import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'react-toastify/dist/ReactToastify.css';
import 'leaflet/dist/leaflet.css';
import ThemeEffects from '../components/ThemeEffects';
import PremiumCarouselTheme from '../components/themes/PremiumCarouselTheme';
import NewDevelopmentTheme from '../components/themes/NewDevelopmentTheme';
import SafeImage from '../components/SafeImage';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import trivanaLogo from '../Assets/Trivana_full_logo.png';
import yelofastLogo from '../Assets/Full Logo Yellow.png';
import bluedartLogo from '../Assets/couriers/bluedart.png';
import delhiveryLogo from '../Assets/couriers/delhivery.png';
import xpressbeesLogo from '../Assets/couriers/xpressbees.png';

const COURIER_PARTNERS_DATA = [
  {
    id: 'xpressbees',
    name: 'Xpressbees',
    tagline: 'Fastest growing express logistics in India',
    description: 'Specialises in providing same/next day delivery, cash on delivery, reverse pickup, and reverse shipping with high reliability.',
    serviceability: '20,000+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: 'Same / Next Day',
    category: 'Air & Surface',
    color: '#f26522',
    logoIcon: '»» XPRESSBEES',
    popular: true
  },
  {
    id: 'delhivery',
    name: 'Delhivery',
    tagline: 'India’s leading express & supply chain giant',
    description: 'Services over 18,000 pin codes across India, offering same/next day delivery and 48-96 hour long-distance express shipments.',
    serviceability: '18,000+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '48 - 96 Hours',
    category: 'Air & Surface',
    color: '#09090b',
    logoIcon: '■ DELHIVERY',
    popular: true
  },
  {
    id: 'ecomexpress',
    name: 'Ecom Express',
    tagline: 'End-to-end pan-India e-commerce logistics',
    description: 'Focuses on delivery capability, scalability, customisation and sustainability across 27,000+ pin codes.',
    serviceability: '27,000+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '24 - 72 Hours',
    category: 'Pan-India Express',
    color: '#be185d',
    logoIcon: '⚡ Ecom Express',
    popular: true
  },
  {
    id: 'bluedart',
    name: 'Blue Dart',
    tagline: 'South Asia’s premier air express courier',
    description: 'South Asia’s premier express air and integrated transportation & distribution company delivering to 35,000+ locations in India.',
    serviceability: '17,000+ pin codes (35,000+ locations)',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: 'Express Air (24-48h)',
    category: 'Air & Surface',
    color: '#004b93',
    logoIcon: 'BLUE DART',
    popular: true
  },
  {
    id: 'dotzot',
    name: 'Dotzot (DTDC)',
    tagline: 'DTDC’s dedicated e-commerce delivery network',
    description: 'DTDC’s division solely for providing shipping services to e-commerce sellers with modern tech and operations.',
    serviceability: '9,900+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '2 - 4 Days',
    category: 'Pan-India Express',
    color: '#334a6e',
    logoIcon: 'DOTZOT',
    popular: false
  },
  {
    id: 'ecomreverse',
    name: 'Ecom Reverse',
    tagline: 'Dedicated 365-day doorstep return pickup',
    description: 'Ensures reverse pick-up and delivery within 24 to 72 hours 365 days a year, including Sundays and holidays.',
    serviceability: '27,000+ pin codes',
    cod: 'No',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '24 - 72 Hours Returns',
    category: 'Reverse Logistics',
    color: '#9f1239',
    logoIcon: '⮌ Ecom Reverse',
    popular: false
  },
  {
    id: 'shadowfax',
    name: 'Shadowfax',
    tagline: 'On-demand hyperlocal & intercity express',
    description: 'Offers pickups, same-day delivery, assured next-day deliveries for intercity, and return order pickups.',
    serviceability: '8,500+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: 'Same Day / Next Day',
    category: 'Hyperlocal & Express',
    color: '#f9570c',
    logoIcon: '◥ shadowfax',
    popular: true
  },
  {
    id: 'aramex',
    name: 'Aramex',
    tagline: 'Global international freight & express courier',
    description: 'Network of 40 independent express companies across 54 countries providing comprehensive global courier services.',
    serviceability: '3,200+ pin codes (54 Countries)',
    cod: 'No',
    tracking: 'Yes',
    international: 'Yes',
    domestic: 'No',
    speed: '3 - 7 Business Days',
    category: 'International',
    color: '#dc2626',
    logoIcon: 'aramex',
    popular: false
  },
  {
    id: 'ekart',
    name: 'Ekart Logistics',
    tagline: 'Flipkart’s premier in-house supply chain',
    description: 'Delivers across 3,800+ pin codes in India, offering both COD and prepaid payment modes with high delivery rate.',
    serviceability: '3,800+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '24 - 48 Hours',
    category: 'Pan-India Express',
    color: '#0066cc',
    logoIcon: 'ekart',
    popular: true
  },
  {
    id: 'borzo',
    name: 'Borzo Delivery (WeFast)',
    tagline: 'Intra-city express delivery within hours',
    description: 'Hyperlocal and intra-city delivery specialist delivering products within hours across a range of 50 km at affordable rates.',
    serviceability: '50 km Hyperlocal Radius',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '1 - 3 Hours (Instant)',
    category: 'Hyperlocal',
    color: '#0066ff',
    logoIcon: 'borzo',
    popular: true
  },
  {
    id: 'dunzo',
    name: 'Dunzo Courier',
    tagline: 'Fastest doorstep intra-city courier service',
    description: 'Popular hyperlocal delivery specialist providing same-day delivery for groceries, medicines, food, and essentials.',
    serviceability: 'Metro Intra-city Coverage',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '30 - 60 Minutes',
    category: 'Hyperlocal',
    color: '#059669',
    logoIcon: '⚡ dunzo',
    popular: true
  },
  {
    id: 'dtdc',
    name: 'DTDC India',
    tagline: 'Handling 12M+ monthly shipments across India',
    description: 'One of the first choice courier brands handling over 12 million shipments every month across domestic and global routes.',
    serviceability: '10,500+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'Yes',
    domestic: 'Yes',
    speed: '2 - 3 Days',
    category: 'Air & Surface',
    color: '#0f172a',
    logoIcon: 'DTDC ■',
    popular: true
  },
  {
    id: 'amazonshipping',
    name: 'Amazon Shipping',
    tagline: 'Reliable 7-day shipping with weekend pickups',
    description: 'Offers extensive reach and highly reliable services at minimum total logistics cost without extra fees for weekends.',
    serviceability: '14,000+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '2 - 4 Days',
    category: 'Pan-India Express',
    color: '#131921',
    logoIcon: 'amazon shipping',
    popular: true
  },
  {
    id: 'kerryindev',
    name: 'Kerry Indev Express',
    tagline: 'Integrated door-to-door multimodal logistics',
    description: 'Door-to-door service with advanced infrastructural facilities, express connectivity, and technology tracking.',
    serviceability: '3,000+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'Yes',
    domestic: 'Yes',
    speed: '3 - 5 Days',
    category: 'Air & Surface',
    color: '#0b4d75',
    logoIcon: 'KERRY INDEV',
    popular: false
  },
  {
    id: 'gati',
    name: 'Gati KWE',
    tagline: 'Pioneers in express distribution & supply chain',
    description: 'Extends network coverage across 735 of India’s 739 districts with high-capacity road and air transportation.',
    serviceability: '19,800+ pin codes (735 Districts)',
    cod: 'No',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '48 - 72 Hours',
    category: 'Pan-India Express',
    color: '#0284c7',
    logoIcon: '✦ GATI',
    popular: true
  },
  {
    id: 'loadshare',
    name: 'Loadshare Networks',
    tagline: 'Delivering 2 Lakh+ parcels per day',
    description: 'New-age logistics expert that focuses on deep reach into Tier 2, 3, and 4 towns with dedicated customer support.',
    serviceability: '10,000+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '2 - 4 Days',
    category: 'Pan-India Express',
    color: '#3b82f6',
    logoIcon: '☊ LOADSHARE',
    popular: false
  },
  {
    id: 'pikndel',
    name: 'Pik N Del',
    tagline: 'On-demand & same-day delivery solutions',
    description: 'Empowers businesses by offering state-of-the-art delivery services like same-day and on-demand deliveries.',
    serviceability: 'Tier 1 & Tier 2 Cities',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: 'Same Day / Next Day',
    category: 'Hyperlocal & Express',
    color: '#0d9488',
    logoIcon: 'PIK N DEL',
    popular: false
  },
  {
    id: 'smartr',
    name: 'Smartr Logistics',
    tagline: 'Fast delivery for time-sensitive shipments',
    description: 'Provides fast delivery services for time-sensitive shipments with efficient operations and 24×7 customer support.',
    serviceability: '2,200+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '24 - 48 Hours',
    category: 'Air & Surface',
    color: '#7c3aed',
    logoIcon: '★ smartr',
    popular: false
  },
  {
    id: 'pidge',
    name: 'Pidge',
    tagline: 'Building the future of smart city logistics',
    description: 'Helps businesses expand their reach, reduce RTO, and improve their customer delivery experience.',
    serviceability: 'City Wide Coverage',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '60 - 120 Minutes',
    category: 'Hyperlocal',
    color: '#4f46e5',
    logoIcon: '◬ pidge',
    popular: false
  },
  {
    id: 'speedpost',
    name: 'Speed Post (India Post)',
    tagline: 'India’s largest national postal network',
    description: 'Delivers with maximum accuracy using Speed Post, a reliable parcel delivery service by India’s largest postal network.',
    serviceability: '19,100+ pin codes (National Reach)',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'Yes',
    domestic: 'Yes',
    speed: '2 - 5 Days',
    category: 'National Postal',
    color: '#c4161c',
    logoIcon: '📮 Speed Post',
    popular: true
  },
  {
    id: 'blitz',
    name: 'Blitz Delivery',
    tagline: 'Same-day eCommerce logistics platform',
    description: 'Same-day delivery platform helping eCommerce businesses and MSMEs accelerate sales and delight customers.',
    serviceability: '27,000+ pin codes',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: 'Same Day Delivery',
    category: 'Hyperlocal & Express',
    color: '#000000',
    logoIcon: '⚡ blitz',
    popular: false
  },
  {
    id: 'yelofast',
    name: 'YeloFast Instant',
    tagline: 'Direct merchant-to-customer 30-45 min delivery',
    description: 'Hyperlocal direct restaurant & merchant express rider delivery powered by YeloFast logistics ecosystem.',
    serviceability: 'Hyperlocal 15 km Radius',
    cod: 'Yes',
    tracking: 'Yes',
    international: 'No',
    domestic: 'Yes',
    speed: '30 - 45 Minutes',
    category: 'Hyperlocal',
    color: '#18181b',
    logoIcon: '📦 YeloFast Instant',
    popular: true
  }
];

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081';
const API_ORIGIN = (() => {
  try {
    return new URL(API_BASE_URL).origin;
  } catch (_error) {
    return API_BASE_URL.replace(/\/+$/, '');
  }
})();
const API_PORT = (() => {
  try {
    return new URL(API_BASE_URL).port || '';
  } catch (_error) {
    return '';
  }
})();

const SESSION_ID_REGEX = /^sess_\d+_[a-z0-9]+$/i;

const createSessionId = () => `sess_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;

const getInitials = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
};

const resolveMediaUrl = (url, suffix = '') => {
  if (!url) {
    return '';
  }

  let raw = String(url).trim();
  if (!raw) {
    return '';
  }

  // Prepend https:// if it looks like an absolute web URL without a protocol
  if (!/^https?:\/\//i.test(raw)) {
    const firstSlashIdx = raw.indexOf('/');
    const hostPart = firstSlashIdx === -1 ? raw : raw.substring(0, firstSlashIdx);
    const isImageExtension = /\.(png|jpg|jpeg|gif|webp|svg)$/i.test(hostPart);
    if (hostPart.includes('.') && 
        !hostPart.startsWith('/') && 
        hostPart !== 'localhost' && 
        !isImageExtension) {
      raw = `https://${raw}`;
    }
  }

  // Convert Google Drive view URLs to direct stream URLs
  if (raw.includes('drive.google.com')) {
    let fileId = '';
    const fileDMatch = raw.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
    if (fileDMatch && fileDMatch[1]) {
      fileId = fileDMatch[1];
    } else {
      const idParamMatch = raw.match(/[?&]id=([a-zA-Z0-9_-]+)/);
      if (idParamMatch && idParamMatch[1]) {
        fileId = idParamMatch[1];
      }
    }
    if (fileId) {
      raw = `https://lh3.googleusercontent.com/d/${fileId}`;
    }
  }

  // Convert Imgur page links to direct image links
  if (raw.includes('imgur.com') && !raw.includes('i.imgur.com')) {
    if (!/\/a\//i.test(raw) && !/\/gallery\//i.test(raw)) {
      const match = raw.match(/imgur\.com\/([a-zA-Z0-9]+)/);
      if (match && match[1]) {
        raw = `https://i.imgur.com/${match[1]}.png`;
      }
    }
  }

  // Apply Google User Content suffix if requested
  if (raw.includes('googleusercontent.com') && suffix) {
    if (!/=[swh0-9-]+$/i.test(raw)) {
      raw = `${raw}${suffix}`;
    }
  }

  if (/^(data:|blob:)/i.test(raw)) {
    return raw;
  }

  try {
    if (/^https?:\/\//i.test(raw)) {
      const parsed = new URL(raw);
      const isLoopback = ['localhost', '127.0.0.1', '::1'].includes(parsed.hostname);

      if (isLoopback && parsed.port && parsed.port !== API_PORT) {
        return `${API_ORIGIN}${parsed.pathname}${parsed.search}`;
      }

      return raw;
    }
  } catch (_error) {
    return '';
  }

  const normalizedPath = raw.startsWith('/') ? raw : `/${raw}`;
  return `${API_ORIGIN}${normalizedPath}`;
};

const isExternalUrl = (url) => {
  if (!url) return false;
  const raw = String(url).trim();
  return /^https?:\/\//i.test(raw) && !raw.includes('localhost') && !raw.includes('127.0.0.1');
};

const getOrCreateSessionId = () => {
  const fallbackSessionId = createSessionId();

  if (typeof window === 'undefined') {
    return fallbackSessionId;
  }

  try {
    let sessionId = window.localStorage.getItem('session_id');

    if (typeof sessionId === 'string') {
      sessionId = sessionId.trim();
    }

    // Keep a strict format so backend/session filters stay deterministic.
    if (!sessionId || !SESSION_ID_REGEX.test(sessionId)) {
      sessionId = fallbackSessionId;
      window.localStorage.setItem('session_id', sessionId);
    }

    return sessionId;
  } catch (_error) {
    return fallbackSessionId;
  }
};

const buildCartStorageKey = (restaurantId, sessionId) => `cart_${restaurantId || 'unknown'}_${sessionId || 'anonymous'}`;

const loadCartFromStorage = (storageKey) => {
  if (typeof window === 'undefined' || !storageKey) {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (_error) {
    return [];
  }
};

const buildLocationStorageKey = (sessionId) => `location_${sessionId || 'anonymous'}`;
const buildCheckoutContactStorageKey = (restaurantId, sessionId) => `checkout_contact_${restaurantId || 'unknown'}_${sessionId || 'anonymous'}`;

const loadLocationFromStorage = (storageKey) => {
  if (typeof window === 'undefined' || !storageKey) {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw);

    const latitude = Number(parsed?.latitude);
    const longitude = Number(parsed?.longitude);
    const accuracyValue = parsed?.accuracy;
    const accuracy = accuracyValue == null ? null : Number(accuracyValue);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      return null;
    }

    return {
      latitude,
      longitude,
      accuracy: Number.isFinite(accuracy) ? accuracy : null,
    };
  } catch (_error) {
    return null;
  }
};

const saveLocationToStorage = (storageKey, { latitude, longitude, accuracy = null }) => {
  if (typeof window === 'undefined' || !storageKey) {
    return;
  }

  if (!Number.isFinite(Number(latitude)) || !Number.isFinite(Number(longitude))) {
    return;
  }

  try {
    window.localStorage.setItem(storageKey, JSON.stringify({
      latitude: Number(latitude),
      longitude: Number(longitude),
      accuracy: accuracy == null ? null : Number(accuracy),
    }));
  } catch (_error) {
    // Ignore storage failures to keep UI functional.
  }
};

const loadCheckoutContactFromStorage = (storageKey) => {
  if (typeof window === 'undefined' || !storageKey) {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(storageKey);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        return parsed;
      }
    }

    // Backward-compatible fallback keys if older versions stored the values separately.
    const legacyPhone = window.localStorage.getItem('customerPhone')
      || window.localStorage.getItem('whatsappNumber')
      || window.localStorage.getItem('phone');
    const legacyName = window.localStorage.getItem('customerName') || window.localStorage.getItem('name');
    const legacyEmail = window.localStorage.getItem('customerEmail') || window.localStorage.getItem('email');

    if (!legacyPhone && !legacyName && !legacyEmail) {
      return null;
    }

    return {
      name: legacyName || '',
      phone: legacyPhone || '',
      email: legacyEmail || ''
    };
  } catch (_error) {
    return null;
  }
};

const saveCheckoutContactToStorage = (storageKey, contact = {}) => {
  if (typeof window === 'undefined' || !storageKey) {
    return;
  }

  try {
    window.localStorage.setItem(storageKey, JSON.stringify({
      name: String(contact?.name || '').trim(),
      phone: String(contact?.phone || '').trim(),
      email: String(contact?.email || '').trim()
    }));
  } catch (_error) {
    // Ignore storage failures to keep UI functional.
  }
};

const getSpicyBadge = (level) => {
  if (!level) return null;
  const l = String(level).trim().toUpperCase();
  if (l === 'MILD' || l === 'LESS_SPICY' || l === '1') {
    return { icon: '🌶️', label: 'Mild', color: '#16a34a', bg: '#f0fdf4' };
  }
  if (l === 'MEDIUM' || l === 'MEDIUM_SPICY' || l === '2') {
    return { icon: '🌶️🌶️', label: 'Medium', color: '#ea580c', bg: '#fff7ed' };
  }
  if (l === 'HOT' || l === 'SPICY' || l === 'HIGH' || l === '3') {
    return { icon: '🌶️🌶️🌶️', label: 'Spicy', color: '#dc2626', bg: '#fef2f2' };
  }
  if (l === 'EXTRA_HOT' || l === 'EXTRA_SPICY' || l === 'VERY_SPICY' || l === '4') {
    return { icon: '🔥🌶️', label: 'Extra Spicy', color: '#991b1b', bg: '#fee2e2' };
  }
  return { icon: '🌶️', label: String(level), color: '#ea580c', bg: '#fff7ed' };
};

const preloadImages = (items = []) => {
  if (typeof window === 'undefined' || !Array.isArray(items) || items.length === 0) {
    return;
  }

  items.forEach((item) => {
    const imageUrl = resolveMediaUrl(item?.imageUrl || item?.image || '', '=s600');
    if (!imageUrl) return;

    const img = new Image();
    img.decoding = 'async';
    if (isExternalUrl(imageUrl)) {
      img.crossOrigin = 'anonymous';
    }
    img.src = imageUrl;
  });
};

const LazyImage = ({ src, alt, index = 0, className, style, placeholderStyle, skeleton = false }) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [loadedSrc, setLoadedSrc] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible || !src) return;

    const delay = Math.min(index * 150, 1200);
    const timer = setTimeout(() => {
      setLoadedSrc(src);
    }, delay);

    return () => clearTimeout(timer);
  }, [isVisible, src, index]);

  if (!loadedSrc) {
    const mergedClassName = skeleton ? `${className || ''} skeleton-shimmer`.trim() : className;
    return <div ref={containerRef} className={mergedClassName} style={placeholderStyle} />;
  }

  return (
    <SafeImage
      ref={containerRef}
      className={className}
      style={style}
      src={loadedSrc}
      alt={alt}
      loading="lazy"
      decoding="async"
      crossOrigin={isExternalUrl(loadedSrc) ? "anonymous" : undefined}
      fallback={
        <div className={className} style={{ ...style, background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', fontSize: '12px' }}>
          Image Unavailable
        </div>
      }
    />
  );
};

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const RecenterMap = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    if (!Array.isArray(center) || center.length !== 2) return;
    const [lat, lng] = center;
    if (typeof lat !== 'number' || typeof lng !== 'number') return;
    map.setView([lat, lng], map.getZoom(), { animate: false });
  }, [map, center?.[0], center?.[1]]);
  return null;
};

const MapClickSelector = ({ onPick }) => {
  useMapEvents({
    click: (event) => {
      const latitude = Number(event?.latlng?.lat);
      const longitude = Number(event?.latlng?.lng);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        return;
      }
      if (typeof onPick === 'function') {
        onPick({ latitude, longitude });
      }
    }
  });

  return null;
};

const EnsureMapReady = ({ center }) => {
  const map = useMap();

  useEffect(() => {
    let frame = requestAnimationFrame(() => {
      map.invalidateSize();
      if (Array.isArray(center) && center.length === 2) {
        map.setView(center, map.getZoom(), { animate: false });
      }
    });

    const t = setTimeout(() => {
      map.invalidateSize();
    }, 240);

    return () => {
      cancelAnimationFrame(frame);
      clearTimeout(t);
    };
  }, [map, center?.[0], center?.[1]]);

  return null;
};

// Template Theme Configurations — enriched with QR template glassmorphism/visual tokens
const TEMPLATE_THEMES = {

  'Normal': {
    gradient: '#f8fafc',
    primaryColor: '#1e293b',
    secondaryColor: '#64748b',
    accentColor: '#c9a96e',
    splashBg: '#fdfbfb',
    glassPanel: 'rgba(255, 255, 255, 0.85)',
    glassPanelBorder: '1px solid rgba(0,0,0,0.06)',
    glassPanelShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    glassCard: 'rgba(255, 255, 255, 0.70)',
    glassCardBorder: '1px solid rgba(255, 255, 255, 0.8)',
    glassCardShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    categoryActiveGrad: 'linear-gradient(135deg, #2b3a4a 0%, #6d8396 100%)',
    categoryActiveShadow: '0 4px 15px rgba(43, 58, 74, 0.35)',
    font: "'Inter', 'Poppins', sans-serif",
    splashTitle: 'Welcome',
    splashSubtitle: 'An Exquisite Dining Experience',
    greeting: 'Our Signature Menu',
    tagline: 'Discover culinary perfection ',
    icon: '',
    headerIcon: '',
    splashDecoColor1: 'rgba(43,58,74,0.15)',
    splashDecoColor2: 'rgba(109,131,150,0.15)',
    isDark: false,
    softShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    mediumShadow: '0 8px 24px rgba(0, 0, 0, 0.10)',
    spacingSm: '8px',
    spacingMd: '16px',
    spacingLg: '24px',
    spacingXl: '32px',
    borderRadius: '16px',
    borderRadiusLg: '24px'
  },
  'Spring': {
    gradient: 'linear-gradient(135deg, #fff0f5 0%, #f0fdf4 50%, #fff7ed 100%)',
    primaryColor: '#fb7185',
    secondaryColor: '#e11d48',
    accentColor: '#f59e0b',
    splashBg: '#fff0f5',
    glassPanel: 'rgba(255, 255, 255, 0.70)',
    glassPanelBorder: '1px solid rgba(251, 113, 133, 0.1)',
    glassPanelShadow: '0 4px 30px rgba(0, 0, 0, 0.05)',
    glassCard: 'rgba(255, 255, 255, 0.60)',
    glassCardBorder: '1px solid rgba(255, 255, 255, 0.8)',
    glassCardShadow: '0 10px 25px -5px rgba(251, 113, 133, 0.15)',
    categoryActiveGrad: 'linear-gradient(135deg, #fb7185 0%, #e11d48 100%)',
    categoryActiveShadow: '0 4px 15px rgba(251, 113, 133, 0.4)',
    font: "'Great Vibes', cursive",
    splashTitle: 'Namaste',
    splashSubtitle: 'Atithi Devo Bhava',
    greeting: 'Fresh Spring Menu',
    tagline: 'Blossoming flavors await you 🌸',
    icon: '🌸',
    headerIcon: '🌱',
    splashDecoColor1: 'rgba(253, 224, 71, 0.3)',
    splashDecoColor2: 'rgba(251, 113, 133, 0.3)',
    isDark: false
  },
  'Summer': {
    gradient: 'linear-gradient(135deg, #fff1eb 0%, #ace0f9 100%)',
    primaryColor: '#ff7b54',
    secondaryColor: '#ffb26b',
    accentColor: '#ffd56b',
    splashBg: '#fff1eb',
    glassPanel: 'rgba(255, 255, 255, 0.80)',
    glassPanelBorder: '1px solid rgba(255, 123, 84, 0.15)',
    glassPanelShadow: '0 4px 30px rgba(255, 123, 84, 0.08)',
    glassCard: 'rgba(255, 255, 255, 0.70)',
    glassCardBorder: '1px solid rgba(255, 255, 255, 0.8)',
    glassCardShadow: '0 10px 25px -5px rgba(255, 123, 84, 0.15)',
    categoryActiveGrad: 'linear-gradient(135deg, #ff7b54 0%, #ffb26b 100%)',
    categoryActiveShadow: '0 4px 15px rgba(255, 123, 84, 0.4)',
    font: "'Pacifico', cursive",
    splashTitle: 'Namaste',
    splashSubtitle: 'Atithi Devo Bhava',
    greeting: 'Summer Delights',
    tagline: 'Cool & refreshing treats ☀️',
    icon: '☀️',
    headerIcon: '☀️',
    splashDecoColor1: 'rgba(255, 213, 107, 0.4)',
    splashDecoColor2: 'rgba(255, 123, 84, 0.3)',
    isDark: false
  },
  'Autumn': {
    gradient: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fed7aa 100%)',
    primaryColor: '#ea580c',
    secondaryColor: '#c2410c',
    accentColor: '#f59e0b',
    splashBg: '#fff7ed',
    glassPanel: 'rgba(255, 255, 255, 0.60)',
    glassPanelBorder: '1px solid rgba(234, 88, 12, 0.2)',
    glassPanelShadow: '0 4px 30px rgba(69, 26, 3, 0.05)',
    glassCard: 'rgba(255, 255, 255, 0.50)',
    glassCardBorder: '1px solid rgba(255, 255, 255, 0.6)',
    glassCardShadow: '0 10px 25px -5px rgba(234, 88, 12, 0.15)',
    categoryActiveGrad: 'linear-gradient(135deg, #ea580c 0%, #c2410c 100%)',
    categoryActiveShadow: '0 4px 15px rgba(234, 88, 12, 0.4)',
    font: "'Great Vibes', cursive",
    splashTitle: 'Namaste',
    splashSubtitle: 'Atithi Devo Bhava',
    greeting: 'Autumn Comfort',
    tagline: 'Golden Flavors of Autumn 🍂',
    icon: '🍂',
    headerIcon: '🍁',
    splashDecoColor1: 'rgba(251, 146, 60, 0.4)',
    splashDecoColor2: 'rgba(253, 224, 71, 0.4)',
    isDark: false
  },
  'Winter': {
    gradient: 'linear-gradient(to bottom, #0f172a 0%, #1e293b 100%)',
    primaryColor: '#38bdf8',
    secondaryColor: '#3b82f6',
    accentColor: '#dbeafe',
    splashBg: '#0f172a',
    glassPanel: 'rgba(30, 41, 59, 0.70)',
    glassPanelBorder: '1px solid rgba(255, 255, 255, 0.1)',
    glassPanelShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
    glassCard: 'rgba(255, 255, 255, 0.05)',
    glassCardBorder: '1px solid rgba(255, 255, 255, 0.05)',
    glassCardShadow: '0 4px 6px rgba(0,0,0,0.1)',
    categoryActiveGrad: 'linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%)',
    categoryActiveShadow: '0 0 15px rgba(14, 165, 233, 0.5)',
    font: "'Dancing Script', cursive",
    splashTitle: 'Welcome',
    splashSubtitle: 'Winter Wonderland',
    greeting: 'Frozen Delights',
    tagline: 'Warm soups & sizzling platters ❄️',
    icon: '❄️',
    headerIcon: '❄️',
    splashDecoColor1: 'rgba(56, 189, 248, 0.2)',
    splashDecoColor2: 'rgba(59, 130, 246, 0.2)',
    isDark: true
  },
  'Christmas': {
    gradient: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
    primaryColor: '#ef4444',
    secondaryColor: '#16a34a',
    accentColor: '#fbbf24',
    splashBg: '#0f2027',
    glassPanel: 'rgba(20, 40, 45, 0.80)',
    glassPanelBorder: '1px solid rgba(239, 68, 68, 0.15)',
    glassPanelShadow: '0 4px 30px rgba(0,0,0,0.15)',
    glassCard: 'rgba(20, 40, 45, 0.65)',
    glassCardBorder: '1px solid rgba(255,255,255,0.1)',
    glassCardShadow: '0 10px 25px -5px rgba(239, 68, 68, 0.15)',
    categoryActiveGrad: 'linear-gradient(135deg, #ef4444 0%, #16a34a 100%)',
    categoryActiveShadow: '0 4px 15px rgba(239, 68, 68, 0.4)',
    font: "'Mountains of Christmas', cursive",
    splashTitle: 'Merry Christmas',
    splashSubtitle: 'Season of Joy',
    greeting: 'Festive Special Menu',
    tagline: 'Celebrate with joy & flavors 🎄',
    icon: '🎄',
    headerIcon: '🎄',
    splashDecoColor1: 'rgba(239, 68, 68, 0.2)',
    splashDecoColor2: 'rgba(22, 163, 74, 0.2)',
    isDark: true
  },
  'Diwali': {
    gradient: 'linear-gradient(135deg, #2b1459 0%, #4c1d95 55%, #7c2d12 100%)',
    primaryColor: '#ffb300',
    secondaryColor: '#ff8f00',
    accentColor: '#ffc107',
    splashBg: '#2b1459',
    glassPanel: 'rgba(43, 20, 89, 0.82)',
    glassPanelBorder: '1px solid rgba(255, 179, 0, 0.15)',
    glassPanelShadow: '0 4px 30px rgba(255, 179, 0, 0.08)',
    glassCard: 'rgba(55, 28, 112, 0.68)',
    glassCardBorder: '1px solid rgba(255, 179, 0, 0.1)',
    glassCardShadow: '0 10px 25px -5px rgba(255, 179, 0, 0.2)',
    categoryActiveGrad: 'linear-gradient(135deg, #ffb300 0%, #ff8f00 100%)',
    categoryActiveShadow: '0 4px 15px rgba(255, 179, 0, 0.4)',
    font: "'Satisfy', cursive",
    splashTitle: 'Happy Diwali',
    splashSubtitle: 'Festival of Lights',
    greeting: 'Diwali Festival Specials',
    tagline: 'Light up your taste buds 🪔',
    icon: '🪔',
    headerIcon: '🪔',
    splashDecoColor1: 'rgba(255, 179, 0, 0.25)',
    splashDecoColor2: 'rgba(255, 143, 0, 0.25)',
    isDark: true
  },
  'Eid': {
    gradient: 'linear-gradient(135deg, #051914 0%, #0b362b 100%)',
    primaryColor: '#95dbb7',
    secondaryColor: '#6bc79b',
    accentColor: '#cdefe0',
    splashBg: '#051914',
    glassPanel: 'rgba(10, 35, 25, 0.80)',
    glassPanelBorder: '1px solid rgba(149, 219, 183, 0.15)',
    glassPanelShadow: '0 4px 30px rgba(0,0,0,0.15)',
    glassCard: 'rgba(10, 35, 25, 0.65)',
    glassCardBorder: '1px solid rgba(149, 219, 183, 0.1)',
    glassCardShadow: '0 10px 25px -5px rgba(149, 219, 183, 0.15)',
    categoryActiveGrad: 'linear-gradient(135deg, #95dbb7 0%, #6bc79b 100%)',
    categoryActiveShadow: '0 4px 15px rgba(149, 219, 183, 0.4)',
    font: "'Amiri', serif",
    splashTitle: 'Eid Mubarak',
    splashSubtitle: 'Celebration of Blessings',
    greeting: 'Eid Special Feast',
    tagline: 'Blessed flavors for you 🌙',
    icon: '🌙',
    headerIcon: '🌙',
    splashDecoColor1: 'rgba(149, 219, 183, 0.2)',
    splashDecoColor2: 'rgba(107, 199, 155, 0.2)',
    isDark: true
  },
  'Holi': {
    gradient: 'radial-gradient(circle at 20% 80%, #fef3c7 0%, #fffbeb 100%)',
    primaryColor: '#ec4899',
    secondaryColor: '#8b5cf6',
    accentColor: '#f59e0b',
    splashBg: '#fffbeb',
    glassPanel: 'rgba(255, 255, 255, 0.85)',
    glassPanelBorder: '2px solid #ec4899',
    glassPanelShadow: '0 4px 20px rgba(236, 72, 153, 0.15)',
    glassCard: 'rgba(255, 255, 255, 0.90)',
    glassCardBorder: '2px solid white',
    glassCardShadow: '0 8px 15px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0,0,0,0.02)',
    categoryActiveGrad: 'linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%)',
    categoryActiveShadow: '0 4px 15px rgba(236, 72, 153, 0.4)',
    font: "'Fredoka One', cursive",
    splashTitle: 'Happy Holi',
    splashSubtitle: 'Festival of Colors',
    greeting: 'Colors of Flavor',
    tagline: 'Taste the rainbow of joy 🎨',
    icon: '🎨',
    headerIcon: '💜',
    splashDecoColor1: 'rgba(236, 72, 153, 0.3)',
    splashDecoColor2: 'rgba(139, 92, 246, 0.3)',
    isDark: false
  },
  'Navratri': {
    gradient: 'linear-gradient(135deg, #2a0845 0%, #6441a5 100%)',
    primaryColor: '#ffbb00',
    secondaryColor: '#ff6a00',
    accentColor: '#ee0979',
    splashBg: '#2a0845',
    glassPanel: 'rgba(40, 15, 60, 0.75)',
    glassPanelBorder: '1px solid rgba(255, 187, 0, 0.15)',
    glassPanelShadow: '0 4px 30px rgba(0,0,0,0.15)',
    glassCard: 'rgba(40, 15, 60, 0.60)',
    glassCardBorder: '1px solid rgba(255, 187, 0, 0.1)',
    glassCardShadow: '0 10px 25px -5px rgba(255, 187, 0, 0.15)',
    categoryActiveGrad: 'linear-gradient(135deg, #ffbb00 0%, #ff6a00 100%)',
    categoryActiveShadow: '0 4px 15px rgba(255, 187, 0, 0.4)',
    font: "'Bebas Neue', cursive",
    splashTitle: 'Navratri',
    splashSubtitle: 'Nine Nights of Celebration',
    greeting: 'Navratri Special',
    tagline: 'Nine nights of divine flavors 🪔',
    icon: '🪔',
    headerIcon: '🪔',
    splashDecoColor1: 'rgba(255, 187, 0, 0.25)',
    splashDecoColor2: 'rgba(238, 9, 121, 0.25)',
    isDark: true
  },
  'Makar Sankranti': {
    gradient: 'linear-gradient(135deg, #1f1c2c 0%, #928dab 100%)',
    primaryColor: '#f3904f',
    secondaryColor: '#e16120',
    accentColor: '#ffb75e',
    splashBg: '#1f1c2c',
    glassPanel: 'rgba(40, 40, 60, 0.75)',
    glassPanelBorder: '1px solid rgba(243, 144, 79, 0.15)',
    glassPanelShadow: '0 4px 30px rgba(0,0,0,0.15)',
    glassCard: 'rgba(40, 40, 60, 0.60)',
    glassCardBorder: '1px solid rgba(243, 144, 79, 0.1)',
    glassCardShadow: '0 10px 25px -5px rgba(243, 144, 79, 0.15)',
    categoryActiveGrad: 'linear-gradient(135deg, #f3904f 0%, #e16120 100%)',
    categoryActiveShadow: '0 4px 15px rgba(243, 144, 79, 0.4)',
    font: "'Righteous', cursive",
    splashTitle: 'Makar Sankranti',
    splashSubtitle: 'Harvest Festival',
    greeting: 'Harvest Celebration',
    tagline: 'Traditional flavors & blessings 🪁',
    icon: '🪁',
    headerIcon: '🪁',
    splashDecoColor1: 'rgba(243, 144, 79, 0.25)',
    splashDecoColor2: 'rgba(255, 183, 94, 0.25)',
    isDark: true
  },
  'Teej': {
    gradient: 'linear-gradient(135deg, #134e2f 0%, #1a6b3c 50%, #2a8750 100%)',
    primaryColor: '#52c97c',
    secondaryColor: '#f9a826',
    accentColor: '#ffd166',
    splashBg: '#134e2f',
    glassPanel: 'rgba(15, 60, 35, 0.80)',
    glassPanelBorder: '1px solid rgba(82, 201, 124, 0.15)',
    glassPanelShadow: '0 4px 30px rgba(0,0,0,0.15)',
    glassCard: 'rgba(15, 60, 35, 0.65)',
    glassCardBorder: '1px solid rgba(82, 201, 124, 0.1)',
    glassCardShadow: '0 10px 25px -5px rgba(82, 201, 124, 0.15)',
    categoryActiveGrad: 'linear-gradient(135deg, #52c97c 0%, #f9a826 100%)',
    categoryActiveShadow: '0 4px 15px rgba(82, 201, 124, 0.4)',
    font: "'Satisfy', cursive",
    splashTitle: 'Teej Mubarak',
    splashSubtitle: 'Monsoon Festival of Rajasthan',
    greeting: 'Teej Special Menu',
    tagline: 'Celebrate the monsoon blessings 🌿',
    icon: '🌿',
    headerIcon: '🌿',
    splashDecoColor1: 'rgba(82, 201, 124, 0.25)',
    splashDecoColor2: 'rgba(249, 168, 38, 0.25)',
    isDark: true
  },
  'Gangaur': {
    gradient: 'linear-gradient(135deg, #6b0f1a 0%, #b91c1c 50%, #fc5c7d 100%)',
    primaryColor: '#fc5c7d',
    secondaryColor: '#fbb034',
    accentColor: '#fff0a5',
    splashBg: '#6b0f1a',
    glassPanel: 'rgba(80, 10, 25, 0.80)',
    glassPanelBorder: '1px solid rgba(252, 92, 125, 0.15)',
    glassPanelShadow: '0 4px 30px rgba(0,0,0,0.15)',
    glassCard: 'rgba(80, 10, 25, 0.65)',
    glassCardBorder: '1px solid rgba(252, 92, 125, 0.1)',
    glassCardShadow: '0 10px 25px -5px rgba(252, 92, 125, 0.15)',
    categoryActiveGrad: 'linear-gradient(135deg, #fc5c7d 0%, #fbb034 100%)',
    categoryActiveShadow: '0 4px 15px rgba(252, 92, 125, 0.4)',
    font: "'Fredoka One', cursive",
    splashTitle: 'Gangaur Utsav',
    splashSubtitle: 'Festival of Devotion & Colors',
    greeting: 'Gangaur Special Thali',
    tagline: 'Vibrant flavors of Rajasthan 🌺',
    icon: '🌺',
    headerIcon: '🌺',
    splashDecoColor1: 'rgba(252, 92, 125, 0.25)',
    splashDecoColor2: 'rgba(251, 176, 52, 0.25)',
    isDark: true
  },
  'Royal Rajasthan': {
    gradient: 'linear-gradient(180deg, #fffaf5 0%, #fff3e8 52%, #fff7ed 100%)',
    primaryColor: '#ea580c',
    secondaryColor: '#f97316',
    accentColor: '#fb923c',
    splashBg: '#ea580c',
    glassPanel: 'rgba(255, 255, 255, 0.86)',
    glassPanelBorder: '1px solid rgba(251, 146, 60, 0.25)',
    glassPanelShadow: '0 8px 24px rgba(234, 88, 12, 0.16)',
    glassCard: 'rgba(255, 255, 255, 0.84)',
    glassCardBorder: '1px solid rgba(251, 146, 60, 0.2)',
    glassCardShadow: '0 10px 25px -5px rgba(234, 88, 12, 0.18)',
    categoryActiveGrad: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
    categoryActiveShadow: '0 4px 15px rgba(249, 115, 22, 0.4)',
    font: "'Poppins', sans-serif",
    splashTitle: 'Namaste',
    splashSubtitle: 'Atithi Devo Bhava',
    greeting: 'Hungry?',
    tagline: 'Explore our delicious menu ',
    icon: '',
    headerIcon: '🧡',
    splashDecoColor1: 'rgba(251, 146, 60, 0.2)',
    splashDecoColor2: 'rgba(234, 88, 12, 0.2)',
    isDark: false
  },
  'Premium Carousel': {
    gradient: '#F8F7F4',
    primaryColor: '#1F2937',
    secondaryColor: '#6B7280',
    accentColor: '#D4A64A',
    splashBg: '#F8F7F4',
    glassPanel: 'rgba(255, 255, 255, 0.92)',
    glassPanelBorder: '1px solid rgba(229, 231, 235, 0.8)',
    glassPanelShadow: '0 -4px 20px rgba(0, 0, 0, 0.06)',
    glassCard: 'rgba(255, 255, 255, 0.95)',
    glassCardBorder: '1px solid rgba(229, 231, 235, 0.6)',
    glassCardShadow: '0 8px 30px rgba(0, 0, 0, 0.06)',
    categoryActiveGrad: 'linear-gradient(135deg, #D4A64A 0%, #B88A3A 100%)',
    categoryActiveShadow: '0 4px 15px rgba(212, 166, 74, 0.35)',
    font: "'Inter', 'Poppins', sans-serif",
    splashTitle: 'Welcome',
    splashSubtitle: 'An Exquisite Dining Experience',
    greeting: 'Our Menu',
    tagline: 'Discover culinary perfection',
    icon: '🎠',
    headerIcon: '',
    splashDecoColor1: 'rgba(212, 166, 74, 0.15)',
    splashDecoColor2: 'rgba(212, 166, 74, 0.08)',
    isDark: false,
    softShadow: '0 4px 16px rgba(0, 0, 0, 0.06)',
    mediumShadow: '0 12px 32px rgba(0, 0, 0, 0.08)',
    spacingSm: '8px',
    spacingMd: '16px',
    spacingLg: '24px',
    spacingXl: '32px',
    borderRadius: '20px',
    borderRadiusLg: '28px'
  },
  'New Theme (Under Development)': {
    gradient: '#0b1120',
    primaryColor: '#0f766e',
    secondaryColor: '#14b8a6',
    accentColor: '#34d399',
    splashBg: '#0b1120',
    glassPanel: 'rgba(15, 23, 42, 0.92)',
    glassPanelBorder: '1px solid rgba(20, 184, 166, 0.2)',
    glassPanelShadow: '0 -4px 20px rgba(0, 0, 0, 0.3)',
    glassCard: 'rgba(15, 23, 42, 0.95)',
    glassCardBorder: '1px solid rgba(255, 255, 255, 0.08)',
    glassCardShadow: '0 8px 30px rgba(0, 0, 0, 0.35)',
    categoryActiveGrad: 'linear-gradient(135deg, #0f766e 0%, #14b8a6 100%)',
    categoryActiveShadow: '0 4px 15px rgba(20, 184, 166, 0.35)',
    font: "'Inter', 'Poppins', sans-serif",
    splashTitle: 'Under Development',
    splashSubtitle: 'New Store Experience',
    greeting: 'New Theme Canvas',
    tagline: 'Custom theme under development',
    icon: '🚀',
    headerIcon: '🚀',
    isDark: true,
    isUnderDevelopment: true,
    borderRadius: '0px',
    borderRadiusLg: '0px'
  },
  'Midnight Luxe': {
    gradient: 'linear-gradient(180deg, #FFFFFF 0%, #FAF9F6 100%)',
    primaryColor: '#16192E',
    secondaryColor: '#D4A373',
    accentColor: '#E5B887',
    splashBg: '#16192E',
    glassPanel: '#FFFFFF',
    glassPanelBorder: '1px solid #E2E8F0',
    glassPanelShadow: '0 4px 20px rgba(22, 25, 46, 0.08)',
    glassCard: '#FFFFFF',
    glassCardBorder: '1px solid #F1F5F9',
    glassCardShadow: '0 4px 16px rgba(0, 0, 0, 0.04)',
    categoryActiveGrad: 'linear-gradient(135deg, #16192E 0%, #283347 100%)',
    categoryActiveShadow: '0 4px 14px rgba(22, 25, 46, 0.25)',
    font: "'Plus Jakarta Sans', sans-serif",
    splashTitle: 'Welcome',
    splashSubtitle: 'Luxury Dining & Shopping Experience',
    greeting: 'Explore Our Catalog',
    tagline: 'Crafted with elegance and precision',
    icon: '✨',
    headerIcon: '✨',
    isDark: false,
    borderRadius: '16px',
    borderRadiusLg: '24px'
  },
  'New Theme (Under Development)': {
    gradient: 'linear-gradient(180deg, #FFFFFF 0%, #FAF9F6 100%)',
    primaryColor: '#16192E',
    secondaryColor: '#D4A373',
    accentColor: '#E5B887',
    splashBg: '#16192E',
    font: "'Plus Jakarta Sans', sans-serif",
    icon: '✨',
    headerIcon: '✨',
    isDark: false
  },
  'New Theme': {
    gradient: 'linear-gradient(180deg, #FFFFFF 0%, #FAF9F6 100%)',
    primaryColor: '#16192E',
    secondaryColor: '#D4A373',
    accentColor: '#E5B887',
    splashBg: '#16192E',
    font: "'Plus Jakarta Sans', sans-serif",
    icon: '✨',
    headerIcon: '✨',
    isDark: false
  }
};

const generateSlug = (name) => {
  if (!name) return 'restaurant';
  return name
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const TemplatedMenuPage = (props) => {
  const params = useParams();
  const history = useHistory();
  const routeRestaurantId = params.restaurantId;
  const routeRestaurantName = params.restaurantName;
  const isShopMode = Boolean(props && props.shopMode);
  // `restaurantId` variable kept for backward compatibility across the file
  const restaurantId = isShopMode
    ? (props.shopId || routeRestaurantId)
    : (props.restaurantId || routeRestaurantId);
  const [sessionId] = useState(() => getOrCreateSessionId());
  const cartStorageKey = buildCartStorageKey(restaurantId, sessionId);
  const locationStorageKey = buildLocationStorageKey(sessionId);
  const checkoutContactStorageKey = buildCheckoutContactStorageKey(restaurantId, sessionId);

  const [restaurant, setRestaurant] = useState(() => {
    if (props && props.initialShop) {
      const init = props.initialShop;
      return {
        restaurantName: init.shopName || init.shop_name || '',
        logoUrl: init.logoUrl || init.logo_url || '',
        bannerUrl: init.bannerUrl || init.banner_url || '',
        promotionalBanner: init.promotionalBanner || init.promotional_banner || null,
        contactPhone: init.contactPhone || init.contact_phone || '',
        contactEmail: init.contactEmail || init.contact_email || '',
        city: init.city || '',
        isCityFixed: Boolean(init.isCityFixed ?? init.is_city_fixed),
        is_city_fixed: Boolean(init.is_city_fixed ?? init.isCityFixed),
        menuTemplate: init.menuTemplate || 'Normal',
        websiteUrl: init.websiteUrl || init.website_url || '',
        instagramUrl: init.instagramUrl || init.instagram_url || '',
        facebookUrl: init.facebookUrl || init.facebook_url || '',
        mapLocation: init.mapLocation || init.map_location || '',
        whatsappNumber: init.whatsappNumber || init.whatsapp_number || '',
        isWebsiteOrderingEnabled: init.isWebsiteOrderingEnabled !== undefined ? Boolean(init.isWebsiteOrderingEnabled) : true,
        orderingDisabledButtonText: init.orderingDisabledButtonText || 'Order on Website',
        orderingDisabledButtonUrl: init.orderingDisabledButtonUrl || '',
        isTemplatesDisabled: Boolean(init.isTemplatesDisabled ?? init.is_templates_disabled),
      };
    }
    return null;
  });
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [cart, setCart] = useState(() => loadCartFromStorage(cartStorageKey));
  const [loading, setLoading] = useState(true);
  const [showSplash, setShowSplash] = useState(true);
  const [themeReady, setThemeReady] = useState(false);
  const [royalLoaderOpened, setRoyalLoaderOpened] = useState(false);
  const [currentView, setCurrentView] = useState('home');
  const [logoLoadError, setLogoLoadError] = useState(false);
  const [fulfillmentType, setFulfillmentType] = useState('DELIVERY');
  const [showOrderTypePopup, setShowOrderTypePopup] = useState(false);
  const [descriptionPopupProduct, setDescriptionPopupProduct] = useState(null);
  const [truncatedDescriptions, setTruncatedDescriptions] = useState(new Set());
  const [showCouriersModal, setShowCouriersModal] = useState(false);
  const [courierSearchTerm, setCourierSearchTerm] = useState('');
  const [courierFilterCategory, setCourierFilterCategory] = useState('All');

  const markDescriptionTruncated = (productId, isTruncated) => {
    setTruncatedDescriptions((prev) => {
      if (prev.has(productId) === isTruncated) return prev;
      const next = new Set(prev);
      if (isTruncated) {
        next.add(productId);
      } else {
        next.delete(productId);
      }
      return next;
    });
  };

  const getOrderTypeStorageKey = () => `sv_order_type_${restaurantId || 'unknown'}`;

  // Load saved order type and show popup on first visit (non-shop mode)
  useEffect(() => {
    if (isShopMode || !restaurantId) return;
    const storageKey = `sv_order_type_${restaurantId}`;
    const saved = localStorage.getItem(storageKey);
    if (saved && ['DELIVERY', 'TAKEAWAY', 'DRIVETHROUGH'].includes(saved)) {
      setFulfillmentType(saved);
    } else {
      setShowOrderTypePopup(true);
    }
  }, [isShopMode, restaurantId]);

  const selectFulfillmentType = (type) => {
    setFulfillmentType(type);
    if (restaurantId) {
      localStorage.setItem(getOrderTypeStorageKey(), type);
    }
    setShowOrderTypePopup(false);
  };

    // Lock order type to DELIVERY for shop mode
    useEffect(() => {
      if (isShopMode && fulfillmentType !== 'DELIVERY') {
        setFulfillmentType('DELIVERY');
      }
    }, [isShopMode, fulfillmentType]);

    // Reset logo load error when shop/restaurant changes
    useEffect(() => {
      setLogoLoadError(false);
    }, [restaurantId]);

    const [inputValue, setLocalitySearchText] = useState('');
    const [selectedLocality, setSelectedLocality] = useState(null);
    const [localities, setAllLocalities] = useState([]);
    const [filteredLocalities, setFilteredLocalities] = useState([]);
    const [loadingLocalities, setLoadingLocalities] = useState(false);
    const [hasFetchedLocalities, setHasFetchedLocalities] = useState(false);
    const [showLocalityDropdown, setShowLocalityDropdown] = useState(false);
    const [processingPayment, setProcessingPayment] = useState(false);
    const [paymentError, setPaymentError] = useState('');
    const [couponCode, setCouponCode] = useState('');
    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [applyingCoupon, setApplyingCoupon] = useState(false);
    const [showCouponList, setShowCouponList] = useState(false);
    const [availableCoupons, setAvailableCoupons] = useState([]);
    const [couponsLoading, setCouponsLoading] = useState(false);
    const [couponsError, setCouponsError] = useState('');
    const quickInstructionChips = ['No tomatoes', 'No chilli', 'No onion or garlic'];
    const [customerLocation, setCustomerLocation] = useState({
      loading: false,
      latitude: null,
      longitude: null,
      accuracy: null,
      error: ''
    });
    const [mapCenterOverride, setMapCenterOverride] = useState(null);
    const [deliverySettings, setDeliverySettings] = useState({
      isDeliveryEnabled: true,
      isSlabPricingEnabled: false,
      minimumOrderAmountForDelivery: 0,
      fallbackDeliveryCharge: 0,
      slabs: []
    });
    const [gstSettings, setGstSettings] = useState({
      isTaxEnabled: true,
      taxPercentage: 5,
      taxName: 'GST'
    });
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
  const [vegOnlyFilter, setVegOnlyFilter] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 767 : false);

  // Addon states
  const [availableAddons, setAvailableAddons] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectionRulesByGroup, setSelectionRulesByGroup] = useState({});
  const [showAddonModal, setShowAddonModal] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [editingCartItemId, setEditingCartItemId] = useState(null);
  const [loadingAddons, setLoadingAddons] = useState(false);
  const [minDisplayPriceByProduct, setMinDisplayPriceByProduct] = useState({});
  const [pendingSpecialInstructions, setPendingSpecialInstructions] = useState('');
  const [editingSpecialRequest, setEditingSpecialRequest] = useState({
    open: false,
    cartItemId: null,
    text: ''
  });

  // Opening hours / restaurant open status
  const [restaurantOpen, setRestaurantOpen] = useState(true);
  const [closedMessage, setClosedMessage] = useState('');

  // Razorpay checkout states
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [showClearCartConfirm, setShowClearCartConfirm] = useState(false);
  const [showOrderConfirmPopup, setShowOrderConfirmPopup] = useState(false);
  const [showNoOnlinePaymentModal, setShowNoOnlinePaymentModal] = useState(false);
  const [onlinePaymentConfigured, setOnlinePaymentConfigured] = useState(true);
  const [checkoutForm, setCheckoutForm] = useState({
    name: '',
    phone: '',
    email: '',
    addressLine: '',
    landmark: '',
    city: '',
    deliveryInstructions: '',
    vehicleColor: '',
    vehicleNumber: ''
  });

  useEffect(() => {
    if (!restaurantId) return;
    let isCancelled = false;
    const checkOnlinePaymentStatus = async () => {
      try {
        const targetId = restaurantId;
        const endpoint = isShopMode
          ? `${API_BASE_URL}/api/vendor/payment/public-config/shop/${targetId}`
          : `${API_BASE_URL}/api/vendor/payment/public-config/restaurant/${targetId}`;
        const res = await axios.get(endpoint, { headers: getPublicRequestHeaders() });
        const cfg = res.data?.data;
        const isConfigured = Boolean(cfg?.configured && cfg?.keyId && /^rzp_(test|live)_[A-Za-z0-9]+$/.test(cfg?.keyId));
        if (!isCancelled) {
          setOnlinePaymentConfigured(isConfigured);
        }
      } catch (_) {
        // Fallback to true, create-order will act as safety net
      }
    };
    checkOnlinePaymentStatus();
    return () => { isCancelled = true; };
  }, [restaurantId, isShopMode]);
  useEffect(() => {
    if (fulfillmentType !== 'DELIVERY' && paymentError) {
      setPaymentError('');
    }
  }, [fulfillmentType, paymentError]);

  const menuGridRef = useRef(null);
  const localityDropdownRef = useRef(null);
  const addressLineRef = useRef(null);
  const localityFetchInFlightRef = useRef(false);
  const fallbackMapCenter = [28.0229, 73.3119];
  const selectedLocalityLatitude = Number(selectedLocality?.latitude);
  const selectedLocalityLongitude = Number(selectedLocality?.longitude);
  const hasSelectedLocalityCoordinates = Number.isFinite(selectedLocalityLatitude) && Number.isFinite(selectedLocalityLongitude);
  const hasMapOverride = Array.isArray(mapCenterOverride)
    && mapCenterOverride.length === 2
    && Number.isFinite(Number(mapCenterOverride[0]))
    && Number.isFinite(Number(mapCenterOverride[1]));
  const mapCenter = hasMapOverride
    ? [Number(mapCenterOverride[0]), Number(mapCenterOverride[1])]
    : hasSelectedLocalityCoordinates
    ? [selectedLocalityLatitude, selectedLocalityLongitude]
    : customerLocation.latitude != null && customerLocation.longitude != null
      ? [customerLocation.latitude, customerLocation.longitude]
      : fallbackMapCenter;

  useEffect(() => {
    const savedCheckoutContact = loadCheckoutContactFromStorage(checkoutContactStorageKey);
    if (!savedCheckoutContact) {
      return;
    }

    setCheckoutForm((prev) => {
      const nextPhone = String(prev.phone || savedCheckoutContact.phone || '').replace(/\D/g, '').slice(0, 10);
      return {
        ...prev,
        name: prev.name || String(savedCheckoutContact.name || '').trim(),
        phone: prev.phone || nextPhone,
        email: prev.email || String(savedCheckoutContact.email || '').trim()
      };
    });
  }, [checkoutContactStorageKey]);

  useEffect(() => {
    const hasAnyContactValue = Boolean(
      String(checkoutForm.name || '').trim()
      || String(checkoutForm.phone || '').trim()
      || String(checkoutForm.email || '').trim()
    );

    if (!hasAnyContactValue) {
      return;
    }

    saveCheckoutContactToStorage(checkoutContactStorageKey, {
      name: checkoutForm.name,
      phone: checkoutForm.phone,
      email: checkoutForm.email
    });
  }, [checkoutContactStorageKey, checkoutForm.name, checkoutForm.phone, checkoutForm.email]);

  useEffect(() => {
    setShowSplash(true);
    setLoadingProgress(0);
    setThemeReady(false);
    setRoyalLoaderOpened(false);
    loadRestaurantData();
  }, [restaurantId, isShopMode]);

  useEffect(() => {
    if (!(showSplash && themeReady)) return;
    const isRoyalTemplate = /royal/i.test(String(restaurant?.menuTemplate || ''));
    if (!isRoyalTemplate) {
      setRoyalLoaderOpened(false);
      return;
    }

    setRoyalLoaderOpened(false);
    const timer = setTimeout(() => {
      setRoyalLoaderOpened(true);
    }, 3500);

    return () => clearTimeout(timer);
  }, [showSplash, themeReady, restaurant?.menuTemplate, restaurantId]);

  // Splash screen progress animation — stays active until data is loaded
  useEffect(() => {
    if (showSplash && themeReady) {
      const isRoyalTemplate = /royal/i.test(String(restaurant?.menuTemplate || ''));
      const progressStep = isRoyalTemplate ? 0.85 : 2;
      const interval = setInterval(() => {
        setLoadingProgress(prev => {
          if (prev >= 100) {
            // Only finish splash if data loading is also complete
            if (!isRoyalTemplate && !loading) {
              clearInterval(interval);
              setTimeout(() => setShowSplash(false), 950);
            }
            return 100;
          }
          return Math.min(100, prev + progressStep);
        });
      }, 30);
      return () => clearInterval(interval);
    }
  }, [showSplash, loading, themeReady, restaurant?.menuTemplate, royalLoaderOpened]);

  // Royal Rajasthan: hide splash only after shutter has opened and data is ready
  useEffect(() => {
    const isRoyalTemplate = /royal/i.test(String(restaurant?.menuTemplate || ''));
    if (!(showSplash && themeReady && isRoyalTemplate && royalLoaderOpened && !loading)) return;

    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1100);

    return () => clearTimeout(timer);
  }, [showSplash, themeReady, restaurant?.menuTemplate, royalLoaderOpened, loading]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Lock page scroll during splash and while addon modal is open.
  useEffect(() => {
    if (showSplash || showAddonModal) {
      document.body.style.overflow = 'hidden';
      if (showSplash) {
        window.scrollTo(0, 0);
      }
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showSplash, showAddonModal]);

  // Debounce search query (300ms) for smart filtering
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 300);

    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  useEffect(() => {
    setCart(loadCartFromStorage(cartStorageKey));
  }, [cartStorageKey]);

  useEffect(() => {
    try {
      window.localStorage.setItem(cartStorageKey, JSON.stringify(cart));
    } catch (_error) {
      // Keep cart state functional even if storage is unavailable.
    }
  }, [cart, cartStorageKey]);

  useEffect(() => {
    if (!appliedCoupon) return;
    setAppliedCoupon(null);
    setCouponCode('');
  }, [cart]);

  useEffect(() => {
    const handleStorage = (event) => {
      if (!event || event.key !== cartStorageKey) return;
      setCart(loadCartFromStorage(cartStorageKey));
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [cartStorageKey]);

  useEffect(() => {
    const storedLocation = loadLocationFromStorage(locationStorageKey);
    if (storedLocation) {
      setCustomerLocation((prev) => ({
        ...prev,
        loading: false,
        error: '',
        latitude: storedLocation.latitude,
        longitude: storedLocation.longitude,
        accuracy: storedLocation.accuracy,
      }));
    } else {
      setCustomerLocation((prev) => ({
        ...prev,
        loading: false,
        latitude: null,
        longitude: null,
        accuracy: null,
      }));
    }
  }, [locationStorageKey]);

  useEffect(() => {
    const handleStorage = (event) => {
      if (!event || event.key !== locationStorageKey) return;
      const storedLocation = loadLocationFromStorage(locationStorageKey);
      if (!storedLocation) return;

      setCustomerLocation((prev) => ({
        ...prev,
        loading: false,
        error: '',
        latitude: storedLocation.latitude,
        longitude: storedLocation.longitude,
        accuracy: storedLocation.accuracy,
      }));
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [locationStorageKey]);

  useEffect(() => {
    if (products.length > 0) {
      preloadImages(products);
    }
  }, [products]);

  const filterLocalities = useCallback((sourceList, query) => {
    const list = Array.isArray(sourceList) ? sourceList : [];
    const safeQuery = String(query || '').trim().toLowerCase();

    if (!safeQuery) {
      return list;
    }

    return list.filter((locality) => {
      const name = String(locality?.localityName || '').toLowerCase();
      const code = String(locality?.localityCode || '').toLowerCase();
      return name.includes(safeQuery) || code.includes(safeQuery);
    });
  }, []);

  const renderHighlightedLocalityText = useCallback((text, query) => {
    const safeText = String(text || '');
    const safeQuery = String(query || '').trim();

    if (!safeText || !safeQuery) {
      return safeText;
    }

    const lowerText = safeText.toLowerCase();
    const lowerQuery = safeQuery.toLowerCase();
    const matchIndex = lowerText.indexOf(lowerQuery);

    if (matchIndex < 0) {
      return safeText;
    }

    const beforeMatch = safeText.slice(0, matchIndex);
    const matchedText = safeText.slice(matchIndex, matchIndex + safeQuery.length);
    const afterMatch = safeText.slice(matchIndex + safeQuery.length);

    return (
      <>
        {beforeMatch}
        <span style={{ backgroundColor: '#fef08a', color: '#111827', borderRadius: '3px', padding: '0 2px' }}>
          {matchedText}
        </span>
        {afterMatch}
      </>
    );
  }, []);

  useEffect(() => {
    setHasFetchedLocalities(false);
    localityFetchInFlightRef.current = false;
    setAllLocalities([]);
    setFilteredLocalities([]);
    setSelectedLocality(null);
    setMapCenterOverride(null);
    setLocalitySearchText('');
    setLoadingLocalities(false);
    setShowLocalityDropdown(false);
  }, [restaurantId]);

  const applyPickedLocation = (latitude, longitude, accuracy = null, options = {}) => {
    const safeLatitude = Number(latitude);
    const safeLongitude = Number(longitude);
    const safeAccuracy = accuracy == null ? null : Number(accuracy);
    const keepLoading = Boolean(options?.keepLoading);

    if (!Number.isFinite(safeLatitude) || !Number.isFinite(safeLongitude)) {
      return;
    }

    setCustomerLocation(prev => ({
      ...prev,
      loading: keepLoading ? prev.loading : false,
      latitude: safeLatitude,
      longitude: safeLongitude,
      accuracy: Number.isFinite(safeAccuracy) ? safeAccuracy : null,
      error: ''
    }));

    setMapCenterOverride([safeLatitude, safeLongitude]);

    saveLocationToStorage(locationStorageKey, {
      latitude: safeLatitude,
      longitude: safeLongitude,
      accuracy: Number.isFinite(safeAccuracy) ? safeAccuracy : null,
    });
  };

  const reverseGeocodeAndAutofillAddress = useCallback(async ({ latitude, longitude }) => {
    const safeLatitude = Number(latitude);
    const safeLongitude = Number(longitude);

    if (!Number.isFinite(safeLatitude) || !Number.isFinite(safeLongitude)) {
      return;
    }

    try {
      const response = await axios.get('https://nominatim.openstreetmap.org/reverse', {
        params: {
          format: 'jsonv2',
          lat: safeLatitude,
          lon: safeLongitude,
          addressdetails: 1,
          zoom: 18
        },
        timeout: 12000
      });

      const address = response?.data?.address || {};
      const displayName = String(response?.data?.display_name || '').trim();

      const uniqueAddressParts = [];
      const pushAddressPart = (value) => {
        const normalized = String(value || '').trim();
        if (!normalized) return;
        if (uniqueAddressParts.some((existing) => existing.toLowerCase() === normalized.toLowerCase())) {
          return;
        }
        uniqueAddressParts.push(normalized);
      };

      pushAddressPart([address?.house_number, address?.house_name].filter(Boolean).join(' ').trim());
      pushAddressPart(address?.building || address?.amenity);
      pushAddressPart(address?.road || address?.pedestrian || address?.footway || address?.residential || address?.path);
      pushAddressPart(address?.neighbourhood || address?.suburb || address?.quarter || address?.hamlet);
      pushAddressPart(address?.city_district || address?.city || address?.town || address?.village);

      const detailedAddressFromFields = uniqueAddressParts.slice(0, 4).join(', ');

      const genericAdminPattern = /(tehsil|district|division|state|country|india|region)/i;
      const displaySegments = displayName
        .split(',')
        .map((segment) => segment.trim())
        .filter(Boolean);

      const fallbackDisplaySegments = displaySegments
        .filter((segment, index) => index === 0 || !genericAdminPattern.test(segment))
        .slice(0, 4);

      let resolvedAddressLine = detailedAddressFromFields || fallbackDisplaySegments.join(', ').trim() || displayName;
      const resolvedLandmark = String(
        address?.amenity
        || address?.building
        || address?.tourism
        || address?.suburb
        || address?.neighbourhood
        || ''
      ).trim();
      const resolvedPincode = String(address?.postcode || '').trim();
      const resolvedCityFromGeocode = String(
        address?.city
        || address?.town
        || address?.village
        || address?.municipality
        || ''
      ).trim();

      const cityCandidates = [
        address?.city,
        address?.town,
        address?.village,
        address?.municipality,
        restaurant?.city,
      ]
        .map((value) => String(value || '').trim().toLowerCase())
        .filter(Boolean);

      const normalizedAddressLine = String(resolvedAddressLine || '').trim().toLowerCase();
      const isVeryGenericAddress =
        !normalizedAddressLine
        || cityCandidates.includes(normalizedAddressLine)
        || (/^[a-z\s]+$/i.test(normalizedAddressLine) && normalizedAddressLine.split(/\s+/).length <= 2 && cityCandidates.some((city) => normalizedAddressLine.includes(city)));

      if (isVeryGenericAddress) {
        const validLocalities = (Array.isArray(localities) ? localities : []).filter((item) => {
          const lat = Number(item?.latitude);
          const lng = Number(item?.longitude);
          return Number.isFinite(lat) && Number.isFinite(lng) && String(item?.localityName || '').trim();
        });

        if (validLocalities.length > 0) {
          const toRadians = (value) => (Number(value) * Math.PI) / 180;
          const distanceInKm = (lat1, lon1, lat2, lon2) => {
            const earthRadiusKm = 6371;
            const dLat = toRadians(lat2 - lat1);
            const dLon = toRadians(lon2 - lon1);
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
              + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2))
              * Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return earthRadiusKm * c;
          };

          const nearest = validLocalities
            .map((item) => ({
              localityName: String(item.localityName || '').trim(),
              localityCode: String(item.localityCode || '').trim(),
              distanceKm: distanceInKm(safeLatitude, safeLongitude, Number(item.latitude), Number(item.longitude)),
            }))
            .sort((a, b) => a.distanceKm - b.distanceKm)[0];

          if (nearest?.localityName) {
            const nearestLabel = nearest.localityCode
              ? `${nearest.localityName} (${nearest.localityCode})`
              : nearest.localityName;
            const cityLabel = String(restaurant?.city || resolvedCityFromGeocode || address?.city || '').trim();
            resolvedAddressLine = [
              `Near ${nearestLabel}`,
              cityLabel,
            ].filter(Boolean).join(', ');
          }
        }
      }

      setCheckoutForm((prev) => ({
        ...prev,
        addressLine: resolvedAddressLine || prev.addressLine,
        landmark: resolvedLandmark || prev.landmark,
        city: (restaurant?.city || '').trim() || resolvedCityFromGeocode || prev.city,
      }));
    } catch (error) {
      console.warn('Reverse geocode failed', error);
      setCustomerLocation((prev) => ({
        ...prev,
        error: prev.error || 'GPS found. Could not auto-fill address, please enter manually.'
      }));
    }
  }, [restaurant?.city, localities]);

  const requestCustomerLocation = () => {
    if (!navigator?.geolocation) {
      setCustomerLocation(prev => ({
        ...prev,
        loading: false,
        error: 'Location not supported on this device/browser. Please enter address manually.'
      }));
      return;
    }

    setCustomerLocation(prev => ({ ...prev, loading: true, error: '' }));
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        applyPickedLocation(
          position.coords.latitude,
          position.coords.longitude,
          Math.round(position.coords.accuracy || 0),
          { keepLoading: true }
        );

        await reverseGeocodeAndAutofillAddress({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });

        setCustomerLocation((prev) => ({
          ...prev,
          loading: false,
        }));
      },
      () => {
        setCustomerLocation(prev => ({
          ...prev,
          loading: false,
          error: 'Location permission denied. Please fill delivery address manually.'
        }));
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 60000
      }
    );
  };

  const handleMapLocationPick = async ({ latitude, longitude }) => {
    setCustomerLocation((prev) => ({
      ...prev,
      loading: true,
      error: ''
    }));

    applyPickedLocation(latitude, longitude, null, { keepLoading: true });

    await reverseGeocodeAndAutofillAddress({ latitude, longitude });

    setCustomerLocation((prev) => ({
      ...prev,
      loading: false,
      error: ''
    }));
  };

  useEffect(() => {
    if (showCheckoutModal) {
      const isFixed = Boolean(restaurant?.isCityFixed ?? restaurant?.is_city_fixed);
      const storeCity = (restaurant?.city || '').trim();
      if (isFixed && storeCity) {
        setCheckoutForm(prev => ({ ...prev, city: storeCity }));
      } else if (storeCity && !checkoutForm.city) {
        setCheckoutForm(prev => ({ ...prev, city: storeCity }));
      }

      const storedLocation = loadLocationFromStorage(locationStorageKey);
      if (storedLocation) {
        setCustomerLocation((prev) => ({
          ...prev,
          loading: false,
          error: '',
          latitude: storedLocation.latitude,
          longitude: storedLocation.longitude,
          accuracy: storedLocation.accuracy,
        }));
      }

      setShowLocalityDropdown(false);
    }
  }, [showCheckoutModal, locationStorageKey, restaurant?.city]);

  useEffect(() => {
    if (currentView !== 'home') return;

    let shouldShow = false;
    if (typeof window !== 'undefined') {
      shouldShow = window.sessionStorage.getItem('showOrderConfirmPopup') === 'true';
      if (shouldShow) {
        window.sessionStorage.removeItem('showOrderConfirmPopup');
      }
    }

    if (!shouldShow) return;

    const timer = window.setTimeout(() => {
      setShowOrderConfirmPopup(true);
    }, 250);

    return () => window.clearTimeout(timer);
  }, [currentView]);

  const loadLocalitiesFromApi = useCallback(async ({ city }) => {
    const safeCity = String(city || '').trim();
    if (!safeCity) return;

    if (hasFetchedLocalities || localityFetchInFlightRef.current) {
      return;
    }

    localityFetchInFlightRef.current = true;
    setLoadingLocalities(true);
    try {
      const token = localStorage.getItem('token');
      const apiKey =
        localStorage.getItem('apiKey') ||
        process.env.REACT_APP_API_KEY ||
        process.env.REACT_APP_YELOFAST_API_KEY ||
        '';

      const headers = {};
      if (token) headers.Authorization = `Bearer ${token}`;
      if (apiKey) {
        headers['x-api-key'] = apiKey;
        headers['api-key'] = apiKey;
      }
      headers['x-session-id'] = sessionId;

      const endpoint = `${API_BASE_URL}/api/localities?city=${encodeURIComponent(safeCity)}`;

      const response = await axios.get(endpoint, { headers });
      const payload = response?.data?.data || response?.data || [];
      const list = Array.isArray(payload) ? payload : [];

      console.log('[LOCALITIES] API response', {
        city: safeCity,
        endpoint,
        totalRows: list.length,
        rawResponse: response?.data
      });

      if (list.length === 0) {
        console.warn('[LOCALITIES] API returned empty list', {
          city: safeCity,
          endpoint,
          rawResponse: response?.data
        });
      }

      setHasFetchedLocalities(true);
      setAllLocalities(list);
      setFilteredLocalities(filterLocalities(list, inputValue));
    } catch (error) {
      console.warn('Failed to fetch localities', error);
      setHasFetchedLocalities(true);
      setAllLocalities([]);
      setFilteredLocalities([]);
    } finally {
      localityFetchInFlightRef.current = false;
      setLoadingLocalities(false);
    }
  }, [filterLocalities, hasFetchedLocalities, sessionId]);

  useEffect(() => {
    const city = (restaurant?.city || checkoutForm.city || '').trim();
    if (!city) return;

    console.log('[LOCALITIES] Initial locality fetch on mount/city update', { city });
    loadLocalitiesFromApi({ city });
  }, [loadLocalitiesFromApi, restaurant?.city, checkoutForm.city]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!localityDropdownRef.current) return;
      if (!localityDropdownRef.current.contains(event.target)) {
        setShowLocalityDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  useEffect(() => {
    const city = (restaurant?.city || checkoutForm.city || '').trim();
    if (!city) return;

    setFilteredLocalities(filterLocalities(localities, inputValue));
  }, [localities, inputValue, checkoutForm.city, filterLocalities, restaurant?.city]);

  const handleSelectLocality = (locality) => {
    setSelectedLocality(locality);
    setLocalitySearchText(locality?.localityName || '');
    setFilteredLocalities(filterLocalities(localities, locality?.localityName || ''));
    setShowLocalityDropdown(false);

    console.log('[LOCALITY] Selected locality from dropdown', {
      localityName: locality?.localityName || null,
      localityCode: locality?.localityCode || null,
      latitude: locality?.latitude ?? null,
      longitude: locality?.longitude ?? null,
    });

    const localityLatitude = Number(locality?.latitude);
    const localityLongitude = Number(locality?.longitude);
    if (Number.isFinite(localityLatitude) && Number.isFinite(localityLongitude)) {
      setMapCenterOverride([localityLatitude, localityLongitude]);
    }
  };

  const loadRestaurantData = async () => {
    try {
      setLoading(true);
      setThemeReady(false);

      const normalizeRestaurantData = (data = {}) => ({
        ...data,
        ownerId: data.ownerId ?? data.owner_id ?? data.vendorId ?? data.vendor_id ?? null,
        vendorId: data.vendorId ?? data.vendor_id ?? data.ownerId ?? data.owner_id ?? null,
        deliverySlabs: Array.isArray(data.deliverySlabs)
          ? data.deliverySlabs
          : Array.isArray(data.delivery_slabs)
            ? data.delivery_slabs
            : [],
        isDeliveryEnabled: data.isDeliveryEnabled ?? data.is_delivery_enabled ?? data.deliveryEnabled ?? null,
        isSlabPricingEnabled: data.isSlabPricingEnabled ?? data.is_slab_pricing_enabled ?? data.slabPricingEnabled ?? null,
        minimumOrderAmountForDelivery: data.minimumOrderAmountForDelivery ?? data.minimum_order_amount_for_delivery ?? data.minimumOrderAmount ?? null,
        fallbackDeliveryCharge: data.fallbackDeliveryCharge ?? data.fallback_delivery_charge ?? data.deliveryCharge ?? null,
        restaurantName: data.restaurantName ?? data.restaurant_name ?? '',
        cuisineType: data.cuisineType ?? data.cuisine_type ?? '',
        logoUrl: data.logoUrl ?? data.logo_url ?? data.logo ?? '',
        contactPhone: data.contactPhone ?? data.contact_phone ?? '',
        contactEmail: data.contactEmail ?? data.contact_email ?? '',
        city: data.city ?? '',
        isCityFixed: Boolean(data.isCityFixed ?? data.is_city_fixed),
        is_city_fixed: Boolean(data.is_city_fixed ?? data.isCityFixed),
        mapLocation: data.mapLocation ?? data.map_location ?? '',
        websiteUrl: data.websiteUrl ?? data.website_url ?? '',
        instagramUrl: data.instagramUrl ?? data.instagram_url ?? '',
        facebookUrl: data.facebookUrl ?? data.facebook_url ?? '',
        whatsappNumber: data.whatsappNumber ?? data.whatsapp_number ?? '',
        country: data.country ?? '',
        countryCode: data.countryCode ?? data.country_code ?? data.whatsappCountryCode ?? data.whatsapp_country_code ?? '+91',
        whatsappCountryCode: data.whatsappCountryCode ?? data.whatsapp_country_code ?? data.countryCode ?? data.country_code ?? '+91',
        menuTemplate: data.menuTemplate ?? data.menu_template ?? ''
      });

      const headers = getPublicRequestHeaders();

      // If running in shop mode, fetch shop endpoints and normalize to restaurant-like shape
      if (isShopMode) {
        const shopResp = await axios.get(`${API_BASE_URL}/api/vendor/shops/${restaurantId}`, { headers });
        const shopPayload = shopResp?.data?.data || shopResp?.data || {};
        console.log('[DEBUG_LOG] shopPayload loaded from backend:', shopPayload);
        const shopData = {
          restaurantName: shopPayload.shopName || shopPayload.shop_name || shopPayload.shopName || '',
          logoUrl: shopPayload.logoUrl || shopPayload.logo_url || shopPayload.logo || '',
          bannerUrl: shopPayload.bannerUrl || shopPayload.banner_url || shopPayload.banner || '',
          promotionalBanner: shopPayload.promotionalBanner || shopPayload.promotional_banner || null,
          contactPhone: shopPayload.contactPhone || shopPayload.contact_phone || shopPayload.whatsappNumber || '',
          contactEmail: shopPayload.contactEmail || shopPayload.contact_email || '',
          city: shopPayload.city || '',
          isCityFixed: Boolean(shopPayload.isCityFixed ?? shopPayload.is_city_fixed),
          is_city_fixed: Boolean(shopPayload.is_city_fixed ?? shopPayload.isCityFixed),
          menuTemplate: shopPayload.menuTemplate || 'Normal',
          ownerId: shopPayload.ownerId || shopPayload.owner_id || null,
          websiteUrl: shopPayload.websiteUrl || shopPayload.website_url || '',
          instagramUrl: shopPayload.instagramUrl || shopPayload.instagram_url || '',
          facebookUrl: shopPayload.facebookUrl || shopPayload.facebook_url || '',
          mapLocation: shopPayload.mapLocation || shopPayload.map_location || '',
          whatsappNumber: shopPayload.whatsappNumber || shopPayload.whatsapp_number || '',
          country: shopPayload.country || '',
          countryCode: shopPayload.countryCode || shopPayload.country_code || shopPayload.whatsappCountryCode || shopPayload.whatsapp_country_code || '+91',
          whatsappCountryCode: shopPayload.whatsappCountryCode || shopPayload.whatsapp_country_code || shopPayload.countryCode || shopPayload.country_code || '+91',
          isDeliveryEnabled: shopPayload.isDeliveryEnabled ?? true,
          isWebsiteOrderingEnabled: shopPayload.isWebsiteOrderingEnabled !== undefined
            ? Boolean(shopPayload.isWebsiteOrderingEnabled)
            : (shopPayload.is_website_ordering_enabled !== undefined
                ? Boolean(shopPayload.is_website_ordering_enabled)
                : true),
          orderingDisabledButtonText: shopPayload.orderingDisabledButtonText
            || shopPayload.ordering_disabled_button_text
            || 'Order on Website',
          orderingDisabledButtonUrl: shopPayload.orderingDisabledButtonUrl
            || shopPayload.ordering_disabled_button_url
            || '',
        };

        if (!shopData.promotionalBanner) {
          try {
            const bResp = await axios.get(`${API_BASE_URL}/api/public/banners/shop/${restaurantId}`, { headers });
            if (bResp?.data?.success && bResp.data.data) {
              shopData.promotionalBanner = bResp.data.data;
            }
          } catch (bErr) {
            // Non-critical
          }
        }

        console.log('[DEBUG_LOG] shopData resolved in state:', shopData);

        // Load products and categories using shop endpoints
        let productsData = [];
        try {
          const prodResp = await axios.get(`${API_BASE_URL}/api/vendor/products/shop/${restaurantId}`, { headers });
          productsData = prodResp?.data?.data || prodResp?.data || [];
        } catch (prodErr) {
          console.warn('Failed to load shop products', prodErr?.message || prodErr);
        }

        const mapped = (Array.isArray(productsData) ? productsData : []).map((it) => {
          const rawVeg = it.isVeg ?? it.is_veg ?? it.isVegetarian ?? it.is_vegetarian;
          const isVegParsed = (rawVeg !== undefined && rawVeg !== null)
            ? (rawVeg === true || rawVeg === 'true' || rawVeg === 1 || rawVeg === '1')
            : (it.itemType || it.item_type ? String(it.itemType || it.item_type).toUpperCase() !== 'NON_VEG' : true);

          const rawBasePrice = Number(it.basePrice ?? it.base_price ?? it.costPrice ?? it.cost_price ?? 0);
          const rawItemPrice = Number(it.price ?? 0);
          const rawDiscountPrice = it.discountPrice != null && it.discountPrice !== '' ? Number(it.discountPrice) : null;
          const rawMrp = Number(it.mrp ?? it.originalPrice ?? it.original_price ?? it.strikePrice ?? it.strike_price ?? it.comparePrice ?? 0);

          let resolvedPrice = rawItemPrice > 0 ? rawItemPrice : rawBasePrice;
          let resolvedDiscountPrice = rawDiscountPrice;
          let resolvedMrp = rawMrp > 0 ? rawMrp : null;

          if (rawBasePrice > 0 && rawItemPrice > 0 && rawBasePrice > rawItemPrice) {
            resolvedPrice = rawBasePrice;
            resolvedDiscountPrice = rawItemPrice;
            resolvedMrp = rawBasePrice;
          } else if (rawBasePrice > 0 && rawDiscountPrice > 0 && rawBasePrice > rawDiscountPrice) {
            resolvedPrice = rawBasePrice;
            resolvedDiscountPrice = rawDiscountPrice;
            resolvedMrp = rawBasePrice;
          } else if (rawMrp > 0 && rawItemPrice > 0 && rawMrp > rawItemPrice) {
            resolvedPrice = rawMrp;
            resolvedDiscountPrice = rawItemPrice;
          } else if (rawDiscountPrice != null && rawDiscountPrice > 0 && rawItemPrice > rawDiscountPrice) {
            resolvedPrice = rawItemPrice;
            resolvedDiscountPrice = rawDiscountPrice;
            resolvedMrp = rawItemPrice;
          }

          const calculatedDiscountPercentage = (resolvedMrp && resolvedDiscountPrice && resolvedMrp > resolvedDiscountPrice)
            ? Math.round(((resolvedMrp - resolvedDiscountPrice) / resolvedMrp) * 100)
            : ((resolvedPrice && resolvedDiscountPrice && resolvedPrice > resolvedDiscountPrice)
              ? Math.round(((resolvedPrice - resolvedDiscountPrice) / resolvedPrice) * 100)
              : null);

          return {
            productId: it.productId || it.product_id || it.id || null,
            productName: it.productName || it.product_name || it.name || '',
            price: resolvedPrice,
            discountPrice: resolvedDiscountPrice,
            discountPercentage: it.discountPercentage ?? it.discount_percentage ?? calculatedDiscountPercentage,
            mrp: resolvedMrp,
            basePrice: rawBasePrice > 0 ? rawBasePrice : null,
            imageUrl: it.imageUrl || it.image_url || it.image || '',
            description: it.description || it.desc || '',
            isVeg: isVegParsed,
            spiceLevel: it.spiceLevel || it.cuisineType || it.cuisine_type || it.spice_level || null,
            foodType: it.foodType || it.food_type || (isVegParsed ? 'VEG' : 'NON_VEG'),
            isActive: (it.isInStock == null && it.isInStock == null)
              ? (it.isActive !== false)
              : (it.isInStock === true || it.isInStock === 1),
            productCategory: it.productCategory ? { categoryId: it.productCategory.productCategoryId || it.productCategory.productCategoryId || it.productCategory.categoryId, categoryName: it.productCategory.categoryName || '' } : { categoryId: null, categoryName: 'Others' },
            __raw: it
          };
        });

        setRestaurant(shopData);
        setProducts(mapped.filter(p => p?.productId != null && p.isActive !== false));

        try {
          const catResp = await axios.get(`${API_BASE_URL}/api/vendor/products/categories/shop/${restaurantId}`, { headers });
          const rawCategories = catResp?.data?.data || catResp?.data || [];
          setCategories((rawCategories || []).filter(c => c?.isActive !== false));
        } catch (catErr) {
          console.warn('Failed to load shop categories', catErr?.message || catErr);
          setCategories([]);
        }

        try {
          await fetchRestaurantOpenStatus();
        } catch (openErr) {
          console.warn('Failed to fetch shop open status initially:', openErr);
        }

        // Load Shop GST / Tax Settings
        const gstMap = shopPayload.gstSettings || {};
        const isTaxEnabled = shopPayload.isTaxEnabled !== undefined 
          ? Boolean(shopPayload.isTaxEnabled) 
          : (gstMap.isTaxEnabled !== false && gstMap.isTaxEnabled !== undefined && gstMap.isTaxEnabled !== null ? Boolean(gstMap.isTaxEnabled) : false);
        const taxPercentage = Number(shopPayload.taxPercentage ?? gstMap.taxPercentage ?? 0);
        const taxName = shopPayload.taxName || gstMap.taxName || 'GST';

        setGstSettings({
          isTaxEnabled,
          taxPercentage,
          taxName
        });

        // Load Shop Delivery Settings
        let deliveryPayload = null;
        try {
          const delResp = await axios.get(`${API_BASE_URL}/api/public/menu/shop/${restaurantId}/delivery-settings`, { headers });
          deliveryPayload = delResp?.data?.data || delResp?.data || null;
        } catch (e) {
          console.warn('Failed to load public shop delivery settings', e);
        }

        if (!deliveryPayload || !Array.isArray(deliveryPayload?.slabs) || deliveryPayload.slabs.length === 0) {
          try {
            const delResp = await axios.get(`${API_BASE_URL}/api/vendor/delivery-settings/shop/${restaurantId}`, { headers });
            deliveryPayload = delResp?.data?.data || delResp?.data || null;
          } catch (e) {
            console.warn('Failed to load vendor shop delivery settings', e);
          }
        }

        if (deliveryPayload) {
          const rawSlabs = Array.isArray(deliveryPayload?.slabs) ? deliveryPayload.slabs : [];
          const normalizedSlabs = rawSlabs
            .filter((slab) => slab?.isActive !== false)
            .map((slab) => ({
              minOrderAmount: Number(slab?.minOrderAmount || 0),
              maxOrderAmount: slab?.maxOrderAmount === null || slab?.maxOrderAmount === undefined
                ? null
                : Number(slab?.maxOrderAmount),
              deliveryCharge: Number(slab?.deliveryCharge || 0),
              slabName: slab?.slabName || ''
            }))
            .sort((a, b) => a.minOrderAmount - b.minOrderAmount);

          setDeliverySettings({
            isDeliveryEnabled: deliveryPayload.isDeliveryEnabled !== false,
            isSlabPricingEnabled: deliveryPayload.isSlabPricingEnabled === true,
            minimumOrderAmountForDelivery: Number(deliveryPayload.minimumOrderAmountForDelivery || 0),
            fallbackDeliveryCharge: Number(deliveryPayload.fallbackDeliveryCharge || 0),
            slabs: normalizedSlabs
          });
        }

        setCheckoutForm((prev) => ({
          ...prev,
          city: (shopData?.city || '').trim() || prev.city
        }));

        setThemeReady(true);
        document.title = `${shopData.restaurantName || 'Shop'} - Products`;
        return;
      }

      // Prefer public menu endpoint because it includes social/contact fields.
      let restaurantResponse = await axios.get(
        `${API_BASE_URL}/api/public/menu/restaurant/${restaurantId}`,
        { headers }
      );

      const restaurantPayload = restaurantResponse?.data?.data || restaurantResponse?.data;
      console.log('[DEBUG_LOG] restaurantPayload loaded from backend:', restaurantPayload);
      const restaurantData = normalizeRestaurantData(restaurantPayload || {});
      console.log('[DEBUG_LOG] restaurantData resolved in state:', restaurantData);

      if (process.env.NODE_ENV !== 'production') {
        console.log('[DELIVERY_SLABS] Restaurant loaded', {
          restaurantId,
          restaurantData
        });
      }

      const loadDeliverySettingsForRestaurant = async () => {
        try {
          const headers = getPublicRequestHeaders();
          let response;
          let fallbackResponse;

          if (isShopMode) {
            response = await axios.get(
              `${API_BASE_URL}/api/public/menu/shop/${restaurantId}/delivery-settings`,
              { headers }
            );
          } else {
            response = await axios.get(
              `${API_BASE_URL}/api/public/menu/restaurant/${restaurantId}/delivery-settings`,
              { headers }
            );
          }

          let payload = response?.data?.data || response?.data || {};

          if (process.env.NODE_ENV !== 'production') {
            console.log('[DELIVERY_SLABS] Public delivery settings response', {
              restaurantId,
              isShopMode,
              payload
            });
          }

          if (!payload || !Array.isArray(payload?.slabs) || payload.slabs.length === 0) {
            try {
              if (isShopMode) {
                fallbackResponse = await axios.get(
                  `${API_BASE_URL}/api/vendor/delivery-settings/shop/${restaurantId}`,
                  { headers }
                );
              } else {
                fallbackResponse = await axios.get(
                  `${API_BASE_URL}/api/vendor/delivery-settings/restaurant/${restaurantId}`,
                  { headers }
                );
              }
              const vendorPayload = fallbackResponse?.data?.data || fallbackResponse?.data || null;
              if (process.env.NODE_ENV !== 'production') {
                console.log('[DELIVERY_SLABS] Vendor delivery settings response', {
                  restaurantId,
                  isShopMode,
                  vendorPayload
                });
              }
              if (vendorPayload) {
                payload = vendorPayload;
              }
            } catch (vendorError) {
              console.warn('Vendor delivery settings fallback failed:', vendorError?.message || vendorError);
            }
          }
          const rawSlabs = Array.isArray(payload?.slabs) ? payload.slabs : [];
          const fallbackFromRestaurant = buildDeliverySettingsFromRestaurant(restaurantData);

          let normalizedSlabs = rawSlabs
            .filter((slab) => slab?.isActive !== false)
            .map((slab) => ({
              minOrderAmount: Number(slab?.minOrderAmount || 0),
              maxOrderAmount: slab?.maxOrderAmount === null || slab?.maxOrderAmount === undefined
                ? null
                : Number(slab?.maxOrderAmount),
              deliveryCharge: Number(slab?.deliveryCharge || 0),
              slabName: slab?.slabName || ''
            }))
            .sort((a, b) => a.minOrderAmount - b.minOrderAmount);

          if (normalizedSlabs.length === 0 && fallbackFromRestaurant?.slabs?.length) {
            normalizedSlabs = fallbackFromRestaurant.slabs;
          }

          const resolvedIsDeliveryEnabled = payload?.isDeliveryEnabled;
          const resolvedIsSlabPricingEnabled = payload?.isSlabPricingEnabled;

          setDeliverySettings({
            isDeliveryEnabled: resolvedIsDeliveryEnabled == null
              ? fallbackFromRestaurant?.isDeliveryEnabled !== false
              : resolvedIsDeliveryEnabled !== false,
            isSlabPricingEnabled: resolvedIsSlabPricingEnabled == null
              ? fallbackFromRestaurant?.isSlabPricingEnabled === true
              : resolvedIsSlabPricingEnabled === true,
            minimumOrderAmountForDelivery: Number(payload?.minimumOrderAmountForDelivery || fallbackFromRestaurant?.minimumOrderAmountForDelivery || 0),
            fallbackDeliveryCharge: Number(payload?.fallbackDeliveryCharge || fallbackFromRestaurant?.fallbackDeliveryCharge || 0),
            slabs: normalizedSlabs
          });

          if (process.env.NODE_ENV !== 'production') {
            console.debug('[DELIVERY_SLABS] Settings loaded', {
              restaurantId,
              isDeliveryEnabled: payload?.isDeliveryEnabled !== false,
              isSlabPricingEnabled: payload?.isSlabPricingEnabled === true,
              slabCount: normalizedSlabs.length,
              slabs: normalizedSlabs
            });
          }
        } catch (error) {
          // Public menu should stay functional even if delivery settings API is unavailable.
          console.warn('Delivery settings not available, using restaurant fallback.', error);
          const fallbackFromRestaurant = buildDeliverySettingsFromRestaurant(restaurantData);
          if (fallbackFromRestaurant) {
            setDeliverySettings(fallbackFromRestaurant);
            return;
          }
          setDeliverySettings({
            isDeliveryEnabled: true,
            isSlabPricingEnabled: false,
            minimumOrderAmountForDelivery: 0,
            fallbackDeliveryCharge: 0,
            slabs: []
          });
        }
      };

      const loadTaxSettingsForRestaurant = async () => {
        try {
          const headers = getPublicRequestHeaders();
          const response = await axios.get(
            `${API_BASE_URL}/api/billing-pos/restaurants/${restaurantId}/tax-settings`,
            { headers }
          );

          const payload = response?.data || {};
          setGstSettings({
            isTaxEnabled: payload?.isTaxEnabled !== false,
            taxPercentage: Number(payload?.taxPercentage ?? 5),
            taxName: payload?.taxName || 'GST'
          });
        } catch (error) {
          // Keep menu functional even if GST settings API fails.
          console.warn('Tax settings not available, using default GST.', error);
          setGstSettings({
            isTaxEnabled: true,
            taxPercentage: 5,
            taxName: 'GST'
          });
        }
      };

      if (restaurantData?.restaurantName || restaurantData?.restaurant_name) {
        if (!restaurantData.promotionalBanner) {
          try {
            const bResp = await axios.get(`${API_BASE_URL}/api/public/banners/restaurant/${routeRestaurantId || restaurantId}`, { headers });
            if (bResp?.data?.success && bResp.data.data) {
              restaurantData.promotionalBanner = bResp.data.data;
            }
          } catch (bErr) {
            // Non-critical
          }
        }
        setRestaurant(restaurantData);
        const restaurantDeliveryFallback = buildDeliverySettingsFromRestaurant(restaurantData);
        if (restaurantDeliveryFallback) {
          setDeliverySettings(restaurantDeliveryFallback);
        }
        setCheckoutForm((prev) => ({
          ...prev,
          city: (restaurantData?.city || '').trim() || prev.city
        }));
        await Promise.all([
          loadDeliverySettingsForRestaurant(),
          loadTaxSettingsForRestaurant()
        ]);
        setThemeReady(true);
        document.title = `${restaurantData.restaurantName} - Menu`;

        if (!isShopMode && routeRestaurantId) {
          const expectedSlug = generateSlug(restaurantData.restaurantName || restaurantData.restaurant_name);
          if (routeRestaurantName !== expectedSlug) {
            history.replace(`/restaurant/${routeRestaurantId}/${expectedSlug}`);
          }
        }
        if (!restaurantData.instagramUrl && !restaurantData.facebookUrl && !restaurantData.websiteUrl && !restaurantData.whatsappNumber) {
          console.warn('Restaurant loaded but social links are empty', restaurantData);
        }

        // Prefer the POS customizations endpoint so the web menu gets the same
        // addons + modifier groups that the desktop POS already shows.
        let productsData = [];
        try {
          const customizationsResp = await axios.get(
            `${API_BASE_URL}/api/billing-pos/restaurants/${restaurantId}/available-items-with-customizations`,
            { headers }
          );
          productsData = Array.isArray(customizationsResp?.data?.items)
            ? customizationsResp.data.items
            : Array.isArray(customizationsResp?.data?.data)
              ? customizationsResp.data.data
              : [];
        } catch (customizationError) {
          console.warn('Failed to load items with customizations, falling back to public menu items:', customizationError?.message || customizationError);

          const itemsResp = await axios.get(
            `${API_BASE_URL}/api/public/menu/restaurant/${restaurantId}/items`,
            { headers }
          );
          productsData = Array.isArray(itemsResp.data) ? itemsResp.data : (itemsResp.data?.data || []);
        }

        // Normalize the menu items into the product shape expected by the UI.
        const mapped = (productsData || []).map((it) => {
          const pid = Number(it.itemId ?? it.item_id ?? it.id ?? 0) || null;
          const catId = it.categoryId ?? it.category_id ?? null;
          const catName = (it.categoryName ?? it.category_name ?? it.category) || 'Others';
          const normalizedAddons = Array.isArray(it.addons) ? it.addons : [];
          const normalizedModifierGroups = Array.isArray(it.modifierGroups) ? it.modifierGroups : [];

          const rawVeg = it.isVeg ?? it.is_veg ?? it.isVegetarian ?? it.is_vegetarian;
          const isVegParsed = (rawVeg !== undefined && rawVeg !== null)
            ? (rawVeg === true || rawVeg === 'true' || rawVeg === 1 || rawVeg === '1')
            : (it.itemType || it.item_type ? String(it.itemType || it.item_type).toUpperCase() !== 'NON_VEG' : true);

          const rawBasePrice = Number(it.basePrice ?? it.base_price ?? it.costPrice ?? it.cost_price ?? 0);
          const rawItemPrice = Number(it.price ?? 0);
          const rawDiscountPrice = it.discountPrice != null && it.discountPrice !== '' ? Number(it.discountPrice) : null;
          const rawMrp = Number(it.mrp ?? it.originalPrice ?? it.original_price ?? it.strikePrice ?? it.strike_price ?? it.comparePrice ?? 0);

          let resolvedPrice = rawItemPrice > 0 ? rawItemPrice : rawBasePrice;
          let resolvedDiscountPrice = rawDiscountPrice;
          let resolvedMrp = rawMrp > 0 ? rawMrp : null;

          if (rawBasePrice > 0 && rawItemPrice > 0 && rawBasePrice > rawItemPrice) {
            resolvedPrice = rawBasePrice;
            resolvedDiscountPrice = rawItemPrice;
            resolvedMrp = rawBasePrice;
          } else if (rawBasePrice > 0 && rawDiscountPrice > 0 && rawBasePrice > rawDiscountPrice) {
            resolvedPrice = rawBasePrice;
            resolvedDiscountPrice = rawDiscountPrice;
            resolvedMrp = rawBasePrice;
          } else if (rawMrp > 0 && rawItemPrice > 0 && rawMrp > rawItemPrice) {
            resolvedPrice = rawMrp;
            resolvedDiscountPrice = rawItemPrice;
          } else if (rawDiscountPrice != null && rawDiscountPrice > 0 && rawItemPrice > rawDiscountPrice) {
            resolvedPrice = rawItemPrice;
            resolvedDiscountPrice = rawDiscountPrice;
            resolvedMrp = rawItemPrice;
          }

          const calculatedDiscountPercentage = (resolvedMrp && resolvedDiscountPrice && resolvedMrp > resolvedDiscountPrice)
            ? Math.round(((resolvedMrp - resolvedDiscountPrice) / resolvedMrp) * 100)
            : ((resolvedPrice && resolvedDiscountPrice && resolvedPrice > resolvedDiscountPrice)
              ? Math.round(((resolvedPrice - resolvedDiscountPrice) / resolvedPrice) * 100)
              : null);

          return {
            productId: pid,
            productName: String(it.itemName || it.item_name || it.name || '').trim(),
            price: resolvedPrice,
            discountPrice: resolvedDiscountPrice,
            discountPercentage: it.discountPercentage ?? it.discount_percentage ?? calculatedDiscountPercentage,
            mrp: resolvedMrp,
            basePrice: rawBasePrice > 0 ? rawBasePrice : null,
            imageUrl: it.imageUrl ?? it.image_url ?? it.image ?? '',
            description: it.description ?? it.desc ?? '',
            isVeg: isVegParsed,
            spiceLevel: it.spiceLevel || it.cuisineType || it.cuisine_type || it.spice_level || null,
            foodType: it.foodType || it.food_type || (isVegParsed ? 'VEG' : 'NON_VEG'),
            isActive: (it.isAvailable == null && it.is_available == null)
              ? true
              : (it.isAvailable === true || it.isAvailable === 1 || it.is_available === true || it.is_available === 1),
            productCategory: {
              categoryId: catId,
              categoryName: String(catName || 'Others')
            },
            addons: normalizedAddons,
            modifierGroups: normalizedModifierGroups,
            categoryIsMrp: Boolean(it.categoryIsMrp ?? it.category_is_mrp ?? it.isMrp ?? it.is_mrp ?? false),
            // preserve raw payload for debugging if needed
            __raw: it
          };
        });

        const activeProducts = mapped.filter((p) => p?.isActive !== false && p.productId != null);
        setProducts(activeProducts);
        loadMinimumDisplayPrices(activeProducts);

        const catResp = await axios.get(
          `${API_BASE_URL}/api/public/menu/restaurant/${restaurantId}/categories`,
          { headers }
        );
        const rawCategories = Array.isArray(catResp.data) ? catResp.data : (catResp.data?.data || []);

        setCategories((rawCategories || []).filter((c) => c?.isActive !== false));

        await fetchRestaurantOpenStatus();

      } else {
        setThemeReady(true);
        toast.error('Restaurant not found');
      }
    } catch (error) {
      console.error('Error loading restaurant:', error);
      setThemeReady(true);
      toast.error('Failed to load restaurant details');
    } finally {
      setLoading(false);
    }
  };

  const getPublicRequestHeaders = useCallback(() => {
    const token = localStorage.getItem('token');
    const apiKey =
      localStorage.getItem('apiKey') ||
      process.env.REACT_APP_API_KEY ||
      process.env.REACT_APP_YELOFAST_API_KEY ||
      '';

    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    if (apiKey) {
      headers['x-api-key'] = apiKey;
      headers['api-key'] = apiKey;
    }
    headers['x-session-id'] = sessionId;
    return headers;
  }, [sessionId]);

  const fetchRestaurantOpenStatus = useCallback(async () => {
    try {
      const headers = getPublicRequestHeaders();
      const entityType = isShopMode ? 'shop' : 'restaurant';
      const openResponse = await axios.get(
        `${API_BASE_URL}/api/vendor/opening-hours/${entityType}/${restaurantId}/is-open`,
        { headers }
      );

      if (openResponse?.data?.success) {
        const status = openResponse?.data?.data || {};
        const isOpenNow = Boolean(status?.isOpen);

        setRestaurantOpen(isOpenNow);
        if (isOpenNow) {
          setClosedMessage('');
        } else {
          setClosedMessage(status?.message || (isShopMode ? 'Shop is currently closed' : 'Restaurant is currently closed'));
        }
      }
    } catch (openErr) {
      // If check fails, don't block orders
      console.warn('Could not check opening hours:', openErr);
    }
  }, [restaurantId, isShopMode, getPublicRequestHeaders]);

  useEffect(() => {
    if (!restaurantId) {
      return undefined;
    }

    let isDisposed = false;

    const refreshStatus = async () => {
      if (isDisposed) return;
      await fetchRestaurantOpenStatus();
    };

    const intervalId = window.setInterval(() => {
      refreshStatus();
    }, 30000);

    const handleFocus = () => {
      refreshStatus();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refreshStatus();
      }
    };

    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      isDisposed = true;
      window.clearInterval(intervalId);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [restaurantId, fetchRestaurantOpenStatus]);

  const getBaseProductPrice = (product) => Number(product?.discountPrice ?? product?.price ?? 0);

  const calculateMinimumRequiredModifiersTotal = (groups) => {
    return (groups || []).reduce((sum, group) => {
      const minSelection = Number(group?.minSelection || 0);
      const isRequired = !!group?.isRequired || minSelection > 0;
      if (!isRequired || minSelection <= 0) {
        return sum;
      }

      const sortedOptionPrices = (group?.options || [])
        .map((option) => Number(option?.optionPrice || 0))
        .filter((price) => !Number.isNaN(price))
        .sort((a, b) => a - b);

      if (sortedOptionPrices.length < minSelection) {
        return sum;
      }

      const groupMinimum = sortedOptionPrices
        .slice(0, minSelection)
        .reduce((acc, price) => acc + price, 0);

      return sum + groupMinimum;
    }, 0);
  };

  const calculateMinimumModifierOptionTotal = (groups) => {
    return (groups || []).reduce((sum, group) => {
      const optionPrices = (group?.options || [])
        .map((option) => Number(option?.optionPrice || 0))
        .filter((price) => !Number.isNaN(price));

      if (optionPrices.length === 0) {
        return sum;
      }

      return sum + Math.min(...optionPrices);
    }, 0);
  };

  const loadMinimumDisplayPrices = async (productList) => {
    if (!Array.isArray(productList) || productList.length === 0) {
      setMinDisplayPriceByProduct({});
      return;
    }

    const headers = getPublicRequestHeaders();
    const nextMap = {};

    await Promise.all(productList.map(async (product) => {
      const productId = product?.productId;
      if (!productId) return;

      const basePrice = getBaseProductPrice(product);
      if (basePrice > 0) {
        nextMap[productId] = { price: basePrice, estimatedFromModifiers: false };
        return;
      }

      try {
        const groups = Array.isArray(product?.modifierGroups) ? product.modifierGroups : [];
        const minRequiredTotal = calculateMinimumRequiredModifiersTotal(groups);
        const minOptionTotal = calculateMinimumModifierOptionTotal(groups);
        const estimatedPrice = Number(basePrice || 0) + Number(minRequiredTotal || minOptionTotal || 0);

        nextMap[productId] = {
          price: estimatedPrice,
          estimatedFromModifiers: Number(minRequiredTotal || minOptionTotal || 0) > 0
        };
      } catch (error) {
        nextMap[productId] = { price: Number(basePrice || 0), estimatedFromModifiers: false };
      }
    }));

    setMinDisplayPriceByProduct(nextMap);
  };

  const getProductDisplayPriceMeta = (product) => {
    const productId = product?.productId;
    const basePrice = getBaseProductPrice(product);
    const cached = productId ? minDisplayPriceByProduct?.[productId] : null;
    if (cached) return cached;

    if (basePrice <= 0) {
      const groups = Array.isArray(product?.modifierGroups) ? product.modifierGroups : [];
      const minRequiredTotal = calculateMinimumRequiredModifiersTotal(groups);
      const minOptionTotal = calculateMinimumModifierOptionTotal(groups);
      const estimatedTotal = Number(minRequiredTotal || minOptionTotal || 0);

      return {
        price: Number(basePrice || 0) + estimatedTotal,
        estimatedFromModifiers: estimatedTotal > 0
      };
    }

    return { price: basePrice, estimatedFromModifiers: false };
  };

  // Fetch active addons for a product
  const fetchAddons = async (productOrId) => {
    try {
      setLoadingAddons(true);
      const headers = getPublicRequestHeaders();
      const requestedProductId = Number(
        typeof productOrId === 'object'
          ? (productOrId?.productId ?? productOrId?.itemId ?? productOrId?.id)
          : productOrId
      ) || null;

      if (typeof productOrId === 'object') {
        const embeddedAddons = Array.isArray(productOrId?.addons) ? productOrId.addons : [];
        const embeddedModifierGroups = Array.isArray(productOrId?.modifierGroups) ? productOrId.modifierGroups : [];

        if (embeddedAddons.length > 0 || embeddedModifierGroups.length > 0) {
          return applyProductCustomizations(productOrId);
        }
      }

      try {
        const catalogResponse = await axios.get(
          `${API_BASE_URL}/api/billing-pos/restaurants/${restaurantId}/available-items-with-customizations`,
          { headers }
        );
        const items = Array.isArray(catalogResponse?.data?.items)
          ? catalogResponse.data.items
          : Array.isArray(catalogResponse?.data?.data)
            ? catalogResponse.data.data
            : [];

        const matchedItem = items.find((item) => Number(item?.itemId ?? item?.item_id ?? item?.id) === requestedProductId) || null;
        if (matchedItem) {
          return applyProductCustomizations({
            ...matchedItem,
            productId: requestedProductId,
            addons: Array.isArray(matchedItem.addons) ? matchedItem.addons : [],
            modifierGroups: Array.isArray(matchedItem.modifierGroups) ? matchedItem.modifierGroups : []
          });
        }

        setAvailableAddons([]);
        setSelectionRulesByGroup({});
        return [];
      } catch (catalogError) {
        console.warn('POS customization catalog failed for product:', requestedProductId, catalogError?.message || catalogError);
        setAvailableAddons([]);
        setSelectionRulesByGroup({});
        return [];
      }
    } catch (error) {
      console.error('Error fetching addons:', error);
      setAvailableAddons([]);
      setSelectionRulesByGroup({});
      return [];
    } finally {
      setLoadingAddons(false);
    }
  };

  // Helper: Get price for current order type (DINE_IN, DELIVERY, TAKEAWAY, DRIVETHROUGH)
  const getPriceForOrderType = (basePrice, orderTypePrices) => {
    if (!Array.isArray(orderTypePrices) || orderTypePrices.length === 0) {
      return Number(basePrice ?? 0);
    }

    // Map frontend fulfillmentType to backend order type names
    const orderTypeMap = {
      'DELIVERY': 'DELIVERY',
      'TAKEAWAY': 'TAKEAWAY',
      'DRIVETHROUGH': 'DRIVETHROUGH',
      'DINEIN': 'DINE_IN',
      'DINE_IN': 'DINE_IN'
    };

    const currentOrderType = orderTypeMap[fulfillmentType] || fulfillmentType;

    // Find matching price for current order type
    const matchingPrice = orderTypePrices.find(
      p => p.orderType === currentOrderType && p.isActive
    );

    if (matchingPrice && matchingPrice.price != null) {
      return Number(matchingPrice.price);
    }

    return Number(basePrice ?? 0);
  };

  const isProductAvailableForOrderType = (product, type) => {
    if (!product) return false;
    if (product.isActive === false) return false;

    const rawItem = product.__raw || {};
    const orderTypePrices = Array.isArray(rawItem.orderTypePrices)
      ? rawItem.orderTypePrices
      : Array.isArray(rawItem.order_type_prices)
        ? rawItem.order_type_prices
        : [];

    if (orderTypePrices.length > 0) {
      const orderTypeMap = {
        'DELIVERY': 'DELIVERY',
        'TAKEAWAY': 'TAKEAWAY',
        'DRIVETHROUGH': 'DRIVETHROUGH',
        'DINEIN': 'DINE_IN',
        'DINE_IN': 'DINE_IN'
      };

      const currentOrderType = orderTypeMap[type] || type;

      const match = orderTypePrices.find(entry => {
        const entryOrderType = String(entry?.orderType ?? entry?.order_type ?? entry?.type ?? '')
          .trim()
          .replace(/[-\s]+/g, '_')
          .toUpperCase();
        const targetOrderType = String(currentOrderType)
          .trim()
          .replace(/[-\s]+/g, '_')
          .toUpperCase();
        return entryOrderType === targetOrderType;
      });

      if (match && (match.isActive === false || match.is_active === false)) {
        return false;
      }
    }
    return true;
  };

  // Recalculate cart addon prices when order type changes
  useEffect(() => {
    if (cart.length === 0) return;

    const updatedCart = cart.map(cartItem => {
      // Skip if no addons
      if (!Array.isArray(cartItem.selectedAddons) || cartItem.selectedAddons.length === 0) {
        return cartItem;
      }

      // Recalculate addon prices based on new order type
      const updatedAddons = cartItem.selectedAddons.map(addon => {
        if (!addon.orderTypePrices || addon.orderTypePrices.length === 0) {
          return addon; // No order type pricing available
        }

        const newPrice = getPriceForOrderType(addon.basePrice || addon.addonPrice, addon.orderTypePrices);

        return {
          ...addon,
          addonPrice: newPrice
        };
      });

      return {
        ...cartItem,
        selectedAddons: updatedAddons
      };
    });

    // Only update if prices actually changed
    const pricesChanged = updatedCart.some((item, idx) => {
      const oldItem = cart[idx];
      if (!oldItem.selectedAddons || !item.selectedAddons) return false;

      return item.selectedAddons.some((addon, addonIdx) => {
        const oldAddon = oldItem.selectedAddons[addonIdx];
        return oldAddon && addon.addonPrice !== oldAddon.addonPrice;
      });
    });

    if (pricesChanged) {
      setCart(updatedCart);
      try {
        window.localStorage.setItem(cartStorageKey, JSON.stringify(updatedCart));
      } catch (_error) {
        // Silently fail if localStorage is unavailable
      }
    }
  }, [fulfillmentType]);

  const applyProductCustomizations = (product) => {
    const productAddons = Array.isArray(product?.addons) ? product.addons : [];
    const productModifierGroups = Array.isArray(product?.modifierGroups) ? product.modifierGroups : [];

    const flattenedAddons = [];
    const nextRules = {};

    productAddons.forEach((addon) => {
      const basePrice = Number(addon?.addonPrice ?? addon?.price ?? 0);
      const finalPrice = getPriceForOrderType(basePrice, addon?.orderTypePrices);

      flattenedAddons.push({
        addonId: addon?.addonId ?? addon?.id ?? null,
        addonName: addon?.addonName ?? addon?.name ?? '',
        addonPrice: finalPrice,
        basePrice: basePrice,
        orderTypePrices: addon?.orderTypePrices || [],
        optionId: null,
        legacyAddonId: addon?.legacyAddonId ?? addon?.addonId ?? addon?.id ?? null,
        groupId: 'legacy-default',
        groupName: 'Add-ons',
        groupDisplayOrder: Number(addon?.displayOrder ?? 9999)
      });
    });

    productModifierGroups.forEach((group) => {
      const groupId = String(group?.groupId || `group-${group?.groupName || 'addons'}`);
      nextRules[groupId] = {
        groupName: group?.groupName || 'Add-ons',
        isRequired: !!group?.isRequired,
        minSelection: Number(group?.minSelection || 0),
        maxSelection: Number(group?.maxSelection || 99),
        displayOrder: Number(group?.displayOrder ?? 9999),
        dependsOnGroupId: group?.dependsOnGroupId != null ? String(group.dependsOnGroupId) : null,
        dependsOnGroupName: group?.dependsOnGroupName || null,
        dynamicLabel: !!group?.dynamicLabel
      };

      (Array.isArray(group?.options) ? group.options : []).forEach((option) => {
        const basePrice = Number(option?.optionPrice || 0);
        const finalPrice = getPriceForOrderType(basePrice, option?.orderTypePrices);

        flattenedAddons.push({
          addonId: option?.legacyAddonId || option?.optionId,
          addonName: option?.optionName,
          addonPrice: finalPrice,
          basePrice: basePrice,
          orderTypePrices: option?.orderTypePrices || [],
          optionId: option?.optionId || null,
          legacyAddonId: option?.legacyAddonId || null,
          contextKey: option?.contextKey || null,
          groupId,
          groupName: group?.groupName || 'Add-ons',
          groupDisplayOrder: Number(group?.displayOrder ?? 9999)
        });
      });
    });

    setSelectionRulesByGroup(nextRules);
    setAvailableAddons(flattenedAddons);
    return flattenedAddons;
  };

  // Show addon selection modal
  const closeAddonModal = () => {
    setShowAddonModal(false);
    setSelectedAddons([]);
    setCurrentProduct(null);
    setPendingSpecialInstructions('');
    setEditingCartItemId(null);
  };

  const openAddonModalWithProduct = async (product, preselectedAddons = [], specialInstructions = '', editCartItemId = null) => {
    if (restaurant?.isWebsiteOrderingEnabled === false) {
      handleOrderOnWebsiteRedirect();
      return;
    }

    if (isShopMode) {
      mergeOrAddToCart(product, [], '');
      return;
    }

    setCurrentProduct(product);
    setPendingSpecialInstructions(String(specialInstructions || '').trim());
    setSelectedAddons(Array.isArray(preselectedAddons) ? preselectedAddons : []);
    setEditingCartItemId(editCartItemId);

    const hasEmbeddedCustomizations =
      (Array.isArray(product?.addons) && product.addons.length > 0) ||
      (Array.isArray(product?.modifierGroups) && product.modifierGroups.length > 0);

    if (hasEmbeddedCustomizations) {
      applyProductCustomizations(product);
      setShowAddonModal(true);
      return;
    }

    const fetchedAddons = await fetchAddons(product);
    const hasAddons = Array.isArray(fetchedAddons) && fetchedAddons.length > 0;

    if (hasAddons) {
      setShowAddonModal(true);
      return;
    }

    if (editCartItemId) {
      setShowAddonModal(false);
      setCurrentProduct(null);
      setPendingSpecialInstructions('');
      setEditingCartItemId(null);
      return;
    }

    mergeOrAddToCart(product, [], '');
    setCurrentProduct(null);
  };

  const showAddonSelectionModal = async (product) => {
    await openAddonModalWithProduct(product, [], '', null);
  };

  const openCartItemAddonModal = async (item) => {
    if (!item || !Array.isArray(item.selectedAddons) || item.selectedAddons.length === 0) {
      return;
    }

    await openAddonModalWithProduct(
      item,
      item.selectedAddons,
      item.specialInstructions || '',
      item.cartItemId || null
    );
  };

  // Toggle addon selection
  const normalizeContextKey = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');

  const buildParentContextKeys = (parentOption) => {
    if (!parentOption) return new Set();
    const optionId = parentOption?.optionId || parentOption?.legacyAddonId || parentOption?.addonId;
    const rawKeys = [
      optionId ? `optionid:${optionId}` : null,
      optionId ? `id:${optionId}` : null,
      optionId ? `${optionId}` : null,
      parentOption?.addonName || parentOption?.optionName || null
    ].filter(Boolean);

    return new Set(rawKeys.map((key) => normalizeContextKey(key)).filter(Boolean));
  };

  const matchesDependentContext = (addon, parentOption) => {
    const contextKey = normalizeContextKey(addon?.contextKey);
    if (!contextKey) return true;
    if (!parentOption) return false;
    return buildParentContextKeys(parentOption).has(contextKey);
  };

  const normalizeAddonSelections = (selections) => {
    let nextSelections = [...(selections || [])];

    for (let guard = 0; guard < 6; guard += 1) {
      const groupedSelections = nextSelections.reduce((acc, item) => {
        const key = String(item?.groupId || 'default');
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});

      const keepLastInGroup = {};
      Object.entries(groupedSelections).forEach(([groupId, items]) => {
        const rule = selectionRulesByGroup?.[groupId];
        if (Number(rule?.maxSelection || 99) === 1 && items.length > 0) {
          keepLastInGroup[groupId] = items[items.length - 1];
        }
      });

      const filteredSelections = nextSelections.filter((item) => {
        const groupId = String(item?.groupId || 'default');
        const rule = selectionRulesByGroup?.[groupId];

        if (keepLastInGroup[groupId] && keepLastInGroup[groupId] !== item) {
          return false;
        }

        const dependsOnGroupId = rule?.dependsOnGroupId;
        if (!dependsOnGroupId) {
          return true;
        }

        const parentOption = groupedSelections[String(dependsOnGroupId)]?.[0] || null;
        return matchesDependentContext(item, parentOption);
      });

      if (
        filteredSelections.length === nextSelections.length &&
        filteredSelections.every((item, index) => item === nextSelections[index])
      ) {
        break;
      }

      nextSelections = filteredSelections;
    }

    return nextSelections;
  };

  const getAddonSelectionSignature = (selections) => {
    return (selections || [])
      .map((item) => `${String(item?.groupId || 'default')}:${String(item?.addonId || item?.optionId || item?.legacyAddonId || item?.addonName || '')}`)
      .join('|');
  };

  const getSelectionText = (min, max) => {
    const safeMin = Number(min || 0);
    const safeMax = Number(max || 0);

    if (safeMin === 0 && safeMax === 0) return '';
    if (safeMin === 1 && safeMax === 1) return 'Select any one';
    if (safeMin === 1 && safeMax > 1) return `Select at least 1 (up to ${safeMax})`;
    if (safeMin > 1 && safeMax > 1) return `Select at least ${safeMin} (up to ${safeMax})`;
    if (safeMin >= 1 && safeMax === 0) return `Select at least ${safeMin}`;
    if (safeMin === 0 && safeMax > 0) return `Select up to ${safeMax}`;
    return '';
  };

  const getAddonIdentityKey = (addon) => String(
    addon?.optionId
    || addon?.legacyAddonId
    || addon?.addonId
    || addon?.addonName
    || ''
  );

  useEffect(() => {
    if (!showAddonModal) return;

    setSelectedAddons((prev) => {
      let normalized = normalizeAddonSelections(prev);

      const groupedSelections = normalized.reduce((acc, addon) => {
        const key = String(addon?.groupId || 'default');
        if (!acc[key]) acc[key] = [];
        acc[key].push(addon);
        return acc;
      }, {});

      const groupedAvailableAddons = Object.values(
        availableAddons.reduce((acc, addon) => {
          const fallbackId = addon?.groupId || `group-${addon?.groupName || 'addons'}`;
          const groupId = String(fallbackId);
          if (!acc[groupId]) {
            acc[groupId] = {
              groupId,
              groupDisplayOrder: Number(
                addon?.groupDisplayOrder
                ?? selectionRulesByGroup?.[groupId]?.displayOrder
                ?? 9999
              ),
              options: []
            };
          }
          acc[groupId].options.push(addon);
          return acc;
        }, {})
      ).sort((a, b) => a.groupDisplayOrder - b.groupDisplayOrder);

      groupedAvailableAddons.forEach(({ groupId, options }) => {
        const rule = selectionRulesByGroup?.[groupId];
        const minSelection = Number(rule?.minSelection || 0);
        const hasSelection = (groupedSelections[groupId] || []).length > 0;

        if (minSelection < 1 || hasSelection) return;

        const dependsOnGroupId = rule?.dependsOnGroupId;
        const selectedParentOption = dependsOnGroupId
          ? groupedSelections[String(dependsOnGroupId)]?.[0] || null
          : null;

        if (dependsOnGroupId && !selectedParentOption) return;

        const contextFilteredOptions = (options || []).filter((addon) =>
          matchesDependentContext(addon, selectedParentOption)
        );

        const firstOption = contextFilteredOptions[0];
        if (!firstOption) return;

        normalized = normalizeAddonSelections([...normalized, firstOption]);
        groupedSelections[groupId] = [firstOption];
      });

      const prevSignature = getAddonSelectionSignature(prev);
      const nextSignature = getAddonSelectionSignature(normalized);
      return prevSignature === nextSignature ? prev : normalized;
    });
  }, [showAddonModal, availableAddons, selectionRulesByGroup]);

  const pruneInvalidDependentSelections = (selections) => {
    return normalizeAddonSelections(selections);
  };

  const toggleAddonSelection = (addon) => {
    const currentAddonKey = getAddonIdentityKey(addon);

    setSelectedAddons(prev => {
      const exists = prev.find((a) => getAddonIdentityKey(a) === currentAddonKey);
      if (exists) {
        return normalizeAddonSelections(prev.filter((a) => getAddonIdentityKey(a) !== currentAddonKey));
      } else {
        const groupId = addon?.groupId;
        const rule = selectionRulesByGroup?.[String(groupId)];
        if (rule) {
          const selectedInGroup = prev.filter((item) => item?.groupId === groupId);
          if (Number(rule.maxSelection || 99) === 1 && selectedInGroup.length >= 1) {
            const withoutGroup = prev.filter((item) => item?.groupId !== groupId);
            return normalizeAddonSelections([...withoutGroup, addon]);
          }
          if (selectedInGroup.length >= Number(rule.maxSelection || 99)) {
            toast.error(`Max ${rule.maxSelection} selection allowed in ${rule.groupName}`, { important: true });
            return prev;
          }
        }
        return normalizeAddonSelections([...prev, addon]);
      }
    });
  };

  const openSpecialRequestEditor = (item) => {
    setEditingSpecialRequest({
      open: true,
      cartItemId: item.cartItemId,
      text: item.specialInstructions || ''
    });
  };

  const closeSpecialRequestEditor = () => {
    setEditingSpecialRequest({
      open: false,
      cartItemId: null,
      text: ''
    });
  };

  const saveSpecialRequest = () => {
    const nextText = String(editingSpecialRequest.text || '').slice(0, 100).trim();

    setCart(prev => prev.map((item) => {
      if (item.cartItemId !== editingSpecialRequest.cartItemId) {
        return item;
      }

      return {
        ...item,
        specialInstructions: nextText
      };
    }));

    closeSpecialRequestEditor();
  };

  const handleOrderOnWebsiteRedirect = useCallback(() => {
    const rawUrl = restaurant?.orderingDisabledButtonUrl;
    if (rawUrl && (rawUrl.startsWith('http://') || rawUrl.startsWith('https://'))) {
      window.open(rawUrl, '_blank', 'noopener,noreferrer');
    } else {
      toast.info('Direct online ordering is paused for this store. Please contact the store directly.', {
        position: 'top-center',
        autoClose: 4000
      });
    }
  }, [restaurant?.orderingDisabledButtonUrl]);

  const mergeOrAddToCart = (product, addons = [], specialInstructions = '') => {
    if (restaurant?.isWebsiteOrderingEnabled === false) {
      handleOrderOnWebsiteRedirect();
      return;
    }

    const normalizedAddons = normalizeAddonSelections(addons);
    const signature = getAddonSelectionSignature(normalizedAddons);
    const nextSpecialInstructions = specialInstructions.trim();

    setCart(prev => {
      const existingIndex = prev.findIndex(item => 
        String(item.productId) === String(product.productId) && 
        getAddonSelectionSignature(item.selectedAddons) === signature
      );

      if (existingIndex > -1) {
        return prev.map((item, index) => 
          index === existingIndex ? { ...item, quantity: item.quantity + 1 } : item
        );
      }

      const cartItem = {
        ...product,
        quantity: 1,
        specialInstructions: nextSpecialInstructions,
        selectedAddons: normalizedAddons,
        cartItemId: `${product.productId}_${Date.now()}` // Unique ID for cart item
      };
      return [...prev, cartItem];
    });
  };

  const addCartItem = (product, addons = [], specialInstructions = '') => {
    mergeOrAddToCart(product, addons, specialInstructions);
  };

  // Add to cart with selected addons
  const addToCartWithAddons = (product, addons) => {
    const normalizedAddons = normalizeAddonSelections(addons);
    const nextSpecialInstructions = String(pendingSpecialInstructions || '').trim();

    if (editingCartItemId) {
      setCart((prev) => prev.map((item) => {
        if (item.cartItemId !== editingCartItemId) {
          return item;
        }

        return {
          ...item,
          selectedAddons: normalizedAddons,
          specialInstructions: nextSpecialInstructions,
        };
      }));
      closeAddonModal();
      toast.success('Item updated');
      return;
    }

    addCartItem(product, normalizedAddons, nextSpecialInstructions);
    closeAddonModal();
  };

  const toggleInstructionChip = (chip) => {
    const currentTokens = pendingSpecialInstructions
      .split('|')
      .map(token => token.trim())
      .filter(Boolean);
    const alreadySelected = currentTokens.some(
      token => token.toLowerCase() === chip.toLowerCase()
    );
    const nextTokens = alreadySelected
      ? currentTokens.filter(token => token.toLowerCase() !== chip.toLowerCase())
      : [...currentTokens, chip];
    setPendingSpecialInstructions(nextTokens.join(' | ').slice(0, 100));
  };

  const validateGroupSelections = () => {
    const normalizedSelections = normalizeAddonSelections(selectedAddons);
    const grouped = (normalizedSelections || []).reduce((acc, item) => {
      const key = item?.groupId || 'default';
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});

    for (const [groupId, rule] of Object.entries(selectionRulesByGroup || {})) {
      const dependsOnGroupId = rule?.dependsOnGroupId;
      if (dependsOnGroupId) {
        const parentSelectedCount = grouped[String(dependsOnGroupId)] || 0;
        if (parentSelectedCount === 0) {
          continue;
        }
      }

      const selectedCount = grouped[groupId] || 0;
      const min = Number(rule?.minSelection || 0);
      const max = Number(rule?.maxSelection || 99);

      if (rule?.isRequired && selectedCount === 0) {
        toast.error(`Please select at least one option for ${rule.groupName}`, { important: true });
        return false;
      }
      if (selectedCount < min) {
        toast.error(`Select minimum ${min} option(s) for ${rule.groupName}`, { important: true });
        return false;
      }
      if (selectedCount > max) {
        toast.error(`Select maximum ${max} option(s) for ${rule.groupName}`, { important: true });
        return false;
      }
    }
    return true;
  };

  const addToCart = (product) => {
    if (restaurant?.isWebsiteOrderingEnabled === false) {
      handleOrderOnWebsiteRedirect();
      return;
    }
    showAddonSelectionModal(product);
  };

  const normalizedSelectedAddons = normalizeAddonSelections(selectedAddons);

  const updateQuantity = (cartItemId, change) => {
    setCart(prev => prev.map(item => {
      if (item.cartItemId === cartItemId) {
        const newQuantity = item.quantity + change;
        return newQuantity > 0 ? { ...item, quantity: newQuantity } : null;
      }
      return item;
    }).filter(Boolean));
  };

  const removeFromCart = (cartItemId) => {
    setCart(prev => prev.filter(item => item.cartItemId !== cartItemId));
    toast.info('Item removed');
  };

  const clearCart = () => {
    try {
      // Clear from localStorage
      window.localStorage.removeItem(cartStorageKey);
      // Reset cart state
      setCart([]);
      setAppliedCoupon(null);
      setCouponCode('');
      setShowClearCartConfirm(false);
      // Show success notification
      toast.success('Cart cleared successfully!');
    } catch (error) {
      toast.error('Failed to clear cart');
    }
  };

  const openClearCartConfirm = () => {
    if (cart.length === 0) return;
    setShowClearCartConfirm(true);
  };

  const closeClearCartConfirm = () => {
    setShowClearCartConfirm(false);
  };

  const getCartSubtotal = () => {
    return cart.reduce((total, item) => {
      const basePrice = item.discountPrice || item.price;
      const addonsPrice = (item.selectedAddons || []).reduce((sum, addon) => sum + Number(addon.addonPrice || 0), 0);
      const itemTotal = (basePrice + addonsPrice) * item.quantity;
      return total + itemTotal;
    }, 0);
  };

  const isMrpCartItem = (item) => Boolean(
    item?.categoryIsMrp ?? item?.category_is_mrp ?? item?.isMrp ?? item?.is_mrp
  );

  const getTaxableCartSubtotal = () => {
    return cart.reduce((total, item) => {
      if (isMrpCartItem(item)) {
        return total;
      }

      const basePrice = item.discountPrice || item.price;
      const addonsPrice = (item.selectedAddons || []).reduce((sum, addon) => sum + Number(addon.addonPrice || 0), 0);
      const itemTotal = (basePrice + addonsPrice) * item.quantity;
      return total + itemTotal;
    }, 0);
  };

  const buildDeliverySettingsFromRestaurant = (restaurantData) => {
    if (!restaurantData) return null;
    const slabs = Array.isArray(restaurantData?.deliverySlabs)
      ? restaurantData.deliverySlabs
      : [];

    const normalizedSlabs = slabs
      .filter((slab) => slab?.isActive !== false)
      .map((slab) => ({
        ...slab,
        minOrderAmount: Number(slab?.minOrderAmount || slab?.min || 0),
        maxOrderAmount: slab?.maxOrderAmount == null && slab?.max == null
          ? null
          : Number(slab?.maxOrderAmount ?? slab?.max),
        deliveryCharge: Number(slab?.deliveryCharge || slab?.charge || 0),
        displayOrder: Number(slab?.displayOrder ?? 9999)
      }))
      .sort((a, b) => {
        const orderDiff = a.displayOrder - b.displayOrder;
        if (orderDiff !== 0) return orderDiff;
        return a.minOrderAmount - b.minOrderAmount;
      });

    if (normalizedSlabs.length === 0) return null;

    return {
      isDeliveryEnabled: restaurantData?.isDeliveryEnabled !== false,
      isSlabPricingEnabled: restaurantData?.isSlabPricingEnabled === true || normalizedSlabs.length > 0,
      minimumOrderAmountForDelivery: Number(restaurantData?.minimumOrderAmountForDelivery || 0),
      fallbackDeliveryCharge: Number(restaurantData?.fallbackDeliveryCharge || 0),
      slabs: normalizedSlabs
    };
  };

  const normalizeDeliverySlabs = () => {
    const slabs = Array.isArray(deliverySettings?.slabs) ? deliverySettings.slabs : [];
    return slabs
      .filter((slab) => slab?.isActive !== false)
      .map((slab) => ({
        ...slab,
        minOrderAmount: Number(slab?.minOrderAmount || 0),
        maxOrderAmount: slab?.maxOrderAmount == null ? null : Number(slab.maxOrderAmount),
        deliveryCharge: Number(slab?.deliveryCharge || 0),
        displayOrder: Number(slab?.displayOrder ?? 9999)
      }))
      .sort((a, b) => {
        const orderDiff = a.displayOrder - b.displayOrder;
        if (orderDiff !== 0) return orderDiff;
        return a.minOrderAmount - b.minOrderAmount;
      });
  };

  const buildDeliverySlabInsight = () => {
    if (fulfillmentType !== 'DELIVERY') {
      return null;
    }
    const slabs = normalizeDeliverySlabs();
    const subtotal = Number(getCartSubtotal() || 0);
    if (subtotal <= 0) return null;

    const currentCharge = Number(getCartPricing().deliveryCharge || 0);

    if (!deliverySettings?.isDeliveryEnabled) {
      return {
        message: currentCharge > 0
          ? `Delivery charges ₹${currentCharge.toFixed(0)} apply at checkout.`
          : 'FREE Delivery is applicable on your order.',
        tone: currentCharge > 0 ? 'saving' : 'free'
      };
    }

    if (currentCharge <= 0) {
      return {
        message: 'FREE Delivery is applicable on your order.',
        tone: 'free'
      };
    }

    if (slabs.length === 0 || !deliverySettings?.isSlabPricingEnabled) {
      const minimumOrderAmount = Number(deliverySettings?.minimumOrderAmountForDelivery || 0);
      if (minimumOrderAmount > 0 && subtotal < minimumOrderAmount) {
        const delta = Math.max(minimumOrderAmount - subtotal, 0);
        return {
          message: `Add ₹${delta.toFixed(0)} more to reach the minimum order for delivery. Current delivery charge ₹${currentCharge.toFixed(0)}.`,
          tone: 'saving'
        };
      }

      return {
        message: `Delivery charges ₹${currentCharge.toFixed(0)} apply at checkout.`,
        tone: 'saving'
      };
    }

    const nextSlab = slabs.find((slab) => slab.minOrderAmount > subtotal && slab.deliveryCharge < currentCharge);

    if (!nextSlab) {
      return {
        message: `Delivery charges ₹${currentCharge.toFixed(0)} apply at checkout.`,
        tone: 'saving'
      };
    }

    const delta = Math.max(nextSlab.minOrderAmount - subtotal, 0);
    if (delta <= 0) {
      return {
        message: `Delivery charges ₹${currentCharge.toFixed(0)} apply at checkout.`,
        tone: 'saving'
      };
    }

    if (nextSlab.deliveryCharge <= 0) {
      return {
        message: `Current delivery charge ₹${currentCharge.toFixed(0)}. Add ₹${delta.toFixed(0)} more to avail FREE Delivery.`,
        shortMessage: `Add ₹${delta.toFixed(0)} more for FREE Delivery`,
        delta,
        nextDeliveryCharge: 0,
        currentCharge,
        tone: 'free'
      };
    }

    return {
      message: `Current delivery charge ₹${currentCharge.toFixed(0)}. Add ₹${delta.toFixed(0)} more to reduce delivery charges to ₹${nextSlab.deliveryCharge.toFixed(0)}.`,
      shortMessage: `Add ₹${delta.toFixed(0)} more to reduce delivery charges to ₹${nextSlab.deliveryCharge.toFixed(0)}`,
      delta,
      nextDeliveryCharge: nextSlab.deliveryCharge,
      currentCharge,
      tone: 'saving'
    };
  };

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') return;
    const subtotal = Number(getCartSubtotal() || 0);
    if (!deliverySettings) return;
    const slabs = normalizeDeliverySlabs();
    const currentCharge = Number(getCartPricing().deliveryCharge || 0);
    const currentSlab = slabs.find((slab) => {
      const min = Number(slab?.minOrderAmount || 0);
      const max = slab?.maxOrderAmount == null ? null : Number(slab.maxOrderAmount);
      return subtotal >= min && (max == null || subtotal <= max);
    }) || null;
    const nextSlab = slabs.find((slab) => slab.minOrderAmount > subtotal && slab.deliveryCharge < currentCharge) || null;

    console.debug('[DELIVERY_SLABS] Insight recompute', {
      restaurantId,
      subtotal,
      deliveryCharge: currentCharge,
      slabs,
      currentSlab,
      nextSlab,
      insight: buildDeliverySlabInsight()
    });
  }, [restaurantId, cart, deliverySettings]);

  const resolveDeliveryCharge = (subtotal) => {
    const safeSubtotal = Number(subtotal || 0);
    if (!deliverySettings?.isDeliveryEnabled) {
      return 0;
    }

    if (deliverySettings?.isSlabPricingEnabled) {
      const slabs = Array.isArray(deliverySettings?.slabs) ? deliverySettings.slabs : [];
      for (const slab of slabs) {
        const min = Number(slab?.minOrderAmount || 0);
        const max = slab?.maxOrderAmount === null || slab?.maxOrderAmount === undefined
          ? null
          : Number(slab?.maxOrderAmount);
        const inRange = safeSubtotal >= min && (max === null || safeSubtotal <= max);
        if (inRange) {
          return Number(slab?.deliveryCharge || 0);
        }
      }
    }

    return Number(deliverySettings?.fallbackDeliveryCharge || 0);
  };

  const getBaseCartPricing = () => {
    const isDeliveryOrder = fulfillmentType === 'DELIVERY';
    const subtotal = getCartSubtotal();
    const taxableSubtotal = getTaxableCartSubtotal();
    const minimumOrderAmount = Number(deliverySettings?.minimumOrderAmountForDelivery || 0);
    const belowMinimum = isDeliveryOrder && minimumOrderAmount > 0 && subtotal < minimumOrderAmount;
    const deliveryCharge = isDeliveryOrder ? resolveDeliveryCharge(subtotal) : 0;
    const taxPercentage = Number(gstSettings?.taxPercentage || 0);
    const taxEnabled = Boolean(gstSettings?.isTaxEnabled) && taxPercentage > 0;
    // Delivery charge is not taxable — compute tax only on taxable subtotal
    const taxableAmount = taxableSubtotal;
    const taxAmount = taxEnabled ? (taxableAmount * taxPercentage) / 100 : 0;
    const totalBeforeDiscount = subtotal + deliveryCharge + taxAmount;

    return {
      subtotal,
      deliveryCharge,
      taxAmount,
      taxPercentage,
      taxEnabled,
      totalBeforeDiscount,
      minimumOrderAmount,
      belowMinimum,
    };
  };

  const getCartPricing = () => {
    const base = getBaseCartPricing();
    const rawDiscount = Number(appliedCoupon?.discountAmount || 0);
    const discountAmount = Number.isFinite(rawDiscount)
      ? Math.min(Math.max(rawDiscount, 0), base.totalBeforeDiscount)
      : 0;
    const total = Math.max(base.totalBeforeDiscount - discountAmount, 0);

    return {
      subtotal: base.subtotal,
      deliveryCharge: base.deliveryCharge,
      taxAmount: base.taxAmount,
      taxPercentage: base.taxPercentage,
      taxEnabled: base.taxEnabled,
      totalBeforeDiscount: base.totalBeforeDiscount,
      discountAmount,
      total,
      minimumOrderAmount: base.minimumOrderAmount,
      belowMinimum: base.belowMinimum,
      appliedCouponCode: appliedCoupon?.couponCode || null,
    };
  };

  const getCartTotal = () => getCartPricing().total;
  const deliverySlabInsight = buildDeliverySlabInsight();
  const stickyFooterDeliveryInsight = fulfillmentType !== 'DELIVERY'
    ? null
    : (deliverySlabInsight || {
      message: getCartPricing().deliveryCharge > 0
        ? `Delivery charges ₹${Number(getCartPricing().deliveryCharge || 0).toFixed(0)} apply at checkout.`
        : 'FREE Delivery is applicable on your order.',
      tone: getCartPricing().deliveryCharge > 0 ? 'saving' : 'free'
    });

  const hasValidSelectedLocality = true;
  const hasSelectedAValidLocality = Boolean(
    selectedLocality
    && String(selectedLocality?.localityName || '').trim()
    && String(selectedLocality?.localityCode || '').trim()
  );

  const requiredHint = 'Fill this detail';
  const isFilled = (value) => String(value || '').trim().length > 0;

  const handleApplyCoupon = async (overrideCode) => {
    const code = String(overrideCode ?? couponCode ?? '').trim().toUpperCase();
    if (!code) {
      toast.error('Please enter a coupon code');
      return;
    }

    const pricing = getBaseCartPricing();
    if (pricing.totalBeforeDiscount <= 0) {
      toast.error('Cart total must be greater than 0');
      return;
    }

    setApplyingCoupon(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/coupons/apply`,
        {
          restaurantId: parseInt(restaurantId),
          couponCode: code,
          amount: Number(pricing.totalBeforeDiscount.toFixed(2)),
        },
        { headers: getPublicRequestHeaders() }
      );

      if (!response?.data?.success || !response?.data?.data) {
        throw new Error(response?.data?.message || 'Failed to apply coupon');
      }

      setAppliedCoupon(response.data.data);
      setCouponCode(response.data.data.couponCode || code);
      toast.success('Coupon applied successfully');
    } catch (error) {
      setAppliedCoupon(null);
      const message = error?.response?.data?.message || error?.message || 'Invalid coupon';
      toast.error(message);
    } finally {
      setApplyingCoupon(false);
    }
  };

  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
    setCouponCode('');
    toast.info('Coupon removed');
  };

  const resolveCouponOwnerId = () => {
    const candidates = [
      restaurant?.ownerId,
      restaurant?.vendorId,
      restaurant?.owner?.id,
      restaurant?.owner?.ownerId,
      restaurant?.vendor?.id,
      restaurant?.userId,
      restaurant?.user?.id,
      restaurant?.createdBy,
      restaurant?.createdById
    ];
    const directMatch = candidates.find((value) => Number.isFinite(Number(value)));
    if (Number.isFinite(Number(directMatch))) return Number(directMatch);

    if (typeof window === 'undefined') return null;
    const stored = window.localStorage.getItem('ownerId')
      || window.localStorage.getItem('vendorId')
      || window.localStorage.getItem('owner_id')
      || window.localStorage.getItem('vendor_id');
    return Number.isFinite(Number(stored)) ? Number(stored) : null;
  };

  const isCouponWithinDateRange = (coupon) => {
    const now = new Date();
    const validFrom = coupon?.validFrom ? new Date(coupon.validFrom) : null;
    const validTill = coupon?.validTill ? new Date(coupon.validTill) : null;
    if (validFrom && !Number.isNaN(validFrom.getTime()) && validFrom > now) return false;
    if (validTill && !Number.isNaN(validTill.getTime()) && validTill < now) return false;
    return true;
  };

  const formatCouponDescription = (coupon) => {
    const discountType = String(coupon?.discountType || '').toUpperCase();
    const discountValue = Number(coupon?.discountValue || 0);
    const minOrderValue = Number(coupon?.minimumOrderValue || 0);
    const maxDiscount = Number(coupon?.maxDiscountValue || coupon?.maxDiscount || 0);
    const upToValue = Number(coupon?.upToValue ?? coupon?.up_to_value ?? 0);

    let baseText = '';
    if (discountType === 'PERCENT') {
      baseText = `${discountValue}% Off`;
    } else {
      baseText = `Get ₹${discountValue.toFixed(0)} Off`;
    }

    if (minOrderValue > 0) {
      baseText += ` on orders above ₹${minOrderValue.toFixed(0)}`;
    }

    const suffixes = [];
    if (discountType === 'PERCENT') {
      if (upToValue > 0) {
        suffixes.push(`Up to ₹${upToValue.toFixed(0)}`);
      } else if (maxDiscount > 0) {
        suffixes.push(`Up to ₹${maxDiscount.toFixed(0)}`);
      }
    }

    if (suffixes.length > 0) {
      baseText = `${baseText} • ${suffixes.join(' • ')}`;
    }

    return baseText;
  };

  const formatCouponExpiry = (coupon) => {
    const validTill = coupon?.validTill ? new Date(coupon.validTill) : null;
    if (!validTill || Number.isNaN(validTill.getTime())) return '';
    return `Valid till ${validTill.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}`;
  };

  const fetchAvailableCoupons = async () => {
    const ownerId = resolveCouponOwnerId();
    if (!ownerId) {
      if (process.env.NODE_ENV !== 'production') {
        console.debug('[COUPON] OwnerId not available for coupon list', {
          restaurantId,
          restaurantOwnerId: restaurant?.ownerId,
          restaurantVendorId: restaurant?.vendorId,
        });
      }
      setAvailableCoupons([]);
      setCouponsError('Coupons are not available for this restaurant.');
      return;
    }

    setCouponsLoading(true);
    setCouponsError('');

    try {
      let response;
      try {
        const couponEndpoint = isShopMode
          ? `${API_BASE_URL}/api/vendor/coupons/shop/${restaurantId}`
          : `${API_BASE_URL}/api/vendor/coupons/restaurant/${restaurantId}`;
        response = await axios.get(couponEndpoint, { headers: getPublicRequestHeaders() });
      } catch (scopedErr) {
        // Fallback to owner-scoped with explicit shopId or restaurantId param
        const params = isShopMode
          ? { shopId: Number(restaurantId) || undefined }
          : { restaurantId: Number(restaurantId) || undefined };
        response = await axios.get(
          `${API_BASE_URL}/api/vendor/coupons/owner/${ownerId}`,
          {
            params,
            headers: getPublicRequestHeaders()
          }
        );
      }

      if (process.env.NODE_ENV !== 'production') {
        console.debug('[COUPON] Coupons API response', {
          ownerId,
          restaurantId,
          responseData: response?.data
        });
      }

      const payload = response?.data?.data || response?.data || [];
      const list = Array.isArray(payload) ? payload : [];
      const filtered = list.filter((coupon) => {
        if (!coupon || coupon?.isActive === false) return false;
        if (!isCouponWithinDateRange(coupon)) return false;
        if (coupon?.applyToAll === true || coupon?.restaurantId == null) return true;
        return Number(coupon.restaurantId) === Number(restaurantId);
      });

      setAvailableCoupons(filtered);
      if (filtered.length === 0) {
        setCouponsError('No active coupons available right now.');
      }
    } catch (error) {
      setAvailableCoupons([]);
      setCouponsError(error?.response?.data?.message || error?.message || 'Unable to load coupons');
    } finally {
      setCouponsLoading(false);
    }
  };

  const handleToggleCoupons = async () => {
    const nextState = !showCouponList;
    setShowCouponList(nextState);
    if (nextState && availableCoupons.length === 0 && !couponsLoading) {
      await fetchAvailableCoupons();
    }
  };

  useEffect(() => {
    if (!showCouponList) return;
    if (availableCoupons.length > 0 || couponsLoading) return;
    if (!restaurant?.ownerId && !restaurant?.vendorId) return;

    fetchAvailableCoupons();
  }, [showCouponList, restaurant?.ownerId, restaurant?.vendorId]);

  const getCartCount = () => {
    return cart.reduce((count, item) => count + item.quantity, 0);
  };

  // ── Razorpay Checkout ─────────────────────────────────────────
  const handleRazorpayCheckout = async () => {
    if (!onlinePaymentConfigured) {
      setShowCheckoutModal(false);
      setShowNoOnlinePaymentModal(true);
      return;
    }
    const normalizedPhone = String(checkoutForm.phone || '').replace(/\D/g, '').slice(0, 10);
    const isDeliveryOrder = fulfillmentType === 'DELIVERY';
    const isDriveThroughOrder = fulfillmentType === 'DRIVETHROUGH';

    if (!checkoutForm.name.trim() || !normalizedPhone) {
      setPaymentError('Name and WhatsApp number are required');
      return;
    }

    if (normalizedPhone.length !== 10) {
      setPaymentError('Please enter a valid 10-digit WhatsApp number');
      return;
    }

    if (isDeliveryOrder) {
      if (!hasValidSelectedLocality) {
        setPaymentError('Please select a valid locality');
        return;
      }

      const trimmedAddress = String(checkoutForm.addressLine || '').trim();
      if (!trimmedAddress) {
        setPaymentError('Please enter complete delivery address');
        if (addressLineRef.current) {
          addressLineRef.current.focus();
        }
        return;
      }
    }

    if (isDriveThroughOrder) {
      const vehicleNumber = String(checkoutForm.vehicleNumber || '').trim();
      if (!vehicleNumber) {
        setPaymentError('Please enter vehicle number for drive-through order');
        return;
      }
    }

    const trimmedAddress = String(checkoutForm.addressLine || '').trim();
    if (isDeliveryOrder && !trimmedAddress) {
      setPaymentError('Please enter complete delivery address');
      return;
    }

    const effectiveLatitude = Number(customerLocation?.latitude);
    const effectiveLongitude = Number(customerLocation?.longitude);
    const selectedLocalityLatitude = Number(selectedLocality?.latitude);
    const selectedLocalityLongitude = Number(selectedLocality?.longitude);
    const isDummyCoordinates = (lat, lng) => lat === 0.5 && lng === 0.5;
    const hasCustomerGps = Number.isFinite(effectiveLatitude)
      && Number.isFinite(effectiveLongitude)
      && !isDummyCoordinates(effectiveLatitude, effectiveLongitude);
    const hasLocalityGps = Number.isFinite(selectedLocalityLatitude)
      && Number.isFinite(selectedLocalityLongitude)
      && !isDummyCoordinates(selectedLocalityLatitude, selectedLocalityLongitude);
    const finalLatitude = hasCustomerGps
      ? effectiveLatitude
      : hasLocalityGps
        ? selectedLocalityLatitude
        : null;
    const finalLongitude = hasCustomerGps
      ? effectiveLongitude
      : hasLocalityGps
        ? selectedLocalityLongitude
        : null;
    const hasGps = Number.isFinite(finalLatitude) && Number.isFinite(finalLongitude);

    const pricing = getCartPricing();
    if (pricing.belowMinimum) {
      setPaymentError(`Minimum order for delivery is Rs ${pricing.minimumOrderAmount.toFixed(2)}.`);
      return;
    }

    setPaymentError('');
    setProcessingPayment(true);

    const buildOrderPayload = ({ paymentStatus, paymentFailureReason, razorpayOrderId, razorpayPaymentId }) => {
      const pricing = getCartPricing();
      const total = pricing.total;

      const fallbackLocName = String(checkoutForm.city || restaurant?.city || 'NA').trim() || 'NA';
      const fallbackLocCode = 'NA';

      const effectiveLocalityName = selectedLocality?.localityName || fallbackLocName;
      const effectiveLocalityCode = selectedLocality?.localityCode || fallbackLocCode;

      const composedAddress = isDeliveryOrder
        ? [
            checkoutForm.addressLine,
            checkoutForm.landmark,
            effectiveLocalityName,
            checkoutForm.city,
          ].map(v => (v || '').trim()).filter(Boolean).join(', ')
        : null;

      const singleLineAddress = composedAddress;

      const combinedInstructions = [
        (checkoutForm.deliveryInstructions || '').trim(),
        isDriveThroughOrder ? `Vehicle color: ${String(checkoutForm.vehicleColor || '').trim() || 'N/A'}` : null,
        isDriveThroughOrder ? `Vehicle number: ${String(checkoutForm.vehicleNumber || '').trim() || 'N/A'}` : null,
        customerLocation.accuracy ? `GPS accuracy: ${customerLocation.accuracy}m` : null,
        paymentFailureReason ? `Payment note: ${paymentFailureReason}` : null
      ].filter(Boolean).join(' | ');

      console.log('[LOCALITY] Building order payload with mapped locality + coordinates', {
        localityName: effectiveLocalityName || null,
        localityCode: effectiveLocalityCode || null,
        selectedLocalityLatitude: hasLocalityGps ? selectedLocalityLatitude : null,
        selectedLocalityLongitude: hasLocalityGps ? selectedLocalityLongitude : null,
        deliveryLatitude: hasGps ? finalLatitude : null,
        deliveryLongitude: hasGps ? finalLongitude : null,
      });

      return {
        sessionId,
        restaurantId: Number(restaurantId),
        customerName: checkoutForm.name,
        customerPhone: normalizedPhone,
        customerEmail: checkoutForm.email || '',
        orderType: fulfillmentType,
        vehicleColor: isDriveThroughOrder ? (String(checkoutForm.vehicleColor || '').trim() || null) : null,
        vehicleNumber: isDriveThroughOrder ? (String(checkoutForm.vehicleNumber || '').trim() || null) : null,
        deliveryAddress: isDeliveryOrder ? (composedAddress || null) : null,
        deliveryCity: isDeliveryOrder ? ((restaurant?.city || '').trim() || null) : null,
        deliveryLatitude: isDeliveryOrder && hasGps ? finalLatitude : null,
        deliveryLongitude: isDeliveryOrder && hasGps ? finalLongitude : null,
        latitude: isDeliveryOrder ? (hasLocalityGps ? selectedLocalityLatitude : (hasGps ? finalLatitude : null)) : null,
        longitude: isDeliveryOrder ? (hasLocalityGps ? selectedLocalityLongitude : (hasGps ? finalLongitude : null)) : null,
        localityLatitude: isDeliveryOrder && hasLocalityGps ? selectedLocalityLatitude : null,
        localityLongitude: isDeliveryOrder && hasLocalityGps ? selectedLocalityLongitude : null,
        deliveryInstructions: combinedInstructions || null,
        singleLineAddress: isDeliveryOrder ? (singleLineAddress || null) : null,
        addressLine: isDeliveryOrder ? ((checkoutForm.addressLine || '').trim() || null) : null,
        landmark: isDeliveryOrder ? ((checkoutForm.landmark || '').trim() || null) : null,
        localityCode: isDeliveryOrder ? (effectiveLocalityCode || null) : null,
        localityName: isDeliveryOrder ? (effectiveLocalityName || null) : null,
        locality_code: isDeliveryOrder ? (effectiveLocalityCode || null) : null,
        locality_name: isDeliveryOrder ? (effectiveLocalityName || null) : null,
        localityInfo: {
          name: isDeliveryOrder ? (effectiveLocalityName || null) : null,
          code: isDeliveryOrder ? (effectiveLocalityCode || null) : null
        },
        formattedDetails: {
          city: isDeliveryOrder ? ((restaurant?.city || '').trim() || null) : null,
          state: 'Rajasthan',
          state_code: 'RJ',
          state_district: isDeliveryOrder ? ((restaurant?.city || '').trim() || null) : null,
          town: isDeliveryOrder ? (effectiveLocalityName || null) : null,
          road: isDeliveryOrder ? ((checkoutForm.addressLine || '').trim() || null) : null,
          country: 'India'
        },
        paymentMethod: 'ONLINE',
        paymentStatus,
        razorpayOrderId: razorpayOrderId || null,
        razorpayPaymentId: razorpayPaymentId || null,
        couponId: appliedCoupon?.couponId || null,
        couponCode: pricing.appliedCouponCode || null,
        discountAmount: Number(pricing.discountAmount || 0),
        items: cart.map(item => {
          const selectedAddons = Array.isArray(item.selectedAddons) ? item.selectedAddons : [];
          const selectedAddonIds = selectedAddons
            .filter((addon) => !!(addon?.legacyAddonId || addon?.addonId) && !addon?.optionId)
            .map((addon) => Number(addon.legacyAddonId || addon.addonId));
          const modifierSelections = selectedAddons.reduce((acc, addon) => {
            const groupId = addon?.groupId;
            const optionId = addon?.optionId;
            if (!groupId || !optionId) {
              return acc;
            }

            const key = String(groupId);
            if (!acc[key]) {
              acc[key] = [];
            }
            if (!acc[key].includes(Number(optionId))) {
              acc[key].push(Number(optionId));
            }
            return acc;
          }, {});
          const modifierOptionIds = Object.values(modifierSelections).flat();

          return {
            productId: item.productId,
            quantity: item.quantity,
            specialInstructions: item.specialInstructions || '',
            selectedAddonIds,
            selectedModifiers: modifierSelections,
            modifierSelections,
            addons: selectedAddonIds.map((addonId) => ({ addonId })),
            modifierOptionIds,
          };
        }),
        taxAmount: Number(pricing.taxAmount || 0),
        taxPercentage: Number(pricing.taxPercentage || 0),
        totalAmount: total,
      };
    };

    const createPaidOrder = async ({ razorpayOrderId, razorpayPaymentId }) => {
      const orderEndpoint = isShopMode
        ? `${API_BASE_URL}/api/vendor/orders/shop/${restaurantId}`
        : `${API_BASE_URL}/api/vendor/orders/restaurant/${restaurantId}`;
      await axios.post(
        orderEndpoint,
        buildOrderPayload({
          paymentStatus: 'COMPLETED',
          paymentFailureReason: null,
          razorpayOrderId,
          razorpayPaymentId,
        }),
        { headers: getPublicRequestHeaders() }
      );
    };

    try {
      const total = getCartTotal();

      // 1. Request order details from backend (key-only OR full order creation)
      const orderRes = await axios.post(`${API_BASE_URL}/api/vendor/payment/create-order`, {
        ...(isShopMode ? { shopId: parseInt(restaurantId) } : { restaurantId: parseInt(restaurantId) }),
        amount: total,
        currency: 'INR',
        customerName: checkoutForm.name?.trim() || '',
        customerEmail: checkoutForm.email?.trim() || '',
        customerPhone: normalizedPhone,
      }, { headers: getPublicRequestHeaders() });

      if (!orderRes.data.success) {
        const errMsg = String(orderRes.data?.error || orderRes.data?.message || 'Order creation failed');
        if (/not configured|disabled|missing key|payment gateway/i.test(errMsg)) {
          setShowCheckoutModal(false);
          setShowNoOnlinePaymentModal(true);
          return;
        }
        throw new Error(errMsg);
      }

      const paymentGatewayData = orderRes?.data?.data || {};
      const razorpayOrderId = (paymentGatewayData.razorpayOrderId || '').toString().trim();
      const keyId = (paymentGatewayData.keyId || '').toString().trim();
      const keyOnly = Boolean(paymentGatewayData.keyOnly);
      const amount = Number(paymentGatewayData.amount || 0);

      if (!/^rzp_(test|live)_[A-Za-z0-9]+$/.test(keyId)) {
        setShowCheckoutModal(false);
        setShowNoOnlinePaymentModal(true);
        return;
      }

      if (!keyOnly && !razorpayOrderId) {
        throw new Error('Payment order is missing. Please try again in a moment.');
      }

      // 2. Load Razorpay checkout script
      const loadScript = () => new Promise(resolve => {
        if (window.Razorpay) { resolve(true); return; }
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
      });

      const loaded = await loadScript();
      if (!loaded) throw new Error('Could not load payment gateway. Please try again.');

      // 3. Open Razorpay checkout
      await new Promise((resolve, reject) => {
        const razorpayThemeColor = currentTheme?.primaryColor || currentTheme?.secondaryColor || currentTheme?.accentColor || '#4299f5';
        const options = {
          key: keyId,
          amount: keyOnly
            ? Math.round(total * 100)
            : Math.max(100, Math.round(amount * 100) || Math.round(total * 100)),
          currency: 'INR',
          name: restaurant?.restaurantName || restaurant?.shopName || restaurant?.name || 'Order',
          description: `Order of ${getCartCount()} item(s)`,
          prefill: {
            name: checkoutForm.name,
            contact: normalizedPhone,
            email: checkoutForm.email || '',
          },
          theme: { color: razorpayThemeColor },
          handler: async (response) => {
            try {
              // 4a. Full mode: verify signature on backend
              if (!keyOnly && razorpayOrderId) {
                const verifyPayload = isShopMode
                  ? {
                      shopId: parseInt(restaurantId),
                      razorpayOrderId: response.razorpay_order_id,
                      razorpayPaymentId: response.razorpay_payment_id,
                      razorpaySignature: response.razorpay_signature,
                    }
                  : {
                      restaurantId: parseInt(restaurantId),
                      razorpayOrderId: response.razorpay_order_id,
                      razorpayPaymentId: response.razorpay_payment_id,
                      razorpaySignature: response.razorpay_signature,
                    };
                const verifyRes = await axios.post(`${API_BASE_URL}/api/vendor/payment/verify`, {
                  ...verifyPayload,
                }, { headers: getPublicRequestHeaders() });
                if (!verifyRes.data.success) {
                  reject(new Error('Payment verification failed'));
                  return;
                }
              }

              // 4b. Create the order only after payment is confirmed
              try {
                await createPaidOrder({
                  razorpayOrderId: response.razorpay_order_id || null,
                  razorpayPaymentId: response.razorpay_payment_id
                });
              } catch (orderErr) {
                // Log but continue — backend may have created the POS order in a separate
                // transaction (REQUIRES_NEW) and then thrown afterwards. We must not trap
                // the user on the checkout modal when their payment already succeeded.
                console.error('Order persistence warning after successful payment:', orderErr);
              }

              setCart([]);
              setPaymentError('');
              setShowCheckoutModal(false);
              toast.success('🎉 Payment successful! Your order has been placed.');
              if (typeof window !== 'undefined') {
                window.sessionStorage.setItem('showOrderConfirmPopup', 'true');
              }
              setCurrentView('home');
              resolve();
            } catch (err) {
              reject(err);
            }
          },
          modal: {
            ondismiss: () => { setProcessingPayment(false); resolve(); }
          },
        };
        // Attach order_id only in full mode
        if (!keyOnly && razorpayOrderId) {
          options.order_id = razorpayOrderId;
        }
        const rzp = new window.Razorpay(options);
        rzp.on('payment.failed', async (resp) => {
          reject(new Error(resp.error?.description || 'Payment failed'));
        });
        rzp.open();
      });
    } catch (err) {
      console.error('Checkout error:', err);
      const backendErrorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.response?.data?.data?.message ||
        null;
      const effectiveErrorMessage = backendErrorMessage || err?.message || 'Payment flow failed';
      if (!onlinePaymentConfigured || /not configured|disabled|missing key|Payment gateway is not configured/i.test(effectiveErrorMessage)) {
        setShowCheckoutModal(false);
        setShowNoOnlinePaymentModal(true);
      } else {
        setPaymentError(effectiveErrorMessage || 'Payment failed. Please try again.');
      }
    } finally {
      setProcessingPayment(false);
    }
  };

  const getProductQuantity = (productId) => {
    const item = cart.find(item => item.productId === productId);
    return item ? item.quantity : 0;
  };

  const getCallNumber = () => {
    const raw = restaurant?.contactPhone || restaurant?.whatsappNumber || restaurant?.contactPhoneNumber || '';
    return String(raw || '').trim();
  };

  const getWhatsAppNumber = () => {
    const raw = restaurant?.whatsappNumber || restaurant?.whatsapp_number || restaurant?.contactPhone || restaurant?.contact_phone || restaurant?.contactPhoneNumber || '';
    if (!raw) return '';
    let digits = String(raw).replace(/\D/g, '');
    if (!digits) return '';
    if (digits.startsWith('0')) {
      digits = digits.replace(/^0+/, '');
    }
    const rawCC =
      restaurant?.whatsappCountryCode ||
      restaurant?.whatsapp_country_code ||
      restaurant?.countryCode ||
      restaurant?.country_code ||
      '91';
    const cc = String(rawCC).replace(/\D/g, '') || '91';
    if (digits.length === 10) {
      digits = cc + digits;
    }
    return digits;
  };

  const handleDirectWhatsAppOrder = () => {
    const phone = getWhatsAppNumber();
    const vendorName = restaurant?.restaurantName || restaurant?.shopName || restaurant?.name || 'Store';
    const total = getCartTotal();

    let text = `Hello *${vendorName}*,\nI would like to place an order:\n\n`;
    if (cart && cart.length > 0) {
      text += `*Order Items:*\n`;
      cart.forEach((item, index) => {
        const itemTotal = Number(item.price || 0) * Number(item.quantity || 1);
        text += `${index + 1}. ${item.productName || item.name} x ${item.quantity} - ₹${itemTotal.toFixed(2)}\n`;
        if (item.selectedVariants?.length) {
          text += `   (${item.selectedVariants.map(v => v.variantName || v.name).join(', ')})\n`;
        }
      });
      text += `\n*Total Amount:* ₹${total.toFixed(2)}\n`;
    }
    if (fulfillmentType) {
      text += `*Order Type:* ${fulfillmentType}\n`;
    }
    if (checkoutForm?.name?.trim()) {
      text += `*Customer Name:* ${checkoutForm.name.trim()}\n`;
    }
    if (checkoutForm?.phone?.trim()) {
      text += `*Phone:* ${checkoutForm.phone.trim()}\n`;
    }
    if (checkoutForm?.addressLine?.trim()) {
      text += `*Delivery Address:* ${checkoutForm.addressLine.trim()}${checkoutForm.landmark ? ', ' + checkoutForm.landmark : ''}${checkoutForm.city ? ', ' + checkoutForm.city : ''}\n`;
    }
    if (checkoutForm?.deliveryInstructions?.trim()) {
      text += `*Instructions:* ${checkoutForm.deliveryInstructions.trim()}\n`;
    }
    text += `\nPlease confirm my order. Thank you!`;

    const encoded = encodeURIComponent(text);
    if (phone) {
      window.open(`https://wa.me/${phone}?text=${encoded}`, '_blank');
    } else {
      window.open(`https://api.whatsapp.com/send?text=${encoded}`, '_blank');
    }
  };

  const handleDirectCall = () => {
    const num = getCallNumber();
    if (num) {
      window.location.href = `tel:${num}`;
    }
  };

  const handleOpenCheckoutModal = () => {
    if (restaurant?.isWebsiteOrderingEnabled === false) {
      handleOrderOnWebsiteRedirect();
      return;
    }
    if (!onlinePaymentConfigured) {
      setShowNoOnlinePaymentModal(true);
      return;
    }
    setShowCheckoutModal(true);
    setPaymentError('');
  };

  const normalizeSearchText = (value) => String(value || '').trim().toLowerCase();
  const normalizedDebouncedQuery = normalizeSearchText(debouncedSearchQuery);
  const getCategoryName = (category) => category?.categoryName || category?.name || '';
  const getCategoryOrder = (category) => Number(category?.order ?? category?.displayOrder ?? category?.sortOrder ?? category?.position ?? 9999);

  const sortedCategories = [...categories].sort((a, b) => {
    const orderDiff = getCategoryOrder(a) - getCategoryOrder(b);
    if (orderDiff !== 0) return orderDiff;
    return getCategoryName(a).localeCompare(getCategoryName(b));
  });

  const fallbackCategoryNames = Array.from(
    new Set(products.map((p) => p?.productCategory?.categoryName).filter(Boolean))
  );

  const orderedCategoryBuckets = [
    ...sortedCategories
      .filter((c) => getCategoryName(c))
      .map((c) => ({
        id: c?.categoryId ?? c?.category_id ?? c?.productCategoryId ?? c?.product_category_id ?? c?.id ?? null,
        name: getCategoryName(c),
        order: getCategoryOrder(c),
      })),
    ...fallbackCategoryNames
      .filter(
        (name) => !sortedCategories.some((c) => normalizeSearchText(getCategoryName(c)) === normalizeSearchText(name))
      )
      .map((name, index) => ({
        id: null,
        name,
        order: 10000 + index,
      })),
  ];

  const getProductCategoryName = (p) => p?.productCategory?.categoryName || 'Uncategorized';
  const getProductCategoryId = (p) => p?.productCategory?.categoryId ?? p?.categoryId ?? null;

  const hasNonVegItems = React.useMemo(() => {
    return (products || []).some((p) => {
      return p.isVeg === false || p.isVeg === 'false' || p.itemType === 'NON_VEG';
    });
  }, [products]);

  const categoryScopedProducts = React.useMemo(() => {
    return (products || [])
      .filter(p => isProductAvailableForOrderType(p, fulfillmentType))
      .filter(p => {
        if (!vegOnlyFilter) return true;
        return p.isVeg !== false && p.isVeg !== 'false' && p.itemType !== 'NON_VEG';
      });
  }, [products, fulfillmentType, vegOnlyFilter]);

  const matchedCategoryNames = normalizedDebouncedQuery
    ? new Set(
      orderedCategoryBuckets
        .filter((bucket) => normalizeSearchText(bucket.name).includes(normalizedDebouncedQuery))
        .map((bucket) => normalizeSearchText(bucket.name))
    )
    : new Set();

  // Filter products by debounced search query with exact match prioritization
  const filteredProducts = !normalizedDebouncedQuery
    ? categoryScopedProducts
    : categoryScopedProducts
      .filter((p) => {
        const searchableText = [
          p.productName,
          p.description,
          p.productCategory?.categoryName,
          p.foodType,
          p.cuisineType,
          p.isVeg ? 'veg vegetarian' : 'non veg non-veg',
          p.price,
          p.discountPrice,
        ]
          .map((val) => normalizeSearchText(val))
          .join(' ');

        const productCategoryName = normalizeSearchText(getProductCategoryName(p));

        return searchableText.includes(normalizedDebouncedQuery)
          || matchedCategoryNames.has(productCategoryName);
      })
      .sort((a, b) => {
        // Exact match priority: product name exact match comes first
        const aNameExact = normalizeSearchText(a.productName) === normalizedDebouncedQuery ? 1 : 0;
        const bNameExact = normalizeSearchText(b.productName) === normalizedDebouncedQuery ? 1 : 0;
        if (aNameExact !== bNameExact) return bNameExact - aNameExact;

        // Category name exact match priority
        const aCategoryExact = normalizeSearchText(a.productCategory?.categoryName) === normalizedDebouncedQuery ? 1 : 0;
        const bCategoryExact = normalizeSearchText(b.productCategory?.categoryName) === normalizedDebouncedQuery ? 1 : 0;
        if (aCategoryExact !== bCategoryExact) return bCategoryExact - aCategoryExact;

        // Preserve original order for partial matches
        return 0;
      });

  const productBelongsToCategory = (product, bucket) => {
    const productCatId = getProductCategoryId(product);
    if (bucket?.id != null && productCatId != null) {
      return String(bucket.id) === String(productCatId);
    }
    return normalizeSearchText(getProductCategoryName(product)) === normalizeSearchText(bucket?.name);
  };

  const visibleBuckets = orderedCategoryBuckets;

  const groupedMenuSections = visibleBuckets
    .map((bucket) => ({
      ...bucket,
      items: filteredProducts.filter((product) => productBelongsToCategory(product, bucket)),
    }))
    .filter((section) => section.items.length > 0);

  const categoryNamesKey = groupedMenuSections.map((section) => section.name).join('|');

  useEffect(() => {
    setExpandedCategories((prev) => {
      let changed = false;
      const next = { ...prev };
      groupedMenuSections.forEach((section) => {
        if (next[section.name] == null) {
          next[section.name] = true;
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [categoryNamesKey]);

  const toggleCategoryExpanded = (name) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [name]: !(prev?.[name] !== false)
    }));
  };

  const [showCategoryMenuModal, setShowCategoryMenuModal] = useState(false);

  const productSequentialIndexMap = {};
  let sequentialImageIndex = 0;
  groupedMenuSections.forEach((section) => {
    section.items.forEach((product) => {
      if (product?.productId != null && productSequentialIndexMap[product.productId] == null) {
        productSequentialIndexMap[product.productId] = sequentialImageIndex;
        sequentialImageIndex += 1;
      }
    });
  });



  // Normalize template name - remove _QR_template suffix and capitalize properly
  // Direct map handles typos in stored template values (autmn, navratra, sakaranti, etc.)
  const TEMPLATE_ALIAS_MAP = {
    'Normal_QR_template': 'Normal',
    'Spring_QR_template': 'Spring',
    'summer_QR_template': 'Summer',
    'autmn_QR_template': 'Autumn',
    'Winter_qr_template': 'Winter',
    'Christmas_qr_template': 'Christmas',
    'Diwali_QR_template': 'Diwali',
    'EID_qr_template': 'Eid',
    'HOLI_OR_template': 'Holi',
    'navratra_qr_template': 'Navratri',
    'Makar_sakaranti_qr_template': 'Makar Sankranti',
    'Teej_QR_template': 'Teej',
    'Gangaur_QR_template': 'Gangaur',
    'Royal_Rajasthan_QR_template': 'Royal Rajasthan',
    'Premium_Carousel_QR_template': 'Premium Carousel',
    'Midnight_Luxe_QR_template': 'Midnight Luxe',
    'Midnight Luxe': 'Midnight Luxe',
    'New_Theme_Development_QR_template': 'Midnight Luxe',
    'New_theme_development_qr_template': 'Midnight Luxe',
    'New Theme (Under Development)': 'Midnight Luxe',
    'New Theme': 'Midnight Luxe'
  };

  const normalizeTemplateName = (templateName) => {
    if (!templateName) return 'Normal';

    // Direct alias lookup first — handles typos like autmn, navratra, sakaranti
    if (TEMPLATE_ALIAS_MAP[templateName]) return TEMPLATE_ALIAS_MAP[templateName];

    // Check for Midnight Luxe / new theme development keywords
    if (/midnight_luxe|midnight luxe|new_theme|under_development|under development|new theme/i.test(String(templateName))) {
      return 'Midnight Luxe';
    }

    // Fuzzy fallback: strip suffixes and match against known theme keys.
    const cleaned = String(templateName)
      .replace(/_QR_template/gi, '')
      .replace(/_OR_template/gi, '')
      .replace(/_template/gi, '')
      .replace(/[^a-zA-Z\s_-]/g, ' ')
      .replace(/[\s_-]+/g, ' ')
      .trim()
      .toLowerCase();

    if (!cleaned) return 'Normal';

    // Match against known theme keys in a tolerant way (exact/includes).
    const themeKeys = Object.keys(TEMPLATE_THEMES);
    const matched = themeKeys.find((key) => {
      const lowerKey = key.toLowerCase();
      return cleaned === lowerKey || cleaned.includes(lowerKey) || lowerKey.includes(cleaned);
    });

    return matched || 'Normal';
  };

  // Get theme based on selected template
  const templateKey = normalizeTemplateName(restaurant?.menuTemplate || 'Normal');
  console.log("Applied Theme:", templateKey, "Raw Template:", restaurant?.menuTemplate);

  const currentTheme = TEMPLATE_THEMES[templateKey] || TEMPLATE_THEMES['Normal'];
  const isRajasthanTheme = templateKey === 'Royal Rajasthan';
  const isPremiumCarouselTheme = templateKey === 'Premium Carousel';
  const isNewDevelopmentTheme = templateKey === 'Midnight Luxe' || templateKey === 'New Theme (Under Development)' || templateKey === 'New Theme';

  // Text colors - Dark themes use light text on dark glass, light themes use dark text
  const textColor = currentTheme.isDark ? '#f1f5f9' : '#1e293b';
  const headerTextColor = currentTheme.isDark
    ? (currentTheme.accentColor || currentTheme.primaryColor)
    : currentTheme.primaryColor;
  const subtitleTextColor = currentTheme.isDark ? '#e2e8f0' : '#64748b';

  // CSS Animations - Enhanced with theme-specific animations
  const styles = `

    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600;700&family=Great+Vibes&family=Pacifico&family=Righteous&family=Lobster&family=Mountains+of+Christmas:wght@700&family=Satisfy&family=Amiri:wght@400;700&family=Fredoka+One&family=Bebas+Neue&family=Dancing+Script:wght@700&family=Chewy&display=swap');

    /* Royal Rajasthan exact shutter loader */
    .rr-loader .shutter-panel { transition: transform 0.8s cubic-bezier(0.77, 0, 0.175, 1) !important; }
    .rr-loader.loaded .shutter-top { transform: translateY(-100%) !important; }
    .rr-loader.loaded .shutter-bottom { transform: translateY(100%) !important; }

    @keyframes rr-fade-in-up { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes rr-float-char { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
    @keyframes rr-namaste-hands { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-4px); } }
    @keyframes rr-head-nod { 0%, 100% { transform: rotate(0deg); } 50% { transform: rotate(2deg); } }
    @keyframes rr-mustache-move { 0%, 100% { transform: scaleX(1); } 50% { transform: scaleX(1.05); } }

    .rr-loader .animate-fade-in { animation: rr-fade-in-up 0.8s ease-out forwards; }
    .rr-loader .animate-float { animation: rr-float-char 3s ease-in-out infinite; }
    .rr-loader .animate-hands-move { animation: rr-namaste-hands 2s ease-in-out infinite; }
    .rr-loader .animate-head-move { animation: rr-head-nod 4s ease-in-out infinite; transform-origin: 100px 110px; }
    .rr-loader .animate-mustache-move { animation: rr-mustache-move 2s ease-in-out infinite; transform-origin: center; }

    * {
      box-sizing: border-box;
    }

    body {
      margin: 0;
      padding: 0;
      overflow-x: hidden;
      scroll-behavior: smooth;
    }

    h1, h2, h3, h4, h5, h6 {
      font-style: normal;
      font-variant: normal;
    }

    .restaurant-name-themed {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
    }

    @keyframes waterWaveFloat {
      0% { border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%; transform: translate(-50%, -50%) rotate(0deg) scale(1); }
      50% { border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; transform: translate(-50%, -50%) rotate(180deg) scale(1.05); }
      100% { border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%; transform: translate(-50%, -50%) rotate(360deg) scale(1); }
    }

    /* 🔥 Premium Animations */
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(20px); filter: blur(5px); }
      to { opacity: 1; transform: translateY(0); filter: blur(0); }
    }

    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(40px); }
      to { opacity: 1; transform: translateY(0); }
    }

    @keyframes bloom {
      0% { transform: scale(0) rotate(0deg); opacity: 0; }
      50% { opacity: 1; }
      100% { transform: scale(1) rotate(360deg); opacity: 1; }
    }

    @keyframes pulse-soft {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.05); }
    }

    @keyframes bounce-gentle {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-8px); }
    }

    @keyframes float-icon {
      0%, 100% { transform: translateY(0px) rotate(0deg); }
      50% { transform: translateY(-5px) rotate(5deg); }
    }

    @keyframes spin-slow {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    @keyframes twinkle {
      0%, 100% { opacity: 1; transform: scale(1); filter: brightness(1); }
      50% { opacity: 0.6; transform: scale(0.9); filter: brightness(1.2); }
    }

    @keyframes shimmer {
      0% { transform: translateX(-150%) skewX(-15deg); }
      100% { transform: translateX(150%) skewX(-15deg); }
    }

    @keyframes slideInFromBottom {
      from { transform: translateY(100%) scale(0.95); opacity: 0; }
      to { transform: translateY(0) scale(1); opacity: 1; }
    }

    @keyframes scaleInCurve {
      from { transform: scale(0.85); opacity: 0; }
      to { transform: scale(1); opacity: 1; }
    }

    /* 🍂 Autumn QR Animations */
    @keyframes float-leaf {
      0% { transform: translateY(0) rotate(0deg); }
      50% { transform: translateY(-5px) rotate(10deg); }
      100% { transform: translateY(0) rotate(0deg); }
    }

    @keyframes pulse-warm {
      0%, 100% { transform: scale(1); opacity: 0.8; }
      50% { transform: scale(1.05); opacity: 1; }
    }

    /* 🎨 Holi QR Animations */
    @keyframes bounce-slow {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-10px); }
    }

    @keyframes wiggle {
      0%, 100% { transform: rotate(-3deg); }
      50% { transform: rotate(3deg); }
    }

    @keyframes splash-pop {
      0% { transform: scale(0); opacity: 0; }
      50% { transform: scale(1.2); opacity: 1; }
      100% { transform: scale(1); opacity: 1; }
    }

    /* ❄️ Winter QR Animations */
    @keyframes pulse-glow {
      0%, 100% { box-shadow: 0 0 10px rgba(56, 189, 248, 0.2); }
      50% { box-shadow: 0 0 20px rgba(56, 189, 248, 0.6); }
    }

    @keyframes fadeInStagger {
      from { opacity: 0; transform: translateY(15px); }
      to { opacity: 1; transform: translateY(0); }
    }

    /* Animation utility classes */
    .animate-fade-in {
      animation: fadeIn 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
      animation-delay: 0.1s;
      opacity: 0;
    }

    .animate-fade-in-delay {
      animation: fadeIn 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
      animation-delay: 0.35s;
      opacity: 0;
    }

    .animate-bloom {
      animation: bloom 1.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
    }

    .animate-pulse {
      animation: pulse-soft 3.5s ease-in-out infinite;
    }

    .animate-float {
      animation: float-icon 3s ease-in-out infinite;
    }

    .animate-spin {
      animation: spin-slow 12s linear infinite;
    }

    .animate-twinkle {
      animation: twinkle 3s ease-in-out infinite;
    }

    .animate-bounce {
      animation: bounce-gentle 2.5s ease-in-out infinite;
    }

    .animate-slide-up {
      animation: slideInFromBottom 0.6s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
    }

    .animate-scale-in {
      animation: scaleInCurve 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
    }

    .animate-leaf {
      animation: float-leaf 4s ease-in-out infinite;
    }

    .animate-pulse-warm {
      animation: pulse-warm 3s infinite ease-in-out;
    }

    .animate-wiggle {
      animation: wiggle 2s infinite ease-in-out;
    }

    .animate-pop {
      animation: splash-pop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
    }

    .animate-bounce-slow {
      animation: bounce-slow 3s infinite ease-in-out;
    }

    @keyframes float-icon {
      0%, 100% { transform: translate(-50%, -50%) translateY(0px) rotate(0deg); }
      50% { transform: translate(-50%, -50%) translateY(-5px) rotate(5deg); }
    }

    .animate-float {
      animation: float-icon 3s ease-in-out infinite;
    }

    .animate-pulse-glow {
      animation: pulse-glow 3s infinite;
    }

    /* ✨ Interactive Premium States */
    .card-hover {
      transition: all 0.4s cubic-bezier(0.2, 0.8, 0.2, 1);
      position: relative;
    }

    .card-hover::before {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      border-radius: inherit;
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0);
      transition: box-shadow 0.4s ease;
      pointer-events: none;
    }

    .card-hover:hover {
      transform: translateY(-5px) scale(1.01);
      box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06) !important;
    }

    .card-hover:hover::before {
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
    }

    .card-hover:active {
      transform: translateY(-2px) scale(0.99);
      transition: all 0.1s ease;
    }

    .btn-hover {
      transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
      position: relative;
      overflow: hidden;
    }

    .btn-hover::after {
      content: '';
      position: absolute;
      top: 0; left: 0; width: 100%; height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
      transform: translateX(-100%);
    }

    .btn-hover:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    }

    .btn-hover:hover::after {
      animation: shimmer 1.5s infinite;
    }

    .btn-hover:active {
      transform: scale(0.96);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .total-section {
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
    }

    .tax-note {
      font-size: 12px;
      color: #6b7280;
      margin-top: 4px;
      line-height: 1.4;
    }

    /* Hide Scrollbar */
    .no-scrollbar::-webkit-scrollbar { display: none; }
    .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
    
    /* Hide scrollbar globally but allow scrolling */
    html, body {
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    html::-webkit-scrollbar, body::-webkit-scrollbar { width: 0; height: 0; }
    ::-webkit-scrollbar { width: 0; height: 0; }
    ::-webkit-scrollbar-track { background: transparent; }
    ::-webkit-scrollbar-thumb { background: transparent; }

    /* Frosted Glass Effect */
    .glass-effect {
      backdrop-filter: blur(20px) saturate(200%);
      -webkit-backdrop-filter: blur(20px) saturate(200%);
      border: 1px solid rgba(255, 255, 255, 0.15);
      box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
    }

    /* Mobile Enhancements */
    /* .menu-mobile-fab desktop visible */

    .menu-mobile-fab {
      position: fixed !important;
      right: 24px;
      bottom: 90px;
      z-index: 1000;
      display: inline-flex;
      align-items: center;
      border: 2px solid color-mix(in srgb, var(--primary-color) 55%, white);
      backdrop-filter: blur(6px);
      border-radius: 999px;
      background: var(--primary-color);
      color: #ffffff;
      font-weight: 700;
      letter-spacing: 0.3px;
      font-size: 14px; 
      padding: 10px 16px; 
      box-shadow: 0 6px 12px color-mix(in srgb, var(--primary-color) 40%, rgba(0, 0, 0, 0.18));
      transition: transform 0.14s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.14s ease;
      cursor: pointer;
    }

    .menu-mobile-fab:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 16px color-mix(in srgb, var(--primary-color) 40%, rgba(0, 0, 0, 0.25));
    }

    .menu-mobile-fab:active {
      transform: scale(0.95);
      box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
    }


    .menu-mobile-fab {
      position: fixed !important;
      right: 24px;
      bottom: 90px;
      z-index: 1000;
      display: inline-flex;
      align-items: center;
      border: 2px solid color-mix(in srgb, var(--primary-color) 55%, white);
      backdrop-filter: blur(6px);
      border-radius: 999px;
      background: var(--primary-color);
      color: #ffffff;
      font-weight: 700;
      letter-spacing: 0.3px;
      font-size: 14px; 
      padding: 10px 16px; 
      box-shadow: 0 6px 12px color-mix(in srgb, var(--primary-color) 40%, rgba(0, 0, 0, 0.18));
      transition: transform 0.14s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.14s ease;
      cursor: pointer;
    }

    .menu-mobile-fab:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 16px color-mix(in srgb, var(--primary-color) 40%, rgba(0, 0, 0, 0.25));
    }

    .menu-mobile-fab:active {
      transform: scale(0.95);
      box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
    }

    .menu-btn {
      position: fixed;
      right: 16px;
      bottom: 90px;
      z-index: 1000;
    }
    .menu-btn.shifted-up {
      bottom: 200px;
    }
    .pc-hidden {
      display: none !important;
    }
    .cart-popup {
      position: fixed;
      bottom: 0;
      width: auto;
      z-index: 900;
    }
    .main-container {
      padding-bottom: 100px;
    }

    .theme-rajasthan {
      background: #ffffff;
    }

    .theme-default {
      /* keep original theme backgrounds/animations */
    }

    /* Desktop-first menu grid (restore 4-5 items view) */
    .menu-grid {
      display: grid;
      grid-template-columns: repeat(5, minmax(0, 1fr));
      gap: 20px;
      align-items: stretch;
      margin-bottom: 24px;
    }

    .menu-card {
      background: var(--menu-card-bg, rgba(255,255,255,0.92));
      border: var(--menu-card-border, 1px solid rgba(0,0,0,0.06));
      border-radius: 18px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      min-height: 100%;
      box-shadow: var(--menu-card-shadow, 0 4px 12px rgba(0,0,0,0.06));
      transition: transform 0.25s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.25s ease;
    }
    .menu-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 28px rgba(0,0,0,0.10);
    }

    .menu-card-image {
      width: 100%;
      height: 170px;
      object-fit: cover;
      display: block;
      border-radius: 18px 18px 0 0;
      background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
      background-size: 200% 100%;
    }

    .menu-card-content {
      padding: 14px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1;
    }

    .menu-card-footer {
      margin-top: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }

    .powered-text a {
      color: #2563eb;
      font-weight: 800;
      text-decoration: none;
    }

    .powered-text a.yelofast-link {
      color: #eab308;
    }

    .powered-text a:hover {
      text-decoration: underline;
    }

    .powered-text-container {
      border-radius: 10px;
      padding: 6px 10px;
    }

    .powered-logos-container {
      margin-top: 2px;
      border-radius: 10px;
      padding: 0;
      background: transparent;
      border: none;
    }

    @keyframes courierMarquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    @keyframes courierMarqueeReverse {
      0% { transform: translateX(-50%); }
      100% { transform: translateX(0); }
    }
    .courier-marquee-wrapper {
      position: relative;
      overflow: hidden;
      width: 100%;
      mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
      -webkit-mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
      padding: 4px 0;
    }
    .courier-marquee-track {
      display: flex;
      width: max-content;
      animation: courierMarquee 32s linear infinite;
      gap: 8px;
    }
    .courier-marquee-track:hover,
    .courier-marquee-track-reverse:hover {
      animation-play-state: paused;
    }
    .courier-marquee-track-reverse {
      display: flex;
      width: max-content;
      animation: courierMarqueeReverse 32s linear infinite;
      gap: 8px;
    }
    .courier-pill {
      height: 38px;
      min-width: 125px;
      padding: 0 14px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      user-select: none;
      box-shadow: 0 2px 6px rgba(0,0,0,0.12);
      transition: transform 0.15s ease, box-shadow 0.15s ease;
      cursor: default;
    }
    .courier-pill:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(0,0,0,0.22);
    }

    .powered-logos {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
      margin-top: 0;
      flex-wrap: wrap;
    }

    .powered-logos a {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 88px;
      padding: 8px 12px;
      border-radius: 12px;
      background: transparent;
      border: none;
      text-decoration: none;
    }

    .powered-logos img {
      height: 40px;
      object-fit: contain;
      max-width: 160px;
      width: auto;
      background: transparent;
    }

    .powered-logos .trivana-logo {
      height: 130px;
      max-width: 400px;
      background: transparent;
      mix-blend-mode: multiply;
      object-fit: contain;
    }

    .add-btn-container {
      display: flex;
      justify-content: center;
      margin-top: 8px;
    }

    .category-nav {
      display: flex;
      overflow-x: auto;
      gap: 10px;
      position: sticky;
      top: 0;
      z-index: 100;
      background: color-mix(in srgb, #ffffff 88%, transparent);
      backdrop-filter: blur(8px);
      padding: 4px 0;
    }
    .category-nav::-webkit-scrollbar { display: none; }

    @media (max-width: 1023px) {
      .menu-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
      }
    }

.menu-add-btn {
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  min-width: 80px;
  text-align: center;
}

.menu-mobile-sections {
  padding-bottom: 40px;
}

/* Unified add button used in list overlay */
.add-btn {
  background: white;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
  padding: 8px 0;
  width: 100%;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  text-transform: uppercase;
  transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.add-btn:hover {
  background: var(--primary-color);
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(43, 58, 74, 0.18);
}
.add-btn:active {
  transform: scale(0.96);
}

.qty-control {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 4px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.menu-qty-btn {
  width: 36px;
  height: 36px;
  font-size: 18px;
  background: transparent;
  border: none;
  color: var(--primary-color);
  font-weight: 800;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-qty-text {
  font-size: 15px;
  font-weight: 700;
  color: var(--primary-color);
  min-width: 30px;
  text-align: center;
}

.menu-mobile-fab {
  position: fixed;
  right: 16px;
  bottom: 90px;
  z-index: 1000;
  display: inline-flex;
  align-items: center;
  border: 2px solid color-mix(in srgb, var(--primary-color) 55%, white);
  backdrop-filter: blur(6px);
  border-radius: 999px;
  background: var(--primary-color);
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.3px;
  font-size: 12px; /* smaller */
  padding: 8px 12px; /* smaller */
  box-shadow: 0 6px 12px color-mix(in srgb, var(--primary-color) 40%, rgba(0, 0, 0, 0.18));
  transition: transform 0.14s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.14s ease;
}

.menu-mobile-fab:active {
  transform: scale(0.95);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
}

.menu-mobile-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 10030;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 14px 90px;
  animation: fadeIn 0.3s ease-out;
}

.menu-mobile-sheet {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 24px;
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
  animation: slideInFromBottom 0.4s cubic-bezier(0.2, 0.8, 0.2, 1);
  box-shadow: 0 -10px 40px rgba(0,0,0,0.2);
}

.menu-mobile-sheet-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.menu-mobile-cat-btn {
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 14px;
  text-align: left;
  padding: 14px 12px;
  font-size: 15px;
  font-weight: 600;
  background: #ffffff;
  color: #334155;
  transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.menu-mobile-cat-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.08);
}
.menu-mobile-cat-btn.active {
  background: linear-gradient(135deg, var(--primary-color, #2b3a4a), var(--secondary-color, #6d8396));
  color: #ffffff;
  border-color: transparent;
  box-shadow: 0 6px 16px rgba(43, 58, 74, 0.2);
}


    @media (max-width: 767px) {
      .menu-category-strip { display: flex !important; }
      .menu-grid {
        grid-template-columns: 1fr !important;
        gap: 16px !important;
      }

      .menu-card {
        display: flex !important;
        flex-direction: row-reverse !important;
        align-items: stretch !important;
        gap: 12px !important;
        padding: 12px !important;
        border-radius: 16px !important;
        min-height: 120px;
        overflow: hidden !important;
      }

      .menu-card-image {
        width: 100px !important;
        height: 100px !important;
        margin: 0 !important;
        border-radius: 12px !important;
        flex-shrink: 0 !important;
        object-fit: cover;
      }

      .menu-card-content {
        padding: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        justify-content: space-between !important;
        min-width: 0;
        gap: 6px;
        flex: 1 1 auto !important;
      }

      .menu-card-header {
        display: flex !important;
        justify-content: space-between !important;
        align-items: flex-start !important;
        gap: 8px;
        margin-bottom: 4px !important;
      }

      .menu-card-title {
        font-size: 16px !important;
        font-weight: 600 !important;
        line-height: 1.3 !important;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0 !important;
      }

      .menu-veg-badge {
        font-size: 10px !important;
        padding: 3px 6px !important;
        flex-shrink: 0;
      }

      .menu-description {
        display: -webkit-box !important;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 12px !important;
        margin-bottom: 6px !important;
        line-height: 1.4 !important;
        opacity: 0.8;
      }

      .menu-card-footer {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        gap: 8px;
        margin-top: auto;
      }

      .menu-price { font-size: 17px !important; font-weight: 600 !important; }
      .menu-old-price { font-size: 13px !important; opacity: 0.6; }

      .menu-add-btn {
        padding: 8px 16px !important;
        border-radius: 12px !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        min-width: 80px;
        text-align: center;
      }

      .menu-mobile-sections {
          padding-bottom: 40px;
      }

      /* Unified add button used in list overlay */
      .add-btn {
        background: white;
        border: 2px solid var(--primary-color);
        color: var(--primary-color);
        padding: 8px 0;
        width: 100%;
        border-radius: 10px;
        font-weight: 700;
        font-size: 15px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        text-transform: uppercase;
      }

      .qty-control {
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 4px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.05);
      }

      .menu-qty-btn {
        width: 36px !important;
        height: 36px !important;
        font-size: 18px !important;
        background: transparent !important;
        border: none !important;
        color: var(--primary-color) !important;
        font-weight: 800 !important;
        cursor: pointer !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
      }

      .menu-qty-text {
        font-size: 15px !important;
        font-weight: 700 !important;
        color: var(--primary-color) !important;
        min-width: 30px !important;
        text-align: center;
      }

      .menu-mobile-fab {
        position: fixed !important;
        right: 16px;
        bottom: 90px;
        z-index: 1000;
        display: inline-flex;
        align-items: center;
        border: 2px solid color-mix(in srgb, var(--primary-color) 55%, white);
        backdrop-filter: blur(6px);
        border-radius: 999px;
        background: var(--primary-color);
        color: #ffffff;
        font-weight: 700;
        letter-spacing: 0.3px;
        font-size: 12px; /* smaller */
        padding: 8px 12px; /* smaller */
        box-shadow: 0 6px 12px color-mix(in srgb, var(--primary-color) 40%, rgba(0, 0, 0, 0.18));
        transition: transform 0.14s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.14s ease;
      }

      .menu-mobile-fab:active {
        transform: scale(0.95);
        box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
      }

      .menu-mobile-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(4px);
        z-index: 10030;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding: 0 14px 90px;
        animation: fadeIn 0.3s ease-out;
      }

      .menu-mobile-sheet {
        width: 100%;
        max-width: 420px;
        background: #ffffff;
        border-radius: 24px;
        padding: 20px;
        max-height: 60vh;
        overflow-y: auto;
        animation: slideInFromBottom 0.4s cubic-bezier(0.2, 0.8, 0.2, 1);
        box-shadow: 0 -10px 40px rgba(0,0,0,0.2);
      }

      .menu-mobile-sheet-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
      }

      .menu-mobile-cat-btn {
        border: 1px solid rgba(0,0,0,0.06);
        border-radius: 14px;
        text-align: left;
        padding: 14px 12px;
        font-size: 15px;
        font-weight: 600;
        background: #ffffff;
        color: #334155;
        transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      }
      .menu-mobile-cat-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0,0,0,0.08);
      }
      .menu-mobile-cat-btn.active {
        background: linear-gradient(135deg, var(--primary-color, #2b3a4a), var(--secondary-color, #6d8396));
        color: #ffffff;
        border-color: transparent;
        box-shadow: 0 6px 16px rgba(43, 58, 74, 0.2);
      }

      .powered-logos img {
        height: 30px;
        max-width: 130px;
      }

      .powered-logos .trivana-logo {
        height: 100px;
        max-width: 320px;
        object-fit: contain;
      }
    }

    /* ── Splash screen animations (QR Templates + Fallback) ── */
    @keyframes float-leaf { 0% { transform: translateY(0) rotate(0deg); } 50% { transform: translateY(-5px) rotate(10deg); } 100% { transform: translateY(0) rotate(0deg); } }
    @keyframes pulse-warm { 0%, 100% { transform: scale(1); opacity: 0.8; } 50% { transform: scale(1.05); opacity: 1; } }
    @keyframes twinkle { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.3; transform: scale(0.7); } }
    @keyframes sway-tree { 0%, 100% { transform: rotate(-2deg); } 50% { transform: rotate(2deg); } }
    @keyframes pop-in { 0% { transform: scale(0.8); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
    @keyframes flicker { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.8; transform: scale(0.9); } }
    @keyframes float-moon { 0% { transform: translateY(0) rotate(0deg); } 50% { transform: translateY(-10px) rotate(5deg); } 100% { transform: translateY(0) rotate(0deg); } }
    @keyframes bounce-slow { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
    @keyframes wiggle { 0%, 100% { transform: rotate(-3deg); } 50% { transform: rotate(3deg); } }
    @keyframes splash-pop { 0% { transform: scale(0); opacity: 0; } 50% { transform: scale(1.2); opacity: 1; } 100% { transform: scale(1); opacity: 1; } }
    @keyframes float-kite { 0% { transform: translateY(0) rotate(0deg) translateX(0); } 25% { transform: translateY(-15px) rotate(5deg) translateX(10px); } 50% { transform: translateY(0) rotate(0deg) translateX(0); } 75% { transform: translateY(-15px) rotate(-5deg) translateX(-10px); } 100% { transform: translateY(0) rotate(0deg) translateX(0); } }
    @keyframes sway-kalash { 0%, 100% { transform: translateY(0) rotate(-2deg); } 50% { transform: translateY(-10px) rotate(2deg); } }
    @keyframes bloom { 0% { transform: scale(0) rotate(0deg); opacity: 0; } 50% { opacity: 1; } 100% { transform: scale(1) rotate(360deg); opacity: 1; } }
    @keyframes pulse-soft { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
    @keyframes float-icon { 0%, 100% { transform: translateY(0px) rotate(0deg); } 50% { transform: translateY(-5px) rotate(5deg); } }
    @keyframes animate-sun { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

    .animate-leaf { animation: float-leaf 4s ease-in-out infinite; }
    .animate-pulse-warm { animation: pulse-warm 3s infinite ease-in-out; }
    .animate-twinkle { animation: twinkle 3s infinite ease-in-out; }
    .animate-sway { animation: sway-tree 4s ease-in-out infinite; }
    .animate-pop-in { animation: pop-in 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards; }
    .animate-flicker { animation: flicker 2s infinite; }
    .animate-moon { animation: float-moon 5s ease-in-out infinite; }
    .animate-bounce-slow { animation: bounce-slow 3s infinite ease-in-out; }
    .animate-wiggle { animation: wiggle 2s infinite ease-in-out; }
    .animate-pop { animation: splash-pop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards; }
    .animate-kite { animation: float-kite 4s ease-in-out infinite; }
    .animate-bloom { animation: bloom 1.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }
    .animate-pulse-soft { animation: pulse-soft 3s infinite ease-in-out; }
    .animate-float { animation: float-icon 3s ease-in-out infinite; }
    .animate-sun { animation: animate-sun 20s linear infinite; }
    .festive-font { font-family: 'Mountains of Christmas', cursive; letter-spacing: 1px; }
    .fun-font { font-family: 'Chewy', cursive; letter-spacing: 1px; }

    /* New premium loaders */
    @keyframes spin-slow { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
    @keyframes spin-reverse-fast { from { transform: rotate(360deg); } to { transform: rotate(0deg); } }
    @keyframes pulse-slow { 0%, 100% { opacity: 0.6; transform: scale(1); } 50% { opacity: 1; transform: scale(1.05); } }

    .animate-spin-slow { animation: spin-slow 12s linear infinite; }
    .animate-spin-reverse-fast { animation: spin-reverse-fast 2s linear infinite; }
    .animate-pulse-slow { animation: pulse-slow 4s ease-in-out infinite; }

    @keyframes seq-fade-1 {
      0%, 10% { opacity: 0; transform: translateY(10px) scale(0.95); filter: blur(2px); }
      25%, 75% { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); }
      90%, 100% { opacity: 0; transform: translateY(-10px) scale(1.05); filter: blur(2px); }
    }
    @keyframes seq-fade-2 {
      0% { opacity: 0; transform: translateY(10px) scale(0.95); filter: blur(2px); }
      100% { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); }
    }

    /* Premium fallback animations (Normal, Gangaur, Teej) */
    @keyframes splash-ambient-a {
      0%, 100% { transform: translate(0, 0) scale(1); }
      50% { transform: translate(15px, 10px) scale(1.05); }
    }
    @keyframes splash-ambient-b {
      0%, 100% { transform: translate(0, 0) scale(1); }
      50% { transform: translate(-15px, -10px) scale(1.08); }
    }
    @keyframes splash-orb-pulse {
      0%, 100% { transform: scale(1); opacity: 0.7; }
      50% { transform: scale(1.06); opacity: 1; }
    }
    @keyframes splash-text-in {
      from { opacity: 0; transform: translateY(12px); }
      to { opacity: 1; transform: translateY(0); }
    }

    /* ── Normal Theme Premium Enhancements ── */
    .skeleton-shimmer {
      position: relative;
      overflow: hidden;
      background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
      background-size: 200% 100%;
      animation: skeleton-shimmer 1.4s ease-in-out infinite;
    }
    @keyframes skeleton-shimmer {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }

    .social-btn {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transition: transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.2s ease;
      cursor: pointer;
    }
    .social-btn:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    }
    .social-btn:active {
      transform: scale(0.96);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    }

    .order-type-popup-overlay {
      position: fixed;
      inset: 0;
      background: rgba(15, 23, 42, 0.55);
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);
      z-index: 10040;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      animation: fadeIn 0.25s ease-out forwards;
    }
    .order-type-popup-card {
      background: #ffffff;
      border-radius: 24px;
      padding: 28px 24px;
      width: 100%;
      max-width: 380px;
      box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
      animation: scaleInCurve 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
      text-align: center;
    }
    .order-type-option {
      width: 100%;
      padding: 16px;
      border-radius: 16px;
      border: 1.5px solid #e2e8f0;
      background: #ffffff;
      color: #1e293b;
      font-weight: 700;
      font-size: 15px;
      cursor: pointer;
      transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin-bottom: 12px;
    }
    .order-type-option:last-child { margin-bottom: 0; }
    .order-type-option:hover {
      border-color: var(--primary-color, #2b3a4a);
      background: #f8fafc;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
    .order-type-option.selected {
      border-color: var(--primary-color, #2b3a4a);
      background: linear-gradient(135deg, var(--primary-color, #2b3a4a), var(--secondary-color, #6d8396));
      color: #ffffff;
      box-shadow: 0 8px 20px rgba(43, 58, 74, 0.25);
    }

    .segmented-selector {
      display: flex;
      background: #f1f5f9;
      border-radius: 14px;
      padding: 4px;
      gap: 4px;
      border: 1px solid #e2e8f0;
    }
    .segmented-selector-btn {
      flex: 1;
      padding: 10px 8px;
      border-radius: 12px;
      border: none;
      background: transparent;
      color: #64748b;
      font-weight: 700;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
      white-space: nowrap;
    }
    .segmented-selector-btn.active {
      background: linear-gradient(135deg, var(--primary-color, #2b3a4a), var(--secondary-color, #6d8396));
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(43, 58, 74, 0.25);
    }

    .premium-card-shadow {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transition: transform 0.25s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.25s ease;
    }
    .premium-card-shadow:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }
    .premium-card-shadow:active {
      transform: scale(0.99);
    }

    .primary-cta-btn {
      background: linear-gradient(135deg, var(--primary-color, #2b3a4a), var(--secondary-color, #6d8396));
      color: #ffffff;
      border: none;
      border-radius: 999px;
      font-weight: 800;
      cursor: pointer;
      transition: transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.2s ease;
      box-shadow: 0 8px 20px rgba(43, 58, 74, 0.25);
    }
    .primary-cta-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 28px rgba(43, 58, 74, 0.32);
    }
    .primary-cta-btn:active {
      transform: scale(0.97);
    }

    .add-cart-btn {
      background: #ffffff;
      border: 2px solid var(--primary-color, #2b3a4a);
      color: var(--primary-color, #2b3a4a);
      border-radius: 12px;
      font-weight: 700;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
    .add-cart-btn:hover {
      background: var(--primary-color, #2b3a4a);
      color: #ffffff;
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(43, 58, 74, 0.18);
    }
    .add-cart-btn:active {
      transform: scale(0.96);
    }

    .total-amount-text {
      font-size: 24px;
      font-weight: 800;
      color: var(--primary-color, #2b3a4a);
      letter-spacing: -0.02em;
    }

    /* ── Responsive Container & Layout ── */
    .content-container {
      width: 100%;
      margin: 0 auto;
      padding: 16px;
      max-width: 100%;
    }

    .touch-target {
      min-height: 44px;
      min-width: 44px;
    }

    @media (min-width: 768px) {
      .content-container {
        max-width: 720px;
        padding: 24px;
      }
      .cart-popup {
        max-width: 720px;
      }
    }

    @media (min-width: 1024px) {
      .content-container {
        max-width: 1100px;
        padding: 28px;
      }
      .cart-popup {
        max-width: 1100px;
      }
      .menu-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 22px;
      }
      .menu-card-image {
        height: 190px;
      }
    }

    @media (min-width: 1280px) {
      .content-container {
        max-width: 1350px;
        padding: 32px;
      }
      .cart-popup {
        max-width: 1350px;
      }
      .menu-grid {
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 24px;
      }
      .menu-card-image {
        height: 200px;
      }
      .menu-mobile-fab, .menu-btn {
        right: calc(50% - 675px + 24px) !important;
      }
    }

    @media (min-width: 1600px) {
      .content-container {
        max-width: 1650px;
        padding: 32px;
      }
      .cart-popup {
        max-width: 1650px;
      }
      .menu-grid {
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 24px;
      }
      .menu-card-image {
        height: 215px;
      }
      .menu-mobile-fab, .menu-btn {
        right: calc(50% - 825px + 24px) !important;
      }
    }

    @media (min-width: 1920px) {
      .content-container {
        max-width: 1850px;
        padding: 32px;
      }
      .cart-popup {
        max-width: 1850px;
      }
      .menu-grid {
        grid-template-columns: repeat(5, minmax(0, 1fr));
        gap: 26px;
      }
      .menu-card-image {
        height: 225px;
      }
      .menu-mobile-fab, .menu-btn {
        right: calc(50% - 925px + 24px) !important;
      }
    }

    /* Ensure cards don't stretch beyond reasonable width on huge screens */
    .menu-card {
      max-width: 100%;
    }

    /* Cart centered card on tablet/desktop */
    .cart-view-wrapper {
      width: 100%;
    }
    @media (min-width: 768px) {
      .cart-view-wrapper {
        max-width: 680px;
        margin: 0 auto;
      }
    }
    @media (min-width: 1025px) {
      .cart-view-wrapper {
        max-width: 800px;
      }
    }

    /* Home section max-width */
    .home-content-wrapper {
      width: 100%;
    }
    @media (min-width: 768px) {
      .home-content-wrapper {
        max-width: 700px;
        margin: 0 auto;
      }
    }
    @media (min-width: 1280px) {
      .home-content-wrapper {
        max-width: 900px;
      }
    }
    @media (min-width: 1600px) {
      .home-content-wrapper {
        max-width: 1000px;
      }
    }

    /* Segmented selector max-width on large screens */
    .segmented-selector {
      width: 100%;
    }
    .segmented-selector-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
    }
    .segmented-selector-label {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    @media (min-width: 768px) {
      .segmented-selector {
        max-width: 480px;
        margin: 0 auto !important;
      }
      .segmented-selector-wrapper {
        align-items: center !important;
      }
      .segmented-selector-label {
        justify-content: center !important;
      }
      .search-bar-container {
        max-width: 600px !important;
        margin: 0 auto 14px !important;
      }
    }

    /* Ensure bottom nav touch targets */
    .bottom-nav-btn {
      min-height: 56px;
    }

    /* Touch target improvements */
    .category-accordion-btn {
      min-height: 44px;
    }
    .menu-qty-btn {
      width: 44px !important;
      height: 44px !important;
    }
    .menu-add-btn {
      min-height: 44px;
    }
    .segmented-selector-btn {
      min-height: 44px;
    }

    /* ── Normal Theme Home UI (Reference Match) ── */
    .decorative-divider {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin: 12px 0;
      color: #c9a96e;
    }
    .decorative-divider::before,
    .decorative-divider::after {
      content: '';
      width: 42px;
      height: 1px;
      background: currentColor;
    }
    .decorative-divider-dot {
      width: 7px;
      height: 7px;
      border-radius: 1px;
      background: currentColor;
      transform: rotate(45deg);
    }

    .social-action-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      text-decoration: none;
      transition: transform 0.2s ease;
      min-width: 64px;
    }
    .social-action-btn:hover {
      transform: translateY(-3px);
    }
    .social-action-btn:active {
      transform: scale(0.96);
    }
    .social-action-icon {
      width: 64px;
      height: 64px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(0, 0, 0, 0.04);
    }
    .social-action-label {
      font-size: 12px;
      font-weight: 600;
      color: #1e293b;
    }

    .signature-menu-card {
      background: #ffffff;
      border-radius: 32px;
      padding: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.05);
      border: 1.5px solid rgba(201, 169, 110, 0.45);
      transition: transform 0.25s ease, box-shadow 0.25s ease;
      cursor: pointer;
    }
    .signature-menu-card:hover {
      transform: translateY(-3px);
      box-shadow: 0 10px 32px rgba(0, 0, 0, 0.1);
    }
    .signature-menu-icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: rgba(201, 169, 110, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    .signature-menu-arrow {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.06);
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: all 0.2s ease;
      color: #c9a96e;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
    }
    .signature-menu-card:hover .signature-menu-arrow {
      background: #c9a96e;
      border-color: #c9a96e;
      color: #ffffff;
    }

    .website-card {
      background: #ffffff;
      border-radius: 24px;
      padding: 20px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 0, 0, 0.04);
      text-decoration: none;
      transition: transform 0.2s ease, box-shadow 0.2s ease;
      cursor: pointer;
    }
    .website-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    }
    .website-card-icon {
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      color: #0f172a;
    }
  `;

  // ── OLD generic loader disabled per instructions ──
  /*
  const OldSplashScreen = () => (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', background: currentTheme.splashBg,
      transition: 'opacity 1s, visibility 1s', opacity: showSplash ? 1 : 0,
      visibility: showSplash ? 'visible' : 'hidden', pointerEvents: showSplash ? 'all' : 'none', overflow: 'hidden'
    }}>
      <div style={{ position: 'absolute', top: '-20%', left: '-15%', width: '320px', height: '320px', background: `radial-gradient(circle, ${currentTheme.primaryColor}30, transparent 70%)`, borderRadius: '50%', filter: 'blur(60px)', animation: 'splash-ambient-a 6s ease-in-out infinite' }} />
      <div style={{ position: 'absolute', bottom: '-20%', right: '-15%', width: '320px', height: '320px', background: `radial-gradient(circle, ${currentTheme.secondaryColor}25, transparent 70%)`, borderRadius: '50%', filter: 'blur(60px)', animation: 'splash-ambient-b 6s ease-in-out infinite' }} />
      <div style={{ width: '120px', height: '120px', borderRadius: '50%', background: currentTheme.isDark ? `radial-gradient(circle at 35% 35%, ${currentTheme.primaryColor}25, ${currentTheme.secondaryColor}10, transparent)` : `radial-gradient(circle at 35% 35%, ${currentTheme.primaryColor}18, ${currentTheme.secondaryColor}08, transparent)`, border: `1.5px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.1)' : currentTheme.primaryColor + '20'}`, backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', boxShadow: `0 0 40px ${currentTheme.primaryColor}15, inset 0 0 30px ${currentTheme.primaryColor}08`, marginBottom: '40px', animation: 'splash-orb-pulse 2.4s cubic-bezier(0.4, 0, 0.6, 1) infinite', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: currentTheme.primaryColor, boxShadow: `0 0 20px ${currentTheme.primaryColor}60, 0 0 40px ${currentTheme.primaryColor}30`, opacity: 0.8 }} />
      </div>
      <h1 style={{ fontSize: '42px', marginBottom: '6px', fontFamily: currentTheme.font, color: currentTheme.isDark ? '#ffffff' : currentTheme.primaryColor, textAlign: 'center', fontWeight: '700', opacity: 0, animation: 'splash-text-in 0.8s ease-out 0.3s forwards', letterSpacing: '-0.01em' }}>{currentTheme.splashTitle}</h1>
      <p style={{ fontSize: '13px', letterSpacing: '0.3em', textTransform: 'uppercase', color: currentTheme.isDark ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.35)', fontWeight: '500', marginBottom: '0', opacity: 0, animation: 'splash-text-in 0.8s ease-out 0.6s forwards' }}>{isShopMode ? 'Welcome to Our Store' : currentTheme.splashSubtitle}</p>
      <div style={{ marginTop: '48px', width: '192px', height: '3px', background: currentTheme.isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)', borderRadius: '999px', overflow: 'hidden', position: 'relative' }}>
        <div style={{ position: 'absolute', height: '100%', width: `${loadingProgress}%`, background: `linear-gradient(90deg, ${currentTheme.primaryColor}, ${currentTheme.secondaryColor})`, transition: 'width 0.4s ease-out', borderRadius: '999px', boxShadow: `0 0 12px ${currentTheme.primaryColor}50` }} />
      </div>
    </div>
  );
  */

  // ── NEW Exact Per-Theme Splash Screen Loader ──

  // ── Theme-Specific Loader Render Functions ──────────────────────────────
  const renderAutumnLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#fff7ed', overflow: 'hidden' }}>
      <div className="absolute top-[-10%] left-[-10%] w-64 h-64 bg-orange-200 rounded-full blur-3xl opacity-40 animate-pulse-warm"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-64 h-64 bg-yellow-200 rounded-full blur-3xl opacity-40 animate-pulse-warm" style={{ animationDelay: '1s' }}></div>
      <div className="relative w-56 h-56 mb-4 flex items-center justify-center">
        <svg viewBox="0 0 200 200" className="w-full h-full animate-leaf origin-center drop-shadow-xl">
          <path d="M100,180 C100,180 100,130 100,130 C100,130 70,150 50,130 C40,120 60,100 60,100 C60,100 30,90 40,60 C45,45 70,70 70,70 C70,70 80,30 100,20 C120,30 130,70 130,70 C130,70 155,45 160,60 C170,90 140,100 140,100 C140,100 160,120 150,130 C130,150 100,130 100,130 C100,130 100,180 100,180 Z" fill="url(#leafGradient)" stroke="#9a3412" strokeWidth="2" />
          <defs>
            <linearGradient id="leafGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#f59e0b', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#ea580c', stopOpacity: 1 }} />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <h1 className="text-6xl text-orange-700 mb-1 script-font animate-fade-in drop-shadow-sm" style={{ animationDelay: '0.8s' }}>Namaste</h1>
      <p className="text-orange-900/60 text-lg tracking-[0.4em] uppercase font-light animate-fade-in" style={{ animationDelay: '1.2s' }}>Atithi Devo Bhava</p>
      <div className="mt-10 w-48 h-1.5 bg-orange-100 rounded-full overflow-hidden relative">
        <div className="absolute h-full bg-gradient-to-r from-yellow-500 via-orange-500 to-red-600 transition-all duration-[2500ms] ease-out" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );

  const renderWinterLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#0f172a', overflow: 'hidden' }}>
      <div className="relative w-48 h-48 mb-6 flex items-center justify-center">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full animate-spin-slow origin-center drop-shadow-[0_0_15px_rgba(56,189,248,0.8)]">
          <g stroke="#38bdf8" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none">
            {[0, 60, 120, 180, 240, 300].map(angle => (
              <g key={angle} style={{ transform: `rotate(${angle}deg)`, transformOrigin: '100px 100px' }}>
                <line x1="100" y1="100" x2="100" y2="30" />
                <path d="M100 70 L85 55 M100 70 L115 55" strokeWidth="3" />
                <path d="M100 45 L90 35 M100 45 L110 35" strokeWidth="2" />
              </g>
            ))}
            <circle cx="100" cy="100" r="12" fill="#0ea5e9" opacity="0.6" stroke="none" />
            <polygon points="100,85 113,92.5 113,107.5 100,115 87,107.5 87,92.5" strokeWidth="2" stroke="#e0f2fe" opacity="0.8" />
          </g>
        </svg>
      </div>
      <h1 className="text-5xl text-sky-400 mb-2 script-font animate-fade-in drop-shadow-lg">Namaste</h1>
      <p className="text-slate-400 text-lg tracking-[0.3em] uppercase font-light animate-fade-in" style={{ animationDelay: '0.5s' }}>Atithi Devo Bhava</p>
      <div className="mt-12 w-48 h-1 bg-slate-800 rounded-full overflow-hidden relative">
        <div className="absolute h-full bg-sky-500 transition-all duration-[3000ms] ease-out shadow-[0_0_10px_#0ea5e9]" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );

  const renderDiwaliLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(to bottom right, #991b1b, #ea580c)', overflow: 'hidden' }}>
      <div className="relative w-64 h-64 mb-6 flex items-center justify-center">
        <svg viewBox="0 0 200 200" className="w-full h-full drop-shadow-[0_0_25px_rgba(253,224,71,0.6)]">
          <path d="M100,20 Q130,70 100,100 Q70,70 100,20 Z" fill="#fef08a" stroke="#facc15" strokeWidth="2">
            <animate attributeName="d" dur="0.8s" repeatCount="indefinite" values="M100,20 Q130,70 100,100 Q70,70 100,20 Z; M100,10 Q120,65 100,100 Q80,65 100,10 Z; M100,20 Q130,70 100,100 Q70,70 100,20 Z" />
          </path>
          <path d="M100,40 Q115,70 100,90 Q85,70 100,40 Z" fill="#ef4444" opacity="0.8" className="animate-flicker" />
          <path d="M30,100 Q100,180 170,100 L160,100 Q100,160 40,100 Z" fill="#b45309" stroke="#78350f" strokeWidth="2" />
          <path d="M40,100 Q100,160 160,100" fill="#d97706" />
          <path d="M30,100 Q100,130 170,100" fill="none" stroke="#fcd34d" strokeWidth="3" strokeDasharray="5,5" />
          <circle cx="100" cy="60" r="30" fill="#fef08a" opacity="0.3" className="animate-pulse" />
        </svg>
      </div>
      <h1 className="text-5xl text-yellow-200 mb-2 script-font animate-fade-in drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">Happy Diwali</h1>
      <p className="text-white text-lg tracking-widest uppercase font-bold animate-fade-in" style={{ animationDelay: '0.5s' }}>Festival of Flavors</p>
      <div className="mt-10 w-48 h-2 bg-red-900 rounded-full overflow-hidden relative border border-yellow-400">
        <div className="absolute h-full bg-yellow-400 transition-all duration-[2500ms] ease-out" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );

  const renderHoliLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#ffffff', overflow: 'hidden' }}>
      <div className="absolute top-10 left-10 w-32 h-32 bg-yellow-300 rounded-full blur-2xl opacity-60 animate-bounce-slow"></div>
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-pink-400 rounded-full blur-2xl opacity-60 animate-bounce-slow" style={{ animationDelay: '1s' }}></div>
      <div className="absolute top-1/2 left-10 w-24 h-24 bg-blue-400 rounded-full blur-2xl opacity-60 animate-bounce-slow" style={{ animationDelay: '0.5s' }}></div>
      <div className="relative w-64 h-64 mb-4 flex items-center justify-center">
        <svg viewBox="0 0 200 200" className="w-full h-full animate-wiggle drop-shadow-xl">
          <path d="M140,60 Q160,40 180,50" stroke="#3b82f6" strokeWidth="4" strokeDasharray="5,5" className="animate-pulse" />
          <circle cx="185" cy="50" r="5" fill="#3b82f6" className="animate-ping" />
          <rect x="60" y="80" width="80" height="40" rx="5" transform="rotate(-45 100 100)" fill="#ec4899" stroke="#be185d" strokeWidth="2" />
          <rect x="40" y="100" width="30" height="10" transform="rotate(-45 55 105)" fill="#f59e0b" />
          <rect x="110" y="30" width="10" height="40" transform="rotate(-45 115 50)" fill="#fbbf24" stroke="#d97706" strokeWidth="2" />
          <circle cx="50" cy="150" r="25" fill="#8b5cf6" stroke="#6d28d9" strokeWidth="2" />
          <path d="M50,125 L75,100" stroke="#6d28d9" strokeWidth="4" />
        </svg>
      </div>
      <h1 className="text-6xl mb-2 fun-font animate-pop text-gradient drop-shadow-sm">Happy Holi!</h1>
      <p className="text-gray-500 text-lg tracking-widest uppercase font-bold animate-fade-in" style={{ animationDelay: '0.5s' }}>Splash of Flavors</p>
      <div className="mt-10 w-48 h-2 bg-gray-100 rounded-full overflow-hidden relative border border-pink-200">
        <div className="absolute h-full bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 transition-all duration-[2500ms] ease-out" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );

  const renderSpringLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#fff0f5', overflow: 'hidden' }}>
      <div className="absolute top-[-10%] left-[-10%] w-64 h-64 bg-yellow-200 rounded-full blur-3xl opacity-30 animate-pulse-soft"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-64 h-64 bg-pink-200 rounded-full blur-3xl opacity-30 animate-pulse-soft" style={{ animationDelay: '1s' }}></div>
      <div className="relative w-56 h-56 mb-4 flex items-center justify-center">
        <svg viewBox="0 0 200 200" className="w-full h-full animate-bloom origin-center drop-shadow-2xl">
          <circle cx="100" cy="100" r="15" fill="#f59e0b" />
          <g fill="#fb7185" opacity="0.9">
            <ellipse cx="100" cy="70" rx="12" ry="30" transform="rotate(0 100 100)" />
            <ellipse cx="100" cy="70" rx="12" ry="30" transform="rotate(60 100 100)" />
            <ellipse cx="100" cy="70" rx="12" ry="30" transform="rotate(120 100 100)" />
            <ellipse cx="100" cy="70" rx="12" ry="30" transform="rotate(180 100 100)" />
            <ellipse cx="100" cy="70" rx="12" ry="30" transform="rotate(240 100 100)" />
            <ellipse cx="100" cy="70" rx="12" ry="30" transform="rotate(300 100 100)" />
          </g>
          <g fill="#fda4af" opacity="0.6" stroke="#fff" strokeWidth="1">
            <ellipse cx="100" cy="55" rx="15" ry="40" transform="rotate(30 100 100)" />
            <ellipse cx="100" cy="55" rx="15" ry="40" transform="rotate(90 100 100)" />
            <ellipse cx="100" cy="55" rx="15" ry="40" transform="rotate(150 100 100)" />
            <ellipse cx="100" cy="55" rx="15" ry="40" transform="rotate(210 100 100)" />
            <ellipse cx="100" cy="55" rx="15" ry="40" transform="rotate(270 100 100)" />
            <ellipse cx="100" cy="55" rx="15" ry="40" transform="rotate(330 100 100)" />
          </g>
        </svg>
      </div>
      <h1 className="text-6xl text-rose-500 mb-1 script-font animate-fade-in drop-shadow-sm" style={{ animationDelay: '0.8s' }}>Namaste</h1>
      <p className="text-slate-500 text-lg tracking-[0.4em] uppercase font-light animate-fade-in" style={{ animationDelay: '1.2s' }}>Atithi Devo Bhava</p>
      <div className="mt-10 w-48 h-1.5 bg-rose-100 rounded-full overflow-hidden relative">
        <div className="absolute h-full bg-gradient-to-r from-yellow-400 via-rose-400 to-purple-400 transition-all duration-[2500ms] ease-out" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );


  const renderChristmasLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#14532d', overflow: 'hidden' }}>
      <div className="absolute top-10 left-10 w-32 h-32 bg-red-500 rounded-full blur-3xl opacity-40 animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-yellow-400 rounded-full blur-3xl opacity-40 animate-pulse" style={{ animationDelay: '1s' }}></div>
      <div className="relative w-64 h-64 mb-6 flex items-center justify-center">
        <svg viewBox="0 0 200 200" className="w-full h-full animate-sway drop-shadow-2xl">
          <path d="M100,20 L130,60 L70,60 Z" fill="#16a34a" />
          <path d="M100,40 L140,90 L60,90 Z" fill="#15803d" />
          <path d="M100,70 L150,130 L50,130 Z" fill="#166534" />
          <rect x="90" y="130" width="20" height="40" fill="#78350f" />
          <polygon points="100,10 105,25 120,25 108,35 112,50 100,40 88,50 92,35 80,25 95,25" fill="#facc15" className="animate-twinkle" />
          <circle cx="90" cy="50" r="4" fill="#ef4444" className="animate-pulse" />
          <circle cx="110" cy="80" r="4" fill="#facc15" className="animate-pulse" style={{ animationDelay: '0.5s' }} />
          <circle cx="80" cy="110" r="4" fill="#3b82f6" className="animate-pulse" style={{ animationDelay: '1s' }} />
          <circle cx="120" cy="110" r="4" fill="#ec4899" className="animate-pulse" style={{ animationDelay: '1.5s' }} />
        </svg>
      </div>
      <h1 className="text-6xl mb-2 festive-font animate-pop-in text-white drop-shadow-md text-center transform -rotate-2">Merry Christmas</h1>
      <p className="text-yellow-300 text-lg tracking-widest uppercase font-bold animate-fade-in mt-2" style={{ animationDelay: '0.5s' }}>Tis the season to eat!</p>
      <div className="mt-12 w-56 h-3 bg-red-900 rounded-full overflow-hidden relative border border-yellow-500">
        <div className="absolute h-full bg-gradient-to-r from-red-500 via-green-500 to-red-500 transition-all duration-[2500ms] ease-out" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );

  const renderEidLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#022c22', overflow: 'hidden' }}>
      <div className="absolute top-[-10%] left-[-10%] w-64 h-64 bg-emerald-600 rounded-full blur-[120px] opacity-40 animate-pulse"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-64 h-64 bg-yellow-500 rounded-full blur-[120px] opacity-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
      <div className="relative w-56 h-56 mb-4 flex items-center justify-center">
        <svg viewBox="0 0 200 200" className="w-full h-full animate-moon origin-center drop-shadow-[0_0_20px_rgba(212,175,55,0.6)]">
          <path d="M100,20 A80,80 0 1,0 180,100 A60,60 0 1,1 100,20" fill="#d4af37" />
          <polygon points="135,50 140,65 155,65 143,75 147,90 135,80 123,90 127,75 115,65 130,65" fill="#fef3c7" className="animate-twinkle" />
        </svg>
      </div>
      <h1 className="text-6xl text-amber-400 mb-1 script-font animate-fade-in drop-shadow-md" style={{ animationDelay: '0.8s' }}>Eid Mubarak</h1>
      <p className="text-emerald-200/60 text-lg tracking-[0.3em] uppercase font-light animate-fade-in" style={{ animationDelay: '1.2s' }}>Feast with Joy</p>
      <div className="mt-10 w-48 h-1.5 bg-emerald-900 rounded-full overflow-hidden relative">
        <div className="absolute h-full bg-gradient-to-r from-amber-400 via-yellow-500 to-amber-400 transition-all duration-[2500ms] ease-out shadow-[0_0_10px_#d4af37]" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );

  const renderMakarSankrantiLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#bae6fd', overflow: 'hidden' }}>
      <div className="absolute top-10 right-10 w-32 h-32 bg-yellow-300 rounded-full blur-xl opacity-80 animate-pulse"></div>
      <div className="absolute top-1/4 left-[-50px] text-white opacity-60 text-9xl animate-pulse"><i className="fas fa-cloud"></i></div>
      <div className="absolute bottom-1/4 right-[-50px] text-white opacity-40 text-8xl"><i className="fas fa-cloud"></i></div>
      <div className="relative w-64 h-64 mb-6 flex items-center justify-center">
        <svg viewBox="0 0 200 200" className="w-full h-full animate-kite drop-shadow-xl">
          <path d="M100,150 Q120,250 80,300" stroke="#f0f9ff" strokeWidth="2" fill="none" opacity="0.6" />
          <path d="M100,20 L160,80 L100,150 L40,80 Z" fill="#ec4899" stroke="#be185d" strokeWidth="2" />
          <path d="M100,20 L160,80 L100,80 Z" fill="#f472b6" />
          <path d="M40,80 L100,80 L100,150 Z" fill="#db2777" />
          <path d="M40,80 L160,80" stroke="#fcd34d" strokeWidth="2" />
          <path d="M100,20 L100,150" stroke="#fcd34d" strokeWidth="2" />
          <path d="M100,150 L85,170 L115,170 Z" fill="#f59e0b" />
        </svg>
      </div>
      <h1 className="text-6xl mb-2 festive-font animate-pop-in text-gradient drop-shadow-sm text-center transform -rotate-2">Kai Po Che!</h1>
      <p className="text-sky-700 text-lg tracking-widest uppercase font-bold animate-fade-in mt-2" style={{ animationDelay: '0.5s' }}>Happy Makar Sankranti</p>
      <div className="mt-12 w-56 h-3 bg-white/50 rounded-full overflow-hidden relative border border-white">
        <div className="absolute h-full bg-gradient-to-r from-orange-400 via-pink-500 to-yellow-400 transition-all duration-[2500ms] ease-out" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );

  const renderNavratriLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#fff7ed', overflow: 'hidden' }}>
      <div className="absolute top-[-10%] left-[-10%] w-64 h-64 bg-orange-400 rounded-full blur-[100px] opacity-30 animate-pulse"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-64 h-64 bg-yellow-400 rounded-full blur-[100px] opacity-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
      <div className="relative w-56 h-56 mb-4 flex items-center justify-center">
        <svg viewBox="0 0 200 200" className="w-full h-full animate-sway origin-center drop-shadow-xl">
          <circle cx="100" cy="70" r="25" fill="#78350f" />
          <path d="M100,45 Q115,30 100,10 Q85,30 100,45" fill="#15803d" />
          <path d="M75,60 Q60,40 85,55" fill="#15803d" />
          <path d="M125,60 Q140,40 115,55" fill="#15803d" />
          <path d="M60,90 Q100,70 140,90 L130,160 Q100,180 70,160 Z" fill="#b91c1c" />
          <path d="M60,90 Q100,110 140,90" fill="none" stroke="#facc15" strokeWidth="4" />
          <path d="M85,115 L115,115 M100,100 L100,130" stroke="#facc15" strokeWidth="3" strokeLinecap="round" />
          <path d="M85,115 L85,105 M115,115 L115,125 M100,100 L110,100 M100,130 L90,130" stroke="#facc15" strokeWidth="3" strokeLinecap="round" />
        </svg>
      </div>
      <h1 className="text-6xl text-orange-700 mb-1 script-font animate-fade-in drop-shadow-sm" style={{ animationDelay: '0.8s' }}>Jai Mata Di</h1>
      <p className="text-orange-900/60 text-lg tracking-[0.3em] uppercase font-light animate-fade-in" style={{ animationDelay: '1.2s' }}>Shubh Navratri</p>
      <div className="mt-10 w-48 h-1.5 bg-orange-100 rounded-full overflow-hidden relative border border-orange-200">
        <div className="absolute h-full bg-gradient-to-r from-orange-500 via-yellow-500 to-red-600 transition-all duration-[2500ms] ease-out shadow-[0_0_10px_#f97316]" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );

  const renderSummerLoader = (progress) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#fffbf0', overflow: 'hidden' }}>
      <div className="absolute top-[-20%] left-[-15%] w-96 h-96 rounded-full blur-[80px] animate-pulse-slow" style={{ background: `radial-gradient(circle, rgba(255, 159, 67, 0.3), transparent 70%)` }}></div>
      <div className="absolute bottom-[-20%] right-[-15%] w-96 h-96 rounded-full blur-[80px] animate-pulse-slow" style={{ background: `radial-gradient(circle, rgba(225, 112, 85, 0.2), transparent 70%)` }}></div>

      <div className="relative w-40 h-40 mb-8 flex items-center justify-center scale-95">
        {/* Animated Sun Rings */}
        <svg viewBox="0 0 200 200" className="absolute w-full h-full animate-spin-slow origin-center">
          <circle cx="100" cy="100" r="80" fill="none" stroke="#ff9f43" strokeWidth="1.5" strokeDasharray="15 15" opacity="0.4" />
          <path d="M100,10 L100,30 M100,170 L100,190 M10,100 L30,100 M170,100 L190,100 M36,36 L50,50 M150,150 L164,164 M36,164 L50,150 M150,50 L164,36" stroke="#ff9f43" strokeWidth="3" strokeLinecap="round" opacity="0.6" />
        </svg>

        <svg viewBox="0 0 100 100" className="absolute w-3/4 h-3/4 animate-spin-reverse-fast origin-center">
          <circle cx="50" cy="50" r="38" fill="none" stroke="#e17055" strokeWidth="2.5" strokeDasharray="50 150" strokeLinecap="round" opacity="0.8" className="drop-shadow-md" />
        </svg>

        {/* Mango Icon */}
        <svg viewBox="0 0 200 200" className="absolute w-1/2 h-1/2 drop-shadow-lg">
          <path d="M75,140 Q60,110 85,80 Q100,60 115,80 Q140,110 125,140 L100,160 L75,140 Z" fill="#e17055" />
          <path d="M85,80 L100,110 L115,80" fill="none" stroke="#fff" strokeWidth="2" opacity="0.5" />
        </svg>
      </div>

      <div className="relative flex flex-col items-center justify-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-2 tracking-wide script-font text-[#ff9f43]">
          Namaste 🙏
        </h2>
        <p className="text-sm md:text-base tracking-[0.2em] font-medium opacity-80 text-[#e17055]">
          Atithi Devo Bhava
        </p>
      </div>

      <div className="mt-10 w-56 h-1.5 bg-orange-100/50 rounded-full overflow-hidden relative backdrop-blur-sm border border-orange-200/50">
        <div className="absolute h-full rounded-full"
          style={{
            width: `${progress}%`,
            background: `linear-gradient(90deg, #ff9f43, #e17055)`,
            boxShadow: `0 0 10px rgba(255, 159, 67, 0.4)`,
            transition: 'width 0.1s linear'
          }}>
        </div>
      </div>
    </div>
  );

  const renderRoyalRajasthanLoader = (progress) => (
    (() => {
      const loaded = royalLoaderOpened;
      return (
        <div className={`rr-loader fixed inset-0 pointer-events-none flex flex-col ${loaded ? 'loaded' : ''}`} style={{ position: 'fixed', inset: 0, zIndex: 60, pointerEvents: 'none', display: 'flex', flexDirection: 'column' }}>
          <div className="shutter-panel shutter-top bg-orange-600 w-full relative z-10 flex flex-col items-center justify-end pb-4" style={{ background: '#ea580c', width: '100%', height: '50vh', position: 'relative', zIndex: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', paddingBottom: 16 }}>
            <div className="relative w-64 h-64 animate-float" style={{ position: 'relative', width: 256, height: 256 }}>
              <div style={{ position: 'absolute', inset: 0, background: '#fbbf24', borderRadius: '9999px', filter: 'blur(48px)', opacity: 0.2 }}></div>
              <svg viewBox="0 0 200 240" style={{ width: '100%', height: '100%', filter: 'drop-shadow(0 25px 25px rgba(0,0,0,0.15))' }}>
                <defs>
                  <linearGradient id="skinGrad" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#feeec9" /><stop offset="100%" stopColor="#f5cca0" /></linearGradient>
                  <linearGradient id="clothGrad" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#ffb347" /><stop offset="100%" stopColor="#ffcc33" /></linearGradient>
                </defs>
                <g transform="translate(0, 10)">
                  <path d="M60 230 L60 140 Q60 110 100 110 Q140 110 140 140 L140 230" fill="url(#clothGrad)" stroke="black" strokeWidth="2" />
                  <path d="M60 230 L140 230" stroke="black" strokeWidth="2" fill="url(#clothGrad)" />
                  <path d="M60 140 Q100 140 140 200" fill="none" stroke="black" strokeWidth="1.5" strokeDasharray="4 2" />
                  <circle cx="100" cy="150" r="2.5" fill="#92400e" stroke="black" strokeWidth="0.5" />
                  <circle cx="112" cy="165" r="2.5" fill="#92400e" stroke="black" strokeWidth="0.5" />
                  <circle cx="125" cy="180" r="2.5" fill="#92400e" stroke="black" strokeWidth="0.5" />
                  <path d="M85 110 L85 100 Q100 105 115 100 L115 110 L100 120 Z" fill="#feeec9" stroke="black" strokeWidth="1.5" />
                </g>
                <g className="animate-head-move">
                  <rect x="75" y="60" width="50" height="55" rx="20" ry="20" fill="url(#skinGrad)" stroke="black" strokeWidth="2" />
                  <circle cx="75" cy="85" r="6" fill="url(#skinGrad)" stroke="black" strokeWidth="1.5" />
                  <circle cx="125" cy="85" r="6" fill="url(#skinGrad)" stroke="black" strokeWidth="1.5" />
                  <path d="M70 60 Q60 30 100 25 Q140 30 130 60 Q100 70 70 60 Z" fill="#ef4444" stroke="black" strokeWidth="2" />
                  <path d="M70 50 Q100 30 130 50" fill="none" stroke="black" strokeWidth="1.5" />
                  <path d="M75 40 Q100 20 125 40" fill="none" stroke="black" strokeWidth="1.5" />
                  <circle cx="100" cy="40" r="4" fill="#fbbf24" stroke="black" strokeWidth="1" />
                  <circle cx="88" cy="82" r="2.5" fill="#1f2937" />
                  <circle cx="112" cy="82" r="2.5" fill="#1f2937" />
                  <path d="M84 76 Q90 74 94 76" fill="none" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                  <path d="M106 76 Q110 74 116 76" fill="none" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                  <path className="animate-mustache-move" d="M100 95 Q115 90 125 92 Q120 98 110 96 L100 98 L90 96 Q80 98 75 92 Q85 90 100 95" fill="#1f2937" stroke="black" strokeWidth="0.5" />
                  <path d="M92 105 Q100 112 108 105" fill="none" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                  <path d="M100 70 L100 62" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" />
                </g>
                <g className="animate-hands-move" transform="translate(0, 8)">
                  <path d="M60 125 Q50 160 85 160" fill="none" stroke="black" strokeWidth="16" strokeLinecap="round" />
                  <path d="M60 125 Q50 160 85 160" fill="none" stroke="url(#clothGrad)" strokeWidth="13" strokeLinecap="round" />
                  <path d="M140 125 Q150 160 115 160" fill="none" stroke="black" strokeWidth="16" strokeLinecap="round" />
                  <path d="M140 125 Q150 160 115 160" fill="none" stroke="url(#clothGrad)" strokeWidth="13" strokeLinecap="round" />
                  <circle cx="85" cy="160" r="8" fill="url(#clothGrad)" stroke="black" strokeWidth="2" />
                  <circle cx="115" cy="160" r="8" fill="url(#clothGrad)" stroke="black" strokeWidth="2" />
                  <g transform="translate(100, 150)">
                    <path d="M-4 18 L-10 5 Q-12 -8 -4 -15 L 0 -18 L 4 -15 Q 12 -8 10 5 L 4 18 Z" fill="none" stroke="black" strokeWidth="3.5" strokeLinejoin="round" />
                    <path d="M-4 18 L-10 5 Q-12 -8 -4 -15 L 0 -18" fill="#feeec9" stroke="none" />
                    <path d="M-4 18 L-14 8 Q-18 -5 -10 -15 L 0 -18" fill="#f5cca0" stroke="none" />
                    <path d="M4 18 L10 5 Q12 -8 4 -15 L 0 -18" fill="#feeec9" stroke="none" />
                    <path d="M4 18 L14 8 Q18 -5 10 -15 L 0 -18" fill="#f5cca0" stroke="none" />
                    <line x1="0" y1="-18" x2="0" y2="18" stroke="black" strokeWidth="1" />
                    <path d="M-8 -5 Q-4 0 -4 -10" fill="none" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M8 -5 Q4 0 4 -10" fill="none" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                  </g>
                </g>
              </svg>
            </div>
            <h1 className="text-4xl font-black text-white tracking-tight" style={{ fontSize: 36, fontWeight: 900, color: 'white', letterSpacing: '-0.025em', opacity: 1 }}>Namaste</h1>
          </div>

          <div className="shutter-panel shutter-bottom bg-orange-600 w-full relative z-10 flex flex-col items-center justify-start pt-4 px-6" style={{ background: '#ea580c', height: '50vh', width: '100%', position: 'relative', zIndex: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', paddingTop: 16, paddingLeft: 24, paddingRight: 24 }}>
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', top: -16, left: -16, fontSize: 48, color: 'rgba(255,255,255,0.2)', fontFamily: 'serif' }}>❝</span>
              <p className="text-xl font-serif italic text-white font-bold" style={{ fontSize: 20, fontFamily: 'serif', fontStyle: 'italic', color: 'white', fontWeight: 700, opacity: 1 }}>Atithi Devo Bhava</p>
              <span style={{ position: 'absolute', bottom: -24, right: -16, fontSize: 48, color: 'rgba(255,255,255,0.2)', fontFamily: 'serif' }}>❞</span>
            </div>
          </div>
        </div>
      );
    })()
  );

  const renderMinimalFallbackLoader = (theme, progress) => (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', background: theme.splashBg, overflow: 'hidden'
    }}>
      <div className="absolute top-[-20%] left-[-15%] w-96 h-96 rounded-full blur-[80px] animate-pulse-slow" style={{ background: `radial-gradient(circle, ${theme.primaryColor}20, transparent 70%)` }}></div>
      <div className="absolute bottom-[-20%] right-[-15%] w-96 h-96 rounded-full blur-[80px] animate-pulse-slow" style={{ background: `radial-gradient(circle, ${theme.secondaryColor}15, transparent 70%)`, animationDelay: '2s' }}></div>

      <div className="relative w-32 h-32 mb-8 flex items-center justify-center">
        <svg viewBox="0 0 100 100" className="absolute w-full h-full animate-spin-slow origin-center">
          <circle cx="50" cy="50" r="46" fill="none" stroke={theme.primaryColor} strokeWidth="1.5" strokeDasharray="15 10" opacity="0.3" />
        </svg>
        <svg viewBox="0 0 100 100" className="absolute w-full h-full animate-spin-reverse-fast origin-center">
          <circle cx="50" cy="50" r="38" fill="none" stroke={theme.primaryColor} strokeWidth="2" strokeDasharray="60 180" strokeLinecap="round" opacity="0.8" className="drop-shadow-lg" />
        </svg>
        <div className="w-4 h-4 rounded-full blur-[1px]" style={{ background: theme.primaryColor, boxShadow: `0 0 20px ${theme.primaryColor}` }}></div>
      </div>

      <div className="relative w-full h-24 flex flex-col items-center justify-center">
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" style={{ animation: 'seq-fade-1 3.5s cubic-bezier(0.4, 0, 0.2, 1) forwards' }}>
          <h2 className="text-3xl md:text-5xl font-bold mb-2 tracking-wide" style={{ color: theme.primaryColor, fontFamily: theme.font }}>
            Namaste 🙏
          </h2>
          <p className="text-sm md:text-base tracking-[0.2em] font-medium opacity-80" style={{ color: theme.isDark ? '#cbd5e1' : '#64748b' }}>
            Atithi Devo Bhava
          </p>
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none opacity-0" style={{ animation: 'seq-fade-2 1s cubic-bezier(0.4, 0, 0.2, 1) 3s forwards' }}>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-center" style={{ color: theme.isDark ? '#fff' : theme.primaryColor, fontFamily: theme.font }}>
            {theme.splashTitle}
          </h1>
          <p className="text-xs md:text-sm uppercase tracking-widest font-medium mt-3 opacity-80" style={{ color: theme.isDark ? '#cbd5e1' : '#64748b' }}>
            {theme.splashSubtitle}
          </p>
        </div>
      </div>

      <div className="mt-12 w-48 h-1 bg-black/5 dark:bg-white/10 rounded-full overflow-hidden relative backdrop-blur-sm">
        <div className="absolute h-full transition-all duration-[2000ms] ease-out rounded-full"
          style={{
            width: `${progress}%`,
            background: `linear-gradient(90deg, ${theme.primaryColor}, ${theme.secondaryColor})`,
            boxShadow: `0 0 10px ${theme.primaryColor}50`
          }}>
        </div>
      </div>
    </div>
  );

  const SplashScreen = () => {
    if (!showSplash || !themeReady || isNewDevelopmentTheme) return null;

    switch (templateKey) {
      case 'Autumn': return renderAutumnLoader(loadingProgress);
      case 'Winter': return renderWinterLoader(loadingProgress);
      case 'Diwali': return renderDiwaliLoader(loadingProgress);
      case 'Holi': return renderHoliLoader(loadingProgress);
      case 'Spring': return renderSpringLoader(loadingProgress);
      case 'Christmas': return renderChristmasLoader(loadingProgress);
      case 'Eid': return renderEidLoader(loadingProgress);
      case 'Makar Sankranti': return renderMakarSankrantiLoader(loadingProgress);
      case 'Navratri': return renderNavratriLoader(loadingProgress);
      case 'Summer': return renderSummerLoader(loadingProgress);
      case 'Royal Rajasthan': return renderRoyalRajasthanLoader(loadingProgress);
      default: return renderMinimalFallbackLoader(currentTheme, loadingProgress);
    }
  };

  return (
    <>
      <style>{styles}</style>
      {!isRajasthanTheme && <ThemeEffects themeName={templateKey} />}
      <ToastContainer position="top-right" autoClose={2000} style={{ zIndex: 99999 }} />

      {showOrderConfirmPopup && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15, 23, 42, 0.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9990,
            padding: '16px',
            animation: 'fadeIn 0.25s ease-out'
          }}
          onClick={() => setShowOrderConfirmPopup(false)}
        >
          <div
            style={{
              width: '100%',
              maxWidth: '520px',
              borderRadius: '18px',
              background: currentTheme.isDark ? '#0f172a' : '#ffffff',
              color: currentTheme.isDark ? '#f8fafc' : '#0f172a',
              border: `1px solid ${currentTheme.isDark ? 'rgba(148,163,184,0.25)' : '#e2e8f0'}`,
              boxShadow: '0 24px 60px rgba(2, 6, 23, 0.28)',
              padding: '24px',
              animation: 'scaleInCurve 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
              <div>
                <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '800' }}>
                  Payment Confirmed Successfully
                </h3>
              </div>
            </div>
            <p style={{ margin: '0 0 8px 0', fontSize: '14px', lineHeight: '1.6', color: currentTheme.isDark ? '#cbd5e1' : '#475569' }}>
              Your payment was successful.
            </p>
            <p style={{ margin: '0 0 18px 0', fontSize: '14px', lineHeight: '1.6', color: currentTheme.isDark ? '#cbd5e1' : '#475569' }}>
              Contact us for further assistance.
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={() => setShowOrderConfirmPopup(false)}
                style={{
                  padding: '10px 18px',
                  borderRadius: '10px',
                  border: 'none',
                  background: '#10b981',
                  color: '#ffffff',
                  fontSize: '14px',
                  fontWeight: 700,
                  cursor: 'pointer'
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {showNoOnlinePaymentModal && (() => {
        const theme = currentTheme || TEMPLATE_THEMES['Normal'];
        const primary = theme.primaryColor || '#1e293b';
        const isDark = Boolean(theme.isDark);
        const modalBg = isDark
          ? (theme.splashBg ? `linear-gradient(160deg, ${theme.splashBg} 0%, #0b0f19 100%)` : '#0f172a')
          : (theme.gradient?.includes('gradient') ? theme.gradient : '#ffffff');
        const cardBg = isDark
          ? (theme.glassCard || 'rgba(255, 255, 255, 0.04)')
          : 'rgba(0, 0, 0, 0.02)';
        const borderStyle = isDark
          ? `1px solid ${primary}40`
          : `1px solid ${primary}30`;
        const textColor = isDark ? '#f8fafc' : '#0f172a';
        const mutedColor = isDark ? '#94a3b8' : '#64748b';
        const themeFont = theme.font || "'Inter', 'Poppins', sans-serif";

        return (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(15, 23, 42, 0.72)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10005,
              padding: isMobile ? '14px' : '24px'
            }}
            onClick={() => setShowNoOnlinePaymentModal(false)}
          >
            <div
              style={{
                width: '100%',
                maxWidth: '460px',
                borderRadius: '0px',
                background: modalBg,
                color: textColor,
                border: borderStyle,
                boxShadow: `0 24px 60px rgba(0,0,0,0.40), 0 0 20px ${primary}20`,
                padding: isMobile ? '28px 20px' : '32px 28px',
                position: 'relative',
                fontFamily: themeFont,
                animation: 'scaleInCurve 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close button */}
              <button
                type="button"
                onClick={() => setShowNoOnlinePaymentModal(false)}
                style={{
                  position: 'absolute',
                  top: '16px',
                  right: '16px',
                  width: '32px',
                  height: '32px',
                  borderRadius: '0px',
                  border: isDark ? '1px solid rgba(255,255,255,0.15)' : '1px solid rgba(0,0,0,0.12)',
                  background: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.03)',
                  color: mutedColor,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '13px',
                  cursor: 'pointer'
                }}
                aria-label="Close"
              >
                ✕
              </button>

              {/* Header Icon & Title */}
              <div style={{ textAlign: 'center', marginBottom: '22px' }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  margin: '0 auto 16px',
                  borderRadius: '0px',
                  background: isDark ? `${primary}20` : `${primary}10`,
                  border: `1px solid ${primary}35`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: primary
                }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="5" width="20" height="14" rx="0"></rect>
                    <line x1="2" y1="10" x2="22" y2="10"></line>
                  </svg>
                </div>
                <h3 style={{
                  margin: '0 0 10px 0',
                  fontSize: isMobile ? '18px' : '20px',
                  fontWeight: '700',
                  color: textColor,
                  letterSpacing: '0.01em',
                  lineHeight: 1.3
                }}>
                  Online Payments Currently Unavailable
                </h3>
                <p style={{
                  margin: 0,
                  fontSize: isMobile ? '13px' : '14px',
                  lineHeight: '1.6',
                  color: mutedColor,
                  fontWeight: '400'
                }}>
                  We are currently not accepting online payments through the website. Please place your order directly via WhatsApp or phone call.
                </p>
              </div>

              {/* Cart Preview summary if items exist */}
              {cart && cart.length > 0 && (
                <div style={{
                  marginBottom: '22px',
                  padding: '14px',
                  borderRadius: '0px',
                  background: cardBg,
                  border: borderStyle
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                    fontSize: '12px',
                    fontWeight: '700',
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    color: textColor
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={primary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <path d="M16 10a4 4 0 0 1-8 0"></path>
                      </svg>
                      <span>Order Summary ({getCartCount()} items)</span>
                    </div>
                    <span style={{ fontSize: '15px', color: primary, fontWeight: '800' }}>
                      ₹{getCartTotal().toFixed(2)}
                    </span>
                  </div>
                  <div style={{
                    maxHeight: '110px',
                    overflowY: 'auto',
                    fontSize: '12px',
                    color: mutedColor,
                    lineHeight: 1.7
                  }}>
                    {cart.map((item, idx) => (
                      <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0', borderBottom: idx < cart.length - 1 ? (isDark ? '1px solid rgba(255,255,255,0.06)' : '1px solid rgba(0,0,0,0.05)') : 'none' }}>
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '75%' }}>
                          {item.quantity} × {item.productName || item.name}
                        </span>
                        <span>₹{(Number(item.price || 0) * Number(item.quantity || 1)).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Action Buttons */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {/* WhatsApp Button */}
                <button
                  type="button"
                  onClick={handleDirectWhatsAppOrder}
                  style={{
                    width: '100%',
                    padding: '14px 18px',
                    borderRadius: '0px',
                    border: 'none',
                    background: '#25D366',
                    color: '#ffffff',
                    fontSize: isMobile ? '14px' : '15px',
                    fontWeight: '700',
                    letterSpacing: '0.02em',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    transition: 'opacity 0.2s ease'
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2ZM12.05 20.15C10.57 20.15 9.12 19.76 7.85 19.01L7.55 18.83L4.44 19.65L5.27 16.61L5.07 16.29C4.24 14.98 3.81 13.47 3.81 11.91C3.81 7.37 7.5 3.68 12.04 3.68C14.25 3.68 16.31 4.54 17.87 6.1C19.42 7.66 20.28 9.72 20.28 11.92C20.28 16.46 16.59 20.15 12.05 20.15ZM16.57 14.39C16.32 14.26 15.1 13.66 14.87 13.58C14.65 13.5 14.48 13.46 14.32 13.7C14.16 13.95 13.69 14.5 13.55 14.66C13.41 14.83 13.27 14.85 13.02 14.73C12.77 14.6 11.98 14.34 11.04 13.5C10.31 12.85 9.81 12.04 9.67 11.8C9.53 11.55 9.66 11.41 9.78 11.29C9.89 11.18 10.03 11 10.16 10.85C10.28 10.7 10.32 10.58 10.4 10.41C10.48 10.25 10.44 10.1 10.38 9.98C10.32 9.85 9.83 8.65 9.63 8.16C9.43 7.69 9.23 7.75 9.07 7.74C8.93 7.74 8.76 7.73 8.59 7.73C8.43 7.73 8.16 7.79 7.93 8.04C7.71 8.29 7.08 8.87 7.08 10.07C7.08 11.27 7.95 12.43 8.08 12.59C8.2 12.75 9.81 15.24 12.28 16.3C12.87 16.55 13.33 16.71 13.69 16.82C14.28 17.01 14.82 16.98 15.24 16.92C15.71 16.85 16.69 16.33 16.9 15.75C17.1 15.17 17.1 14.68 17.04 14.57C16.98 14.47 16.82 14.51 16.57 14.39Z" />
                  </svg>
                  <span>Order via WhatsApp</span>
                </button>

                {/* Call Button */}
                {getCallNumber() && (
                  <button
                    type="button"
                    onClick={handleDirectCall}
                    style={{
                      width: '100%',
                      padding: '13px 18px',
                      borderRadius: '0px',
                      border: currentTheme.isDark ? `1px solid ${primary}45` : `1.5px solid ${primary}35`,
                      background: currentTheme.isDark ? 'rgba(255,255,255,0.05)' : '#ffffff',
                      color: textColor,
                      fontSize: isMobile ? '14px' : '15px',
                      fontWeight: '700',
                      letterSpacing: '0.02em',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '9px',
                      transition: 'opacity 0.2s ease'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <span>Call Store ({getCallNumber()})</span>
                  </button>
                )}

                {/* Dismiss / Browse Button */}
                <button
                  type="button"
                  onClick={() => setShowNoOnlinePaymentModal(false)}
                  style={{
                    width: '100%',
                    padding: '11px 16px',
                    borderRadius: '0px',
                    border: 'none',
                    background: 'transparent',
                    color: mutedColor,
                    fontSize: '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    marginTop: '2px'
                  }}
                >
                  Return to Menu
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {showSplash && SplashScreen()}

      {restaurant && (
        <>
        <div className={`main-container ${isRajasthanTheme ? 'theme-rajasthan' : 'theme-default'}`} style={{
        '--primary-color': currentTheme.primaryColor,
        '--secondary-color': currentTheme.secondaryColor,
        fontFamily: "'Poppins', sans-serif",
        background: isRajasthanTheme ? '#ffffff' : currentTheme.gradient,
        minHeight: '100vh',
        paddingBottom: '100px',
        color: textColor,
        height: (showSplash && !isNewDevelopmentTheme) ? '100vh' : 'auto',
        overflow: (showSplash && !isNewDevelopmentTheme) ? 'hidden' : 'visible'
      }}>

        {/* Order Type First-Visit Popup */}
        {!isShopMode && showOrderTypePopup && (
          <div className="order-type-popup-overlay" onClick={() => setShowOrderTypePopup(false)}>
            <div className="order-type-popup-card" onClick={(e) => e.stopPropagation()}>
              <h2 style={{ margin: '0 0 8px 0', fontSize: '22px', fontWeight: 800, color: '#1e293b' }}>Select Order Type</h2>
              <p style={{ margin: '0 0 24px 0', fontSize: '14px', color: '#64748b', fontWeight: 500 }}>Choose how you would like to receive your order</p>
              {[
                { key: 'DELIVERY', label: 'Delivery', icon: '🛵' },
                { key: 'TAKEAWAY', label: 'Takeaway', icon: '🥡' },
                { key: 'DRIVETHROUGH', label: 'Drive-through', icon: '🚗' }
              ].map((type) => (
                <button
                  key={type.key}
                  type="button"
                  className={`order-type-option ${fulfillmentType === type.key ? 'selected' : ''}`}
                  onClick={() => selectFulfillmentType(type.key)}
                >
                  <span style={{ fontSize: '20px' }}>{type.icon}</span>
                  <span>{type.label}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {!isNewDevelopmentTheme && descriptionPopupProduct && (
          <div className="order-type-popup-overlay" onClick={() => setDescriptionPopupProduct(null)}>
            <div className="order-type-popup-card" onClick={(e) => e.stopPropagation()} style={{ position: 'relative', paddingTop: '48px', textAlign: 'left' }}>
              <button
                type="button"
                onClick={() => setDescriptionPopupProduct(null)}
                style={{
                  position: 'absolute',
                  top: '16px',
                  right: '16px',
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: 'none',
                  background: '#f1f5f9',
                  color: '#64748b',
                  fontSize: '20px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  lineHeight: 1
                }}
              >
                ×
              </button>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '20px', fontWeight: 800, color: '#1e293b', paddingRight: '40px' }}>
                {descriptionPopupProduct.productName}
              </h3>
              <p style={{ margin: 0, fontSize: '15px', color: '#475569', lineHeight: '1.6', fontWeight: 500 }}>
                {descriptionPopupProduct.description}
              </p>
            </div>
          </div>
        )}

        {!isPremiumCarouselTheme && !isNewDevelopmentTheme && (<>{currentView === 'home' && (
          <div className="content-container home-content-wrapper">

            {/* ── Closed Banner ─────────────────────────────────────────── */}
            {!restaurantOpen && (
              <div style={{
                background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
                color: 'white',
                borderRadius: '16px',
                padding: '20px 24px',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                boxShadow: '0 8px 24px rgba(220, 38, 38, 0.35)',
              }}>
                <span style={{ fontSize: '32px' }}>🔒</span>
                <div>
                  <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '4px' }}>{isShopMode ? 'Shop' : 'Restaurant'} is Currently Closed</div>
                  <div style={{ fontSize: '14px', opacity: 0.9 }}>{closedMessage || 'We are not taking orders right now. Please check back later.'}</div>
                </div>
              </div>
            )}
            {/* ─────────────────────────────────────────────────────────── */}
            {/* Shop Banner — shown if bannerUrl is set */}
            {isShopMode && restaurant.bannerUrl && (
              <div style={{ marginBottom: '16px', borderRadius: '16px', overflow: 'hidden' }}>
                <SafeImage
                  src={resolveMediaUrl(restaurant.bannerUrl, '=s1000')}
                  alt={restaurant.restaurantName}
                  style={{ width: '100%', height: '180px', objectFit: 'cover' }}
                  onError={(e) => { e.target.style.display = 'none'; }}
                  crossOrigin={isExternalUrl(restaurant.bannerUrl) ? "anonymous" : undefined}
                />
              </div>
            )}

            {/* Single Promotional Banner — active promo banner from S3 */}
            {restaurant?.promotionalBanner && restaurant.promotionalBanner.isActive !== false && restaurant.promotionalBanner.imageUrl && (
              <div
                className="promotional-banner-container"
                style={{
                  marginBottom: '20px',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)'
                }}
              >
                <SafeImage
                  src={resolveMediaUrl(restaurant.promotionalBanner.imageUrl, '=s1200')}
                  alt={restaurant.promotionalBanner.altText || restaurant.promotionalBanner.title || 'Special Promotion'}
                  style={{
                    width: '100%',
                    maxHeight: '288px',
                    objectFit: 'cover',
                    borderRadius: '16px',
                    display: 'block'
                  }}
                  onError={(e) => { e.target.style.display = 'none'; }}
                  crossOrigin={isExternalUrl(restaurant.promotionalBanner.imageUrl) ? "anonymous" : undefined}
                />
              </div>
            )}

            {/* Restaurant Name Card — QR template: text-center mt-2 mb-8 */}
            <div style={{
              textAlign: 'center',
              marginTop: '8px',
              marginBottom: '24px'
            }} className="animate-fade-in">
              {/* Avatar circle — clean white circular logo */}
              <div style={{
                width: '120px',
                height: '120px',
                margin: '0 auto 18px',
                background: '#ffffff',
                borderRadius: '50%',
                padding: '6px',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
                position: 'relative'
              }}>
                <div style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  border: '1px solid rgba(0, 0, 0, 0.04)',
                  background: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '40px',
                  overflow: 'hidden'
                }}>
                  {restaurant.logoUrl && !logoLoadError ? (
                    <SafeImage
                      src={resolveMediaUrl(restaurant.logoUrl, '=s400')}
                      alt={restaurant.restaurantName}
                      style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                      fallback={
                        <span style={{ fontSize: '36px', fontWeight: 700, color: '#c9a96e' }}>
                          {getInitials(restaurant.restaurantName)}
                        </span>
                      }
                      onError={(e) => {
                        console.error('[DEBUG_LOG] Image tag failed to load logo image. Attempted URL:', resolveMediaUrl(restaurant.logoUrl, '=s400'), e);
                        setLogoLoadError(true);
                      }}
                    />
                  ) : (
                    <span style={{ fontSize: '36px', fontWeight: 700, color: '#c9a96e' }}>
                      {getInitials(restaurant.restaurantName)}
                    </span>
                  )}
                </div>
              </div>
              {/* Name & Veg Only Switch */}
              <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '14px', flexWrap: 'wrap', marginBottom: '8px' }}>
                <h1 style={{
                  fontSize: '40px',
                  fontWeight: 900,
                  color: '#0f172a',
                  margin: 0,
                  fontFamily: "'Inter', 'Poppins', sans-serif",
                  letterSpacing: '-0.03em',
                  lineHeight: '1.05'
                }}>
                  {restaurant.restaurantName}
                </h1>

                {/* Veg Only Switch - Near restaurant name */}
                {hasNonVegItems && (
                  <button
                    type="button"
                    onClick={() => setVegOnlyFilter((prev) => !prev)}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '5px 12px',
                      borderRadius: '999px',
                      border: `1.5px solid ${vegOnlyFilter ? '#16a34a' : (currentTheme.isDark ? 'rgba(255,255,255,0.2)' : '#cbd5e1')}`,
                      backgroundColor: vegOnlyFilter ? 'rgba(22, 163, 74, 0.12)' : (currentTheme.isDark ? 'rgba(255,255,255,0.05)' : '#ffffff'),
                      color: vegOnlyFilter ? '#16a34a' : textColor,
                      fontWeight: '700',
                      fontSize: '13px',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      boxShadow: vegOnlyFilter ? '0 2px 8px rgba(22, 163, 74, 0.2)' : '0 1px 3px rgba(0,0,0,0.05)'
                    }}
                    title="Toggle Vegetarian Only Items"
                  >
                    <div style={{
                      width: '14px', height: '14px',
                      border: '1.5px solid #16a34a',
                      borderRadius: '3px',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: '#ffffff'
                    }}>
                      <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#16a34a' }} />
                    </div>
                    <span>Veg Only</span>
                    <div style={{
                      width: '30px',
                      height: '16px',
                      borderRadius: '999px',
                      background: vegOnlyFilter ? '#16a34a' : '#cbd5e1',
                      position: 'relative',
                      transition: 'background 0.2s',
                      marginLeft: '2px'
                    }}>
                      <div style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        background: '#ffffff',
                        position: 'absolute',
                        top: '2px',
                        left: vegOnlyFilter ? '16px' : '2px',
                        transition: 'left 0.2s'
                      }} />
                    </div>
                  </button>
                )}
              </div>
              {/* Subtitle */}
              <p style={{
                fontSize: '17px',
                color: '#64748b',
                fontWeight: 500,
                marginTop: '0',
                letterSpacing: '0.01em'
              }}>
                {restaurant.cuisineType || (isShopMode ? 'Daily Essentials' : 'Delicious Food')}
              </p>
              <div className="decorative-divider">
                <span className="decorative-divider-dot"></span>
              </div>
            </div>

            {/* Quick Access - Social Action Buttons with Labels */}
            {(restaurant.contactPhone || restaurant.instagramUrl || restaurant.mapLocation || restaurant.facebookUrl) && (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                gap: '20px',
                flexWrap: 'wrap',
                marginBottom: '28px',
                padding: '0 8px'
              }} className="animate-fade-in">
                {restaurant.contactPhone && (
                  <a
                    href={`tel:${restaurant.contactPhone}`}
                    className="social-action-btn"
                  >
                    <div className="social-action-icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                      </svg>
                    </div>
                    <span className="social-action-label">Call</span>
                  </a>
                )}

                {restaurant.instagramUrl && (
                  <a
                    href={restaurant.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-action-btn"
                  >
                    <div className="social-action-icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient id="instagramGrad" x1="0%" y1="100%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#f09433"/>
                            <stop offset="25%" stopColor="#e6683c"/>
                            <stop offset="50%" stopColor="#dc2743"/>
                            <stop offset="75%" stopColor="#cc2366"/>
                            <stop offset="100%" stopColor="#bc1888"/>
                          </linearGradient>
                        </defs>
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="url(#instagramGrad)"/>
                        <rect x="6.5" y="6.5" width="11" height="11" rx="3.5" fill="none" stroke="#ffffff" strokeWidth="1.6"/>
                        <circle cx="12" cy="12" r="2.7" fill="none" stroke="#ffffff" strokeWidth="1.6"/>
                        <circle cx="17" cy="7" r="1" fill="#ffffff"/>
                      </svg>
                    </div>
                    <span className="social-action-label">Instagram</span>
                  </a>
                )}

                {restaurant.mapLocation && (
                  <a
                    href={restaurant.mapLocation}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-action-btn"
                  >
                    <div className="social-action-icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="#EA4335" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                      </svg>
                    </div>
                    <span className="social-action-label">Location</span>
                  </a>
                )}

                {restaurant.facebookUrl && (
                  <a
                    href={restaurant.facebookUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-action-btn"
                  >
                    <div className="social-action-icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="#1877F2" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.81 9-9.95z"/>
                      </svg>
                    </div>
                    <span className="social-action-label">Facebook</span>
                  </a>
                )}
              </div>
            )}

            {/* Explore Our Menu Card */}
            <div
              onClick={() => setCurrentView('menu')}
              className="signature-menu-card animate-fade-in"
              style={{
                background: currentTheme.isDark ? 'rgba(255, 255, 255, 0.08)' : '#ffffff',
                marginBottom: '20px'
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="signature-menu-icon" style={{ marginBottom: '16px' }}>
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5.5 18h13"/>
                    <path d="M12 10v-6"/>
                    <path d="M12 10c-3.5 0-6.5 2-7.5 5h15c-1-3-4-5-7.5-5z"/>
                    <path d="M8 4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2"/>
                    <path d="M2 20h20"/>
                  </svg>
                </div>
                <h2 style={{
                  fontSize: '26px',
                  fontWeight: 800,
                  margin: '0 0 8px 0',
                  color: currentTheme.isDark ? '#ffffff' : '#0f172a',
                  letterSpacing: '-0.02em'
                }}>
                  {isShopMode ? 'Our Products' : 'Explore Our Menu'}
                </h2>
                <div className="decorative-divider" style={{ color: '#c9a96e', justifyContent: 'flex-start', margin: '8px 0 10px' }}>
                  <span className="decorative-divider-dot"></span>
                </div>
                <p style={{
                  fontSize: '15px',
                  color: currentTheme.isDark ? '#cbd5e1' : '#64748b',
                  margin: 0,
                  fontWeight: 500,
                  lineHeight: '1.5'
                }}>
                  {isShopMode ? 'Best quality at best prices ✨' : (
                    <>Freshly prepared dishes<br />crafted for you</>
                  )}
                </p>
              </div>
              <div className="signature-menu-arrow" style={{
                borderColor: currentTheme.isDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.06)',
                color: '#c9a96e'
              }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>



            {/* Website Card */}
            {restaurant.websiteUrl && (
              <a
                href={restaurant.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="website-card animate-fade-in"
                style={{
                  background: currentTheme.isDark ? 'rgba(255, 255, 255, 0.08)' : '#ffffff',
                  color: currentTheme.isDark ? '#ffffff' : '#1e293b',
                  marginBottom: '24px'
                }}
              >
                <div className="website-card-icon">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="2" y1="12" x2="22" y2="12"></line>
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                  </svg>
                </div>
                <span style={{
                  flex: 1,
                  fontSize: '17px',
                  fontWeight: 700,
                  textAlign: 'left'
                }}>
                  Visit Our Website
                </span>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="M12 5l7 7-7 7"></path>
                </svg>
              </a>
            )}
          </div>
        )}

        {currentView === 'menu' && (
          <div className="content-container">
            {/* ── Top Header Navigation Bar (All Themes) ─────────────────────────────────── */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '8px',
              marginBottom: '14px',
              width: '100%',
              padding: '6px 2px'
            }}>
              {/* Left: Back button + Restaurant Name/Cuisine */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                minWidth: 0,
                flex: 1
              }}>
                <button
                  type="button"
                  onClick={() => setCurrentView('home')}
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    border: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)'}`,
                    background: currentTheme.isDark ? 'rgba(255,255,255,0.08)' : '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    flexShrink: 0,
                    color: textColor
                  }}
                  title="Back to Home"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M19 12H5"></path>
                    <path d="M12 19l-7-7 7-7"></path>
                  </svg>
                </button>
                <div style={{ minWidth: 0, overflow: 'hidden' }}>
                  <h1 style={{
                    fontSize: '16px',
                    fontWeight: 800,
                    color: textColor,
                    margin: 0,
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {restaurant?.restaurantName || 'Menu'}
                  </h1>
                  <p style={{
                    fontSize: '11px',
                    color: subtitleTextColor,
                    margin: '2px 0 0 0',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {restaurant?.cuisineType || (isShopMode ? 'Daily Essentials' : 'Delicious Food')}
                  </p>
                </div>
              </div>

              {/* Right: Veg Only Switch + Cart Button */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                flexShrink: 0
              }}>
                {/* Veg Only Switch - Only shown if non-veg items exist */}
                {hasNonVegItems && (
                  <div
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '5px',
                      background: vegOnlyFilter
                        ? 'linear-gradient(135deg, #16a34a, #15803d)'
                        : (currentTheme.isDark ? 'rgba(255,255,255,0.08)' : '#ffffff'),
                      padding: '4px 8px 4px 6px',
                      borderRadius: '999px',
                      border: `1.5px solid ${vegOnlyFilter ? '#16a34a' : (currentTheme.isDark ? 'rgba(255,255,255,0.2)' : '#e2e8f0')}`,
                      cursor: 'pointer',
                      boxShadow: vegOnlyFilter ? '0 2px 6px rgba(22,163,74,0.3)' : '0 1px 4px rgba(0,0,0,0.04)',
                      transition: 'all 0.2s ease',
                      userSelect: 'none',
                      flexShrink: 0
                    }}
                    onClick={() => setVegOnlyFilter(prev => !prev)}
                    title="Filter Vegetarian items only"
                  >
                    <div style={{
                      width: '12px',
                      height: '12px',
                      border: `1.5px solid ${vegOnlyFilter ? '#ffffff' : '#16a34a'}`,
                      borderRadius: '2px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: vegOnlyFilter ? 'transparent' : '#f0fdf4'
                    }}>
                      <div style={{
                        width: '5px',
                        height: '5px',
                        borderRadius: '50%',
                        background: vegOnlyFilter ? '#ffffff' : '#16a34a'
                      }} />
                    </div>
                    <span style={{
                      fontSize: '11px',
                      fontWeight: 700,
                      color: vegOnlyFilter ? '#ffffff' : textColor,
                      letterSpacing: '0.1px',
                      whiteSpace: 'nowrap'
                    }}>
                      Veg Only
                    </span>
                    <div style={{
                      width: '24px',
                      height: '14px',
                      borderRadius: '8px',
                      background: vegOnlyFilter ? '#ffffff' : (currentTheme.isDark ? 'rgba(255,255,255,0.2)' : '#e5e7eb'),
                      position: 'relative',
                      transition: 'background 0.2s ease',
                      marginLeft: '1px'
                    }}>
                      <div style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        background: vegOnlyFilter ? '#16a34a' : '#9ca3af',
                        position: 'absolute',
                        top: '2px',
                        left: vegOnlyFilter ? '12px' : '2px',
                        transition: 'left 0.2s ease'
                      }} />
                    </div>
                  </div>
                )}

                {/* Cart Button */}
                <button
                  type="button"
                  onClick={() => handleOpenCheckoutModal()}
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    border: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)'}`,
                    background: currentTheme.isDark ? 'rgba(255,255,255,0.08)' : '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    position: 'relative',
                    flexShrink: 0,
                    color: textColor
                  }}
                  title="View Cart"
                >
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                  </svg>
                  {getCartCount() > 0 && (
                    <span style={{
                      position: 'absolute',
                      top: '-4px',
                      right: '-4px',
                      background: '#ef4444',
                      color: '#ffffff',
                      fontSize: '9px',
                      fontWeight: 700,
                      width: '16px',
                      height: '16px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 6px rgba(239, 68, 68, 0.4)'
                    }}>
                      {getCartCount()}
                    </span>
                  )}
                </button>
              </div>
            </div>

            {!isShopMode && (
            <div className="segmented-selector-wrapper" style={{ marginBottom: '16px' }}>
              <div className="segmented-selector-label" style={{ fontSize: '13px', fontWeight: 700, marginBottom: '8px', color: currentTheme.isDark ? '#cbd5e1' : '#334155', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>Order Type</span>
                <span style={{ fontSize: '12px', fontWeight: 500, color: currentTheme.isDark ? '#9aa6b2' : '#64748b' }}>(select your order type)</span>
              </div>
              <div className="segmented-selector">
                {[
                  { key: 'DELIVERY', label: 'Delivery' },
                  { key: 'TAKEAWAY', label: 'Takeaway' },
                  { key: 'DRIVETHROUGH', label: 'Drive-through' }
                ].map((type) => (
                  <button
                    key={type.key}
                    type="button"
                    className={`segmented-selector-btn ${fulfillmentType === type.key ? 'active' : ''}`}
                    onClick={() => selectFulfillmentType(type.key)}
                  >
                    {type.label}
                  </button>
                ))}
              </div>
            </div>
            )}

            {/* Single Promotional Banner (Main Menu Area across all themes) */}
            {restaurant?.promotionalBanner && restaurant.promotionalBanner.isActive !== false && restaurant.promotionalBanner.imageUrl && (
              <div
                className="promotional-banner-container"
                style={{
                  marginBottom: '16px',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)'
                }}
              >
                <SafeImage
                  src={resolveMediaUrl(restaurant.promotionalBanner.imageUrl, '=s1200')}
                  alt={restaurant.promotionalBanner.altText || restaurant.promotionalBanner.title || 'Special Promotion'}
                  style={{
                    width: '100%',
                    maxHeight: '288px',
                    objectFit: 'cover',
                    borderRadius: '16px',
                    display: 'block'
                  }}
                  onError={(e) => { e.target.style.display = 'none'; }}
                  crossOrigin={isExternalUrl(restaurant.promotionalBanner.imageUrl) ? "anonymous" : undefined}
                />
              </div>
            )}

            <div className="search-bar-container" style={{
              marginBottom: '14px',
              background: currentTheme.isDark ? 'rgba(0, 0, 0, 0.35)' : 'rgba(255, 255, 255, 0.9)',
              border: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.1)'}`,
              borderRadius: '14px',
              padding: '8px',
              backdropFilter: 'blur(12px)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '18px', opacity: 0.85 }}>🔍</span>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search for dishes, categories..."
                  style={{
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    color: textColor,
                    fontSize: isMobile ? '14px' : '15px',
                    fontWeight: '600'
                  }}
                />
                {searchQuery && (
                  <button
                    type="button"
                    onClick={() => setSearchQuery('')}
                    style={{
                      border: 'none',
                      cursor: 'pointer',
                      borderRadius: '8px',
                      padding: '6px 10px',
                      color: '#ffffff',
                      fontWeight: '700',
                      background: `linear-gradient(135deg, ${currentTheme.primaryColor}, ${currentTheme.secondaryColor})`
                    }}
                  >
                    Clear
                  </button>
                )}
              </div>
              <div style={{
                marginTop: '6px',
                fontSize: '12px',
                color: currentTheme.isDark ? '#cbd5e1' : '#64748b',
                fontWeight: '600'
              }}>
                {debouncedSearchQuery ? `Showing ${filteredProducts.length} result(s)` : ''}
              </div>
            </div>



            {isMobile ? (
              <div ref={menuGridRef} className="menu-mobile-sections">
                {groupedMenuSections.map((section) => (
                  <div key={`mobile-${section.name}`} id={`category-mobile-${section.name}`} style={{ marginBottom: '8px' }}>
                    {(() => {
                      const isExpanded = expandedCategories?.[section.name] !== false;
                      return (
                        <>
                          <button
                            type="button"
                            className="category-accordion-btn"
                            onClick={() => toggleCategoryExpanded(section.name)}
                            style={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              gap: '10px',
                              padding: 0,
                              margin: '10px 0 6px 0',
                              border: 'none',
                              background: 'transparent',
                              cursor: 'pointer'
                            }}
                          >
                            <span style={{
                              fontSize: '19px',
                              fontWeight: '800',
                              color: currentTheme.isDark ? '#f8fafc' : '#1e293b'
                            }}>
                              {section.name}
                            </span>
                            <span style={{
                              fontSize: '16px',
                              color: currentTheme.primaryColor,
                              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                              transition: 'transform 0.2s ease'
                            }}>
                              ▼
                            </span>
                          </button>
                          <div style={{
                            overflow: 'hidden',
                            maxHeight: isExpanded ? '5000px' : '0px',
                            opacity: isExpanded ? 1 : 0,
                            transition: 'max-height 0.35s ease, opacity 0.25s ease'
                          }}>
                            {section.items.map((product) => {
                      const displayPriceMeta = getProductDisplayPriceMeta(product);
                      const showOriginalPrice = Number(product?.discountPrice) > 0 && Number(product?.price) > Number(product?.discountPrice);

                      return (
                      <div
                        key={product.productId}
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                          if (restaurantOpen) addToCart(product);
                        }}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          padding: '20px 0 24px 0',
                          borderBottom: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.06)'}`,
                          background: 'transparent',
                          cursor: restaurantOpen ? 'pointer' : 'default'
                        }}
                        className="menu-list-item"
                      >
                        <div style={{ flex: 1, paddingRight: '16px', display: 'flex', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '6px' }}>
                            {(() => {
                              const isVeg = product.isVeg !== false && product.isVeg !== 'false' && product.itemType !== 'NON_VEG';
                              return (
                                <div style={{
                                  width: '18px', height: '18px',
                                  border: `1.5px solid ${isVeg ? '#16a34a' : '#dc2626'}`,
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  borderRadius: '3px', flexShrink: 0, marginTop: '4px',
                                  background: '#ffffff'
                                }}>
                                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: isVeg ? '#16a34a' : '#dc2626' }}></div>
                                </div>
                              );
                            })()}
                            <h3 style={{ fontSize: '17px', fontWeight: 700, color: currentTheme.isDark ? '#f8fafc' : '#1e293b', margin: 0, lineHeight: '1.3' }}>
                              {product.productName}
                            </h3>
                          </div>

                          <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <span style={{ fontSize: '17px', fontWeight: 800, color: currentTheme.primaryColor }}>
                              {displayPriceMeta.estimatedFromModifiers ? 'From ' : ''}₹{Number(displayPriceMeta.price || 0).toFixed(0)}
                            </span>
                            {showOriginalPrice && !displayPriceMeta.estimatedFromModifiers && (
                              <span style={{ fontSize: '14px', color: '#94a3b8', textDecoration: 'line-through' }}>
                                ₹{product.price}
                              </span>
                            )}
                            {(() => {
                              const spicy = getSpicyBadge(product.spiceLevel);
                              if (!spicy) return null;
                              return (
                                <span style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '3px',
                                  fontSize: '11px',
                                  fontWeight: '700',
                                  color: spicy.color,
                                  backgroundColor: spicy.bg,
                                  padding: '1px 7px',
                                  borderRadius: '999px',
                                  border: `1px solid ${spicy.color}30`
                                }}>
                                  <span>{spicy.icon}</span>
                                  <span>{spicy.label}</span>
                                </span>
                              );
                            })()}
                          </div>

                          {product.description && (
                            <div
                              ref={(el) => {
                                if (el) {
                                  const textSpan = el.querySelector('.description-text');
                                  if (textSpan) {
                                    const isTruncated = textSpan.scrollHeight > textSpan.clientHeight + 2;
                                    markDescriptionTruncated(product.productId, isTruncated);
                                  }
                                }
                              }}
                              style={{ fontSize: '14px', lineHeight: '1.4' }}
                            >
                              <span
                                className="description-text"
                                style={{
                                  color: currentTheme.isDark ? '#94a3b8' : '#64748b',
                                  display: '-webkit-box',
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden'
                                }}
                              >
                                {product.description}
                              </span>
                              {truncatedDescriptions.has(product.productId) && (
                                <span
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    setDescriptionPopupProduct(product);
                                  }}
                                  style={{
                                    color: currentTheme.primaryColor,
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                    marginLeft: '4px'
                                  }}
                                >
                                  more
                                </span>
                              )}
                            </div>
                          )}
                        </div>

                        {(() => {
                          const isOrderingDisabled = restaurant?.isWebsiteOrderingEnabled === false;
                          const productActions = isOrderingDisabled ? (
                            <button
                              className="add-btn menu-add-btn"
                              onClick={(event) => {
                                event.stopPropagation();
                                handleOrderOnWebsiteRedirect();
                              }}
                              style={{
                                fontSize: '11px',
                                padding: '6px 12px',
                                whiteSpace: 'nowrap',
                                minWidth: '90px'
                              }}
                            >
                              {restaurant?.orderingDisabledButtonText || 'Order ↗'}
                            </button>
                          ) : getProductQuantity(product.productId) === 0 ? (
                            <button
                              className="add-btn menu-add-btn"
                              onClick={(event) => {
                                event.stopPropagation();
                                if (restaurantOpen) addToCart(product);
                              }}
                              disabled={!restaurantOpen}
                            >
                              {restaurantOpen ? 'ADD' : 'Closed'}
                            </button>
                          ) : (
                            <div className="qty-control">
                              <button
                                className="menu-qty-btn"
                                onClick={(event) => { event.stopPropagation(); const ci = cart.find(i => i.productId === product.productId); if (ci) updateQuantity(ci.cartItemId, -1); }}
                              >
                                -
                              </button>
                              <span className="menu-qty-text">{getProductQuantity(product.productId)}</span>
                              <button
                                className="menu-qty-btn"
                                onClick={(event) => { event.stopPropagation(); const ci = cart.find(i => i.productId === product.productId); if (ci) updateQuantity(ci.cartItemId, 1); }}
                              >
                                +
                              </button>
                            </div>
                          );

                          return product.imageUrl ? (
                            <div style={{ position: 'relative', width: '170px', height: '170px', flexShrink: 0 }}>
                              <LazyImage
                                src={resolveMediaUrl(product.imageUrl, '=s600')}
                                alt={product.productName}
                                index={productSequentialIndexMap[product.productId] || 0}
                                skeleton={true}
                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '16px' }}
                                placeholderStyle={{
                                  width: '100%',
                                  height: '100%',
                                  borderRadius: '16px',
                                  background: 'transparent'
                                }}
                              />
                              <div style={{ position: 'absolute', bottom: '-14px', left: '50%', transform: 'translateX(-50%)', width: '100px', display: 'flex', justifyContent: 'center', zIndex: 2 }}>
                                {productActions}
                              </div>
                            </div>
                          ) : (
                            <div style={{ position: 'relative', width: '170px', height: '170px', flexShrink: 0 }}>
                              <div style={{ width: '100%', height: '100%', borderRadius: '16px' }} />
                              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100px', display: 'flex', justifyContent: 'center', zIndex: 2 }}>
                                {productActions}
                              </div>
                            </div>
                          );
                        })()}
                      </div>
                    )})}
                          </div>
                        </>
                      );
                    })()}
                  </div>
                ))}
              </div>
            ) : (
              <div ref={menuGridRef} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
                {groupedMenuSections.map((section) => (
                  <div key={`desktop-${section.name}`} id={`category-desktop-${section.name}`}>
                    {(() => {
                      const isExpanded = expandedCategories?.[section.name] !== false;
                      return (
                        <>
                          <button
                            type="button"
                            className="category-accordion-btn"
                            onClick={() => toggleCategoryExpanded(section.name)}
                            style={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              gap: '10px',
                              padding: 0,
                              margin: '6px 0 12px 0',
                              border: 'none',
                              background: 'transparent',
                              cursor: 'pointer'
                            }}
                          >
                            <span style={{
                              fontSize: '22px',
                              fontWeight: '800',
                              color: currentTheme.isDark ? '#f8fafc' : '#1e293b'
                            }}>
                              {section.name}
                            </span>
                            <span style={{
                              fontSize: '18px',
                              color: currentTheme.primaryColor,
                              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                              transition: 'transform 0.2s ease'
                            }}>
                              ▼
                            </span>
                          </button>
                          <div style={{
                            overflow: 'hidden',
                            maxHeight: isExpanded ? '5000px' : '0px',
                            opacity: isExpanded ? 1 : 0,
                            transition: 'max-height 0.35s ease, opacity 0.25s ease'
                          }}>
                            <div
                              className="menu-grid"
                              style={{
                                '--menu-card-bg': currentTheme.glassCard,
                                '--menu-card-border': currentTheme.glassCardBorder || (currentTheme.isDark ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.08)'),
                                '--menu-card-shadow': currentTheme.glassCardShadow || '0 8px 20px rgba(0,0,0,0.06)'
                              }}
                            >
                              {section.items.map((product) => {
                        const displayPriceMeta = getProductDisplayPriceMeta(product);
                        const showOriginalPrice = Number(product?.discountPrice) > 0 && Number(product?.price) > Number(product?.discountPrice);
                        const currentQty = getProductQuantity(product.productId);
                        return (
                          <div
                            key={product.productId}
                            className="menu-card card-hover"
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                              if (restaurantOpen) addToCart(product);
                            }}
                            style={{ cursor: restaurantOpen ? 'pointer' : 'default' }}
                          >
                            {product.imageUrl ? (
                              <LazyImage
                                className="menu-card-image"
                                src={resolveMediaUrl(product.imageUrl, '=s600')}
                                alt={product.productName}
                                index={productSequentialIndexMap[product.productId] || 0}
                                skeleton={true}
                                placeholderStyle={{ background: 'transparent' }}
                              />
                            ) : (
                              <div className="menu-card-image" style={{ background: 'transparent' }} />
                            )}

                            <div className="menu-card-content">
                              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                {(() => {
                                  const isVeg = product.isVeg !== false && product.isVeg !== 'false' && product.itemType !== 'NON_VEG';
                                  return (
                                    <div style={{
                                      width: '18px', height: '18px',
                                      border: `1.5px solid ${isVeg ? '#16a34a' : '#dc2626'}`,
                                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                                      borderRadius: '3px', flexShrink: 0, marginTop: '4px',
                                      background: '#ffffff'
                                    }}>
                                      <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: isVeg ? '#16a34a' : '#dc2626' }}></div>
                                    </div>
                                  );
                                })()}
                                <h3 style={{ fontSize: '17px', fontWeight: 700, color: currentTheme.isDark ? '#f8fafc' : '#1e293b', margin: 0, lineHeight: '1.3' }}>
                                  {product.productName}
                                </h3>
                              </div>

                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                <span style={{ fontSize: '17px', fontWeight: 800, color: currentTheme.primaryColor }}>
                                  {displayPriceMeta.estimatedFromModifiers ? 'From ' : ''}₹{Number(displayPriceMeta.price || 0).toFixed(0)}
                                </span>
                                {showOriginalPrice && !displayPriceMeta.estimatedFromModifiers && (
                                  <span style={{ fontSize: '14px', color: '#94a3b8', textDecoration: 'line-through' }}>
                                    ₹{product.price}
                                  </span>
                                )}
                                {(() => {
                                  const spicy = getSpicyBadge(product.spiceLevel);
                                  if (!spicy) return null;
                                  return (
                                    <span style={{
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      gap: '3px',
                                      fontSize: '11px',
                                      fontWeight: '700',
                                      color: spicy.color,
                                      backgroundColor: spicy.bg,
                                      padding: '1px 7px',
                                      borderRadius: '999px',
                                      border: `1px solid ${spicy.color}30`
                                    }}>
                                      <span>{spicy.icon}</span>
                                      <span>{spicy.label}</span>
                                    </span>
                                  );
                                })()}
                              </div>

                              {product.description && (
                                <p style={{
                                  fontSize: '14px', color: currentTheme.isDark ? '#94a3b8' : '#64748b', margin: 0, lineHeight: '1.45',
                                  display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden'
                                }}>
                                  {product.description}
                                </p>
                              )}

                              <div className="menu-card-footer">
                                <div className="add-btn-container">
                                  {restaurant?.isWebsiteOrderingEnabled === false ? (
                                    <button
                                      className="add-btn menu-add-btn"
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        handleOrderOnWebsiteRedirect();
                                      }}
                                      style={{ maxWidth: '140px', fontSize: '11px', padding: '6px 12px' }}
                                    >
                                      {restaurant?.orderingDisabledButtonText || 'Order ↗'}
                                    </button>
                                  ) : currentQty === 0 ? (
                                    <button
                                      className="add-btn menu-add-btn"
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          if (restaurantOpen) addToCart(product);
                                        }}
                                      disabled={!restaurantOpen}
                                      style={{ maxWidth: '120px' }}
                                    >
                                      {restaurantOpen ? 'ADD' : 'Closed'}
                                    </button>
                                  ) : (
                                    <div className="qty-control" style={{ maxWidth: '120px' }}>
                                      <button
                                        className="menu-qty-btn"
                                          onClick={(event) => { event.stopPropagation(); const ci = cart.find(i => i.productId === product.productId); if (ci) updateQuantity(ci.cartItemId, -1); }}
                                      >
                                        -
                                      </button>
                                      <span className="menu-qty-text">{currentQty}</span>
                                      <button
                                        className="menu-qty-btn"
                                          onClick={(event) => { event.stopPropagation(); const ci = cart.find(i => i.productId === product.productId); if (ci) updateQuantity(ci.cartItemId, 1); }}
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                ))}
              </div>
            )}

            {filteredProducts.length === 0 && (
              <div style={{
                marginTop: '16px',
                textAlign: 'center',
                background: currentTheme.isDark ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.75)',
                border: `1px dashed ${currentTheme.primaryColor}70`,
                borderRadius: '14px',
                padding: '20px'
              }}>
                <div style={{ fontSize: '24px', marginBottom: '8px' }}>🔎</div>
                <div style={{ fontWeight: '700', color: textColor, marginBottom: '4px' }}>No items found</div>
                <div style={{ fontSize: '13px', color: subtitleTextColor }}>Try another item name or category keyword.</div>
              </div>
            )}

            <button
              className={`menu-mobile-fab menu-btn ${currentView === 'menu' && cart.length > 0 ? 'shifted-up' : ''}`}
              onClick={() => setShowCategoryMenuModal(true)}
              style={{
                display: 'inline-flex'
              }}
            >
              ☰ {isShopMode ? 'PRODUCTS' : 'MENU'}
            </button>

            {showCategoryMenuModal && (
              <div className="menu-mobile-overlay" onClick={() => setShowCategoryMenuModal(false)}>
                <div className="menu-mobile-sheet" onClick={(e) => e.stopPropagation()}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                    <h3 style={{ margin: 0, fontSize: '28px', color: '#111827' }}>Menu</h3>
                    <button
                      onClick={() => setShowCategoryMenuModal(false)}
                      style={{ border: 'none', background: 'transparent', fontSize: '30px', fontWeight: '700', color: '#374151', cursor: 'pointer' }}
                    >
                      ×
                    </button>
                  </div>
                  <div className="menu-mobile-sheet-grid">
                    {groupedMenuSections.map(section => (
                      <button
                        key={section.name}
                        className="menu-mobile-cat-btn"
                        onClick={() => {
                          setExpandedCategories((prev) => ({
                            ...prev,
                            [section.name]: true
                          }));
                          setShowCategoryMenuModal(false);
                          setTimeout(() => {
                            const element = document.getElementById(`category-${isMobile ? 'mobile' : 'desktop'}-${section.name}`);
                            if (element) {
                              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                          }, 50);
                        }}
                      >
                        {section.name}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            )}

          </div>
        )}

        {currentView === 'cart' && (
          <div className="content-container cart-view-wrapper">
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: isMobile ? '12px' : '20px',
              gap: '12px'
            }}>
              <h2 style={{
                fontSize: isMobile ? '22px' : '26px',
                fontWeight: '700',
                color: currentTheme.isDark ? '#ffffff' : currentTheme.primaryColor,
                fontFamily: currentTheme.font,
                textShadow: currentTheme.isDark
                  ? '0 2px 8px rgba(0,0,0,0.5)'
                  : '0 2px 4px rgba(0,0,0,0.1)',
                margin: 0
              }}>
                Your Cart ({getCartCount()} items)
              </h2>
              {cart.length > 0 && (
                <button
                  onClick={openClearCartConfirm}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    background: '#ef4444',
                    color: 'white',
                    padding: isMobile ? '8px 12px' : '10px 16px',
                    borderRadius: '8px',
                    border: 'none',
                    fontWeight: '600',
                    fontSize: isMobile ? '13px' : '14px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    boxShadow: '0 2px 8px rgba(239, 68, 68, 0.3)',
                    whiteSpace: 'nowrap',
                    minWidth: isMobile ? '88px' : '110px'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#dc2626';
                    e.currentTarget.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#ef4444';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                  title="Clear all items from cart"
                >
                  <span style={{ fontSize: isMobile ? '14px' : '16px' }}>🗑️</span>
                  {isMobile ? 'Clear' : 'Clear Cart'}
                </button>
              )}
            </div>

            {cart.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '60px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ fontSize: '80px', marginBottom: '20px', opacity: 0.8 }}>🛒</div>
                <p style={{ fontSize: '18px', color: subtitleTextColor, marginBottom: '30px', fontWeight: '500' }}>
                  Your cart is empty
                </p>
                <button
                  onClick={() => setCurrentView('menu')}
                  style={{
                    background: `linear-gradient(135deg, ${currentTheme.primaryColor}, ${currentTheme.secondaryColor})`,
                    color: 'white',
                    padding: '14px 30px',
                    borderRadius: '50px',
                    border: 'none',
                    fontWeight: '700',
                    fontSize: '16px',
                    cursor: 'pointer',
                    boxShadow: `0 6px 16px ${currentTheme.primaryColor}50`,
                    textShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s'
                  }}
                  className="btn-hover"
                >
                  {isShopMode ? 'Start Shopping' : 'Start Ordering'}
                </button>
              </div>
            ) : (
              <>
                {cart.map(item => {
                  const basePrice = item.discountPrice || item.price;
                  const addonsPrice = (item.selectedAddons || []).reduce((sum, addon) => sum + Number(addon.addonPrice || 0), 0);
                  const itemTotal = (basePrice + addonsPrice) * item.quantity;

                  return (
                    <div
                      key={item.cartItemId}
                      onClick={() => {
                        if (Array.isArray(item.selectedAddons) && item.selectedAddons.length > 0) {
                          openCartItemAddonModal(item);
                        }
                      }}
                      style={{
                        background: currentTheme.isDark
                          ? 'rgba(0, 0, 0, 0.4)'
                          : 'rgba(255, 255, 255, 0.9)',
                        backdropFilter: 'blur(15px)',
                        padding: isMobile ? '10px' : '16px',
                        borderRadius: '16px',
                        marginBottom: isMobile ? '8px' : '12px',
                        display: 'flex',
                        gap: isMobile ? '10px' : '16px',
                        border: `2px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)'}`,
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                        cursor: Array.isArray(item.selectedAddons) && item.selectedAddons.length > 0 ? 'pointer' : 'default'
                      }}>
                      {item.imageUrl && (
                        <SafeImage
                          src={resolveMediaUrl(item.imageUrl, '=s600')}
                          alt={item.productName}
                          style={{
                            width: isMobile ? '64px' : '80px',
                            height: isMobile ? '64px' : '80px',
                            objectFit: 'cover',
                            borderRadius: '8px'
                          }}
                          crossOrigin={isExternalUrl(item.imageUrl) ? "anonymous" : undefined}
                          fallback={
                            <div style={{
                              width: isMobile ? '64px' : '80px',
                              height: isMobile ? '64px' : '80px',
                              background: '#f3f4f6',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '8px',
                              color: '#9ca3af',
                              fontSize: '10px'
                            }}>No Img</div>
                          }
                        />
                      )}
                      <div style={{ flex: 1 }}>
                        <h3 style={{
                          fontSize: isMobile ? '15px' : '17px',
                          fontWeight: '700',
                          marginBottom: isMobile ? '2px' : '4px',
                          color: currentTheme.isDark ? '#f1f5f9' : '#1e293b'
                        }}>
                          {item.productName}
                        </h3>

                        {/* Show selected addons */}
                        {item.selectedAddons && item.selectedAddons.length > 0 && (
                          <div style={{
                            marginTop: '6px',
                            marginBottom: '8px'
                          }}>
                            {item.selectedAddons.map((addon, idx) => (
                              <div key={`${addon.addonId || addon.optionId}-${idx}`} style={{
                                fontSize: isMobile ? '12px' : '13px',
                                color: currentTheme.isDark ? '#94a3b8' : '#64748b',
                                marginBottom: '2px'
                              }}>
                                {addon.addonName} (₹{Number(addon.addonPrice || 0).toFixed(2)})
                              </div>
                            ))}
                          </div>
                        )}

                        {item.specialInstructions && (
                          <div style={{
                            marginBottom: '6px',
                            fontSize: isMobile ? '12px' : '13px',
                            color: currentTheme.isDark ? '#cbd5e1' : '#475569'
                          }}>
                            Special request: {item.specialInstructions}
                          </div>
                        )}

                        <button
                          type="button"
                          onClick={(event) => {
                            event.stopPropagation();
                            openSpecialRequestEditor(item);
                          }}
                          style={{
                            border: 'none',
                            background: `linear-gradient(90deg, #10b981, #059669)`,
                            color: 'white',
                            padding: isMobile ? '4px 8px' : '8px 12px',
                            fontSize: isMobile ? '11px' : '13px',
                            fontWeight: '700',
                            cursor: 'pointer',
                            marginBottom: isMobile ? '6px' : '8px',
                            borderRadius: '999px',
                            boxShadow: isMobile ? 'none' : '0 6px 14px rgba(16,185,129,0.18)',
                            display: 'inline-block',
                            lineHeight: 1
                          }}
                        >
                          {item.specialInstructions ? 'Edit special request' : 'Add special request'}
                        </button>

                        <p style={{
                          fontSize: isMobile ? '16px' : '20px',
                          fontWeight: '700',
                          color: currentTheme.primaryColor
                        }}>
                          ₹{itemTotal.toFixed(2)}
                        </p>
                      </div>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <button
                          onClick={(event) => {
                            event.stopPropagation();
                            updateQuantity(item.cartItemId, -1);
                          }}
                          style={{
                            background: currentTheme.isDark
                              ? 'rgba(255, 255, 255, 0.15)'
                              : 'rgba(255, 255, 255, 0.9)',
                            border: `2px solid ${currentTheme.primaryColor}`,
                            color: currentTheme.isDark ? '#ffffff' : currentTheme.primaryColor,
                            width: isMobile ? '30px' : '36px',
                            height: isMobile ? '30px' : '36px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontWeight: '700',
                            fontSize: isMobile ? '15px' : '18px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                          }}
                        >
                          -
                        </button>
                        <span style={{
                          fontSize: isMobile ? '15px' : '18px',
                          fontWeight: '700',
                          minWidth: isMobile ? '22px' : '32px',
                          textAlign: 'center',
                          color: currentTheme.isDark ? '#ffffff' : '#1e293b'
                        }}>
                          {item.quantity}
                        </span>
                        <button
                          onClick={(event) => {
                            event.stopPropagation();
                            updateQuantity(item.cartItemId, 1);
                          }}
                          style={{
                            background: `linear-gradient(135deg, ${currentTheme.primaryColor}, ${currentTheme.secondaryColor})`,
                            border: 'none',
                            color: 'white',
                            width: isMobile ? '30px' : '36px',
                            height: isMobile ? '30px' : '36px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontWeight: '700',
                            fontSize: isMobile ? '15px' : '18px',
                            boxShadow: `0 4px 12px ${currentTheme.primaryColor}40`,
                            textShadow: '0 1px 2px rgba(0,0,0,0.2)'
                          }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  );
                })}

                <div style={{
                  background: currentTheme.glassCard,
                  backdropFilter: 'blur(10px)',
                  WebkitBackdropFilter: 'blur(10px)',
                  padding: isMobile ? '16px' : '24px',
                  borderRadius: '20px',
                  marginTop: isMobile ? '12px' : '20px',
                  border: currentTheme.glassCardBorder || `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)'}`,
                  boxShadow: currentTheme.glassCardShadow || '0 8px 24px rgba(0, 0, 0, 0.1)'
                }}>
                  {/* QR-style Order Summary header */}
                  <h4 style={{
                    fontWeight: '700',
                    borderBottom: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'}`,
                    paddingBottom: '12px',
                    marginBottom: '12px',
                    color: currentTheme.isDark ? '#e2e8f0' : currentTheme.primaryColor,
                    textTransform: 'uppercase',
                    fontSize: '11px',
                    letterSpacing: '0.1em'
                  }}>Order Summary</h4>
                  {!isShopMode && (
                  <div style={{ marginBottom: '16px', position: 'relative', zIndex: 3 }}>
                    <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '8px', color: currentTheme.isDark ? '#cbd5e1' : '#334155', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span>Order Type</span>
                      <span style={{ fontSize: '12px', fontWeight: 500, color: currentTheme.isDark ? '#9aa6b2' : '#64748b' }}>(select your order type)</span>
                    </div>
                    <div className="segmented-selector">
                      {[
                        { key: 'DELIVERY', label: 'Delivery' },
                        { key: 'TAKEAWAY', label: 'Takeaway' },
                        { key: 'DRIVETHROUGH', label: 'Drive-through' }
                      ].map((type) => (
                        <button
                          key={type.key}
                          type="button"
                          className={`segmented-selector-btn ${fulfillmentType === type.key ? 'active' : ''}`}
                          onClick={() => selectFulfillmentType(type.key)}
                        >
                          {type.label}
                        </button>
                      ))}
                    </div>
                  </div>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '14px', color: currentTheme.isDark ? '#94a3b8' : '#64748b' }}>
                    <span>Subtotal</span>
                    <span style={{ fontWeight: '700' }}>₹{getCartSubtotal().toFixed(2)}</span>
                  </div>
                  {fulfillmentType === 'DELIVERY' && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '14px', color: currentTheme.isDark ? '#94a3b8' : '#64748b' }}>
                      <span>Delivery Charge</span>
                      <span style={{ fontWeight: '700' }}>₹{getCartPricing().deliveryCharge.toFixed(2)}</span>
                    </div>
                  )}
                  {getCartPricing().taxAmount > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '14px', color: currentTheme.isDark ? '#94a3b8' : '#64748b' }}>
                      <span>{gstSettings.taxName || 'GST'} {getCartPricing().taxEnabled ? `(${getCartPricing().taxPercentage.toFixed(2)}%)` : ''}</span>
                      <span style={{ fontWeight: '700' }}>₹{getCartPricing().taxAmount.toFixed(2)}</span>
                    </div>
                  )}
                  {getCartPricing().belowMinimum && (
                    <div style={{ fontSize: '12px', color: '#dc2626', marginBottom: '8px' }}>
                      Add items worth Rs {(getCartPricing().minimumOrderAmount - getCartSubtotal()).toFixed(2)} more for delivery.
                    </div>
                  )}
                  {/* Dashed divider — QR template style */}
                  <div style={{
                    borderTop: `1px dashed ${currentTheme.isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.12)'}`,
                    paddingTop: '12px',
                    marginTop: '12px'
                  }}>
                    <div className="total-section">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{
                          fontSize: isMobile ? '16px' : '18px',
                          fontWeight: 700,
                          color: currentTheme.isDark ? '#ffffff' : '#1e293b'
                        }}>Total</span>
                        <span className="total-amount-text" style={{ fontSize: isMobile ? '24px' : '26px' }}>
                          ₹{getCartTotal().toFixed(2)}
                        </span>
                      </div>
                      <p className="tax-note">
                        {getCartPricing().taxAmount > 0 ? 'Inclusive of all taxes' : 'Taxes not applicable'}
                      </p>
                    </div>
                  </div>
                  {deliverySlabInsight && (
                    <div style={{
                      marginTop: '12px',
                      marginBottom: '12px',
                      padding: isMobile ? '10px 12px' : '12px 14px',
                      borderRadius: '14px',
                      background: currentTheme.isDark
                        ? 'rgba(148, 163, 184, 0.12)'
                        : '#f8fafc',
                      border: `1px solid ${currentTheme.isDark ? 'rgba(148,163,184,0.25)' : '#e2e8f0'}`,
                      boxShadow: currentTheme.isDark
                        ? '0 6px 16px rgba(15, 23, 42, 0.35)'
                        : '0 6px 16px rgba(15, 23, 42, 0.08)'
                    }}>
                      <div style={{
                        fontSize: isMobile ? '13px' : '14px',
                        fontWeight: '700',
                        color: currentTheme.isDark ? '#e2e8f0' : '#0f172a',
                        lineHeight: 1.4
                      }}>
                        {deliverySlabInsight.message}
                      </div>
                      <div style={{
                        marginTop: '4px',
                        fontSize: '11px',
                        color: currentTheme.isDark ? '#94a3b8' : '#64748b',
                        fontWeight: '600'
                      }}>
                        Based on current delivery slabs
                      </div>
                    </div>
                  )}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <button
                      type="button"
                      onClick={() => {
                        setShowCheckoutModal(false);
                        setCurrentView('menu');
                      }}
                      style={{
                        width: '100%',
                        padding: isMobile ? '12px' : '15px',
                        borderRadius: '14px',
                        border: `1px solid ${currentTheme.primaryColor}40`,
                        background: currentTheme.isDark ? 'rgba(15, 23, 42, 0.35)' : '#ffffff',
                        color: currentTheme.primaryColor,
                        fontWeight: 800,
                        fontSize: isMobile ? '14px' : '15px',
                        cursor: 'pointer',
                        boxShadow: currentTheme.softShadow || '0 4px 12px rgba(0, 0, 0, 0.08)',
                        transition: 'transform 0.2s, box-shadow 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = currentTheme.mediumShadow || '0 8px 24px rgba(0, 0, 0, 0.10)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = currentTheme.softShadow || '0 4px 12px rgba(0, 0, 0, 0.08)';
                      }}
                    >
                      Add More Items
                    </button>
                    <button
                      onClick={() => {
                        if (fulfillmentType === 'DELIVERY' && getCartPricing().belowMinimum) {
                          return;
                        }
                        handleOpenCheckoutModal();
                      }}
                      disabled={fulfillmentType === 'DELIVERY' && getCartPricing().belowMinimum}
                      className="primary-cta-btn"
                      style={{
                        width: '100%',
                        padding: isMobile ? '14px' : '16px',
                        fontSize: isMobile ? '15px' : '17px',
                        cursor: fulfillmentType === 'DELIVERY' && getCartPricing().belowMinimum ? 'not-allowed' : 'pointer',
                        opacity: fulfillmentType === 'DELIVERY' && getCartPricing().belowMinimum ? 0.6 : 1,
                      }}
                    >
                      Proceed to Checkout
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}</>)}

        {isPremiumCarouselTheme && (
          <PremiumCarouselTheme
            restaurant={restaurant}
            isShopMode={isShopMode}
            restaurantOpen={restaurantOpen}
            closedMessage={closedMessage}
            categories={categories}
            products={products}
            groupedMenuSections={groupedMenuSections}
            cart={cart}
            currentView={currentView}
            setCurrentView={setCurrentView}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            fulfillmentType={fulfillmentType}
            selectFulfillmentType={selectFulfillmentType}
            addToCart={addToCart}
            updateQuantity={updateQuantity}
            removeFromCart={removeFromCart}
            getCartCount={getCartCount}
            getCartTotal={getCartTotal}
            getCartPricing={getCartPricing}
            getProductDisplayPriceMeta={getProductDisplayPriceMeta}
            getProductQuantity={getProductQuantity}
            openCheckoutModal={handleOpenCheckoutModal}
            openCartItemAddonModal={openCartItemAddonModal}
            setEditingSpecialRequest={setEditingSpecialRequest}
            setShowClearCartConfirm={setShowClearCartConfirm}
            setDescriptionPopupProduct={setDescriptionPopupProduct}
            showCategoryMenuModal={showCategoryMenuModal}
            setShowCategoryMenuModal={setShowCategoryMenuModal}
            toggleCategoryExpanded={toggleCategoryExpanded}
            expandedCategories={expandedCategories}
            stickyFooterDeliveryInsight={stickyFooterDeliveryInsight}
            appliedCoupon={appliedCoupon}
            handleRemoveCoupon={handleRemoveCoupon}
            logoLoadError={logoLoadError}
            setLogoLoadError={setLogoLoadError}
            LazyImage={LazyImage}
            isMobile={isMobile}
            currentTheme={currentTheme}
            getCartSubtotal={getCartSubtotal}
            gstSettings={gstSettings}
            deliverySlabInsight={deliverySlabInsight}
            couponCode={couponCode}
            setCouponCode={setCouponCode}
            applyingCoupon={applyingCoupon}
            handleApplyCoupon={handleApplyCoupon}
            showCouponList={showCouponList}
            setShowCouponList={setShowCouponList}
            availableCoupons={availableCoupons}
            couponsLoading={couponsLoading}
            couponsError={couponsError}
            handleToggleCoupons={handleToggleCoupons}
            formatCouponDescription={formatCouponDescription}
            formatCouponExpiry={formatCouponExpiry}
            showSplash={showSplash}
          />
        )}

        {isNewDevelopmentTheme && (
          <NewDevelopmentTheme
            restaurant={restaurant}
            isShopMode={isShopMode}
            restaurantOpen={restaurantOpen}
            closedMessage={closedMessage}
            categories={categories}
            products={products}
            groupedMenuSections={groupedMenuSections}
            cart={cart}
            currentView={currentView}
            setCurrentView={setCurrentView}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            fulfillmentType={fulfillmentType}
            selectFulfillmentType={selectFulfillmentType}
            addToCart={addToCart}
            updateQuantity={updateQuantity}
            removeFromCart={removeFromCart}
            getCartCount={getCartCount}
            getCartTotal={getCartTotal}
            getCartPricing={getCartPricing}
            deliverySettings={deliverySettings}
            deliverySlabInsight={buildDeliverySlabInsight()}
            getProductDisplayPriceMeta={getProductDisplayPriceMeta}
            getProductQuantity={getProductQuantity}
            openCheckoutModal={handleOpenCheckoutModal}
            openCartItemAddonModal={openCartItemAddonModal}
            setEditingSpecialRequest={setEditingSpecialRequest}
            setShowClearCartConfirm={setShowClearCartConfirm}
            setDescriptionPopupProduct={setDescriptionPopupProduct}
            showCategoryMenuModal={showCategoryMenuModal}
            setShowCategoryMenuModal={setShowCategoryMenuModal}
            toggleCategoryExpanded={toggleCategoryExpanded}
            expandedCategories={expandedCategories}
            appliedCoupon={appliedCoupon}
            handleRemoveCoupon={handleRemoveCoupon}
            logoLoadError={logoLoadError}
            setLogoLoadError={setLogoLoadError}
            LazyImage={LazyImage}
            isMobile={isMobile}
            resolveMediaUrl={resolveMediaUrl}
            currentTheme={currentTheme}
            showSplash={showSplash}
            clearCart={clearCart}
            showAddonModal={showAddonModal}
            setShowAddonModal={setShowAddonModal}
            currentProduct={currentProduct}
            setCurrentProduct={setCurrentProduct}
            availableAddons={availableAddons}
            selectionRulesByGroup={selectionRulesByGroup}
            selectedAddons={selectedAddons}
            setSelectedAddons={setSelectedAddons}
            toggleAddonSelection={toggleAddonSelection}
            closeAddonModal={closeAddonModal}
            loadingAddons={loadingAddons}
            addToCartWithAddons={addToCartWithAddons}
            openAddonModalWithProduct={openAddonModalWithProduct}
            showAddonSelectionModal={showAddonSelectionModal}
            fetchAddons={fetchAddons}
            applyProductCustomizations={applyProductCustomizations}
            validateGroupSelections={validateGroupSelections}
            pendingSpecialInstructions={pendingSpecialInstructions}
            setPendingSpecialInstructions={setPendingSpecialInstructions}
            editingCartItemId={editingCartItemId}
            addCartItem={addCartItem}
            setCart={setCart}
            checkoutForm={checkoutForm}
            setCheckoutForm={setCheckoutForm}
            handleApplyCoupon={handleApplyCoupon}
            couponCode={couponCode}
            setCouponCode={setCouponCode}
            availableCoupons={availableCoupons}
            couponsLoading={couponsLoading}
            couponsError={couponsError}
            handleToggleCoupons={handleToggleCoupons}
            formatCouponDescription={formatCouponDescription}
            formatCouponExpiry={formatCouponExpiry}
            fetchAvailableCoupons={fetchAvailableCoupons}
            onlinePaymentConfigured={onlinePaymentConfigured}
            trivanaLogo={trivanaLogo}
          />
        )}

        {/* Global Powered By Footer for ALL views */}
        {!isNewDevelopmentTheme && (
        <div style={{
          textAlign: 'center',
          paddingTop: '14px',
          paddingBottom: '100px', // Keep clear above bottom nav
          width: '100%',
          marginTop: '10px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          paddingLeft: '12px',
          paddingRight: '12px'
        }} className="animate-fade-in">
          <div style={{
            background: currentTheme.isDark ? '#0f172a' : '#ffffff',
            width: 'min(100%, 700px)',
            borderRadius: '16px',
            padding: '16px 20px',
            color: currentTheme.isDark ? '#cbd5e1' : '#64748b',
            fontSize: '12px',
            fontWeight: '600',
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            opacity: 1,
            boxShadow: currentTheme.isDark ? '0 4px 20px rgba(0,0,0,0.4)' : '0 4px 20px rgba(0,0,0,0.04)',
            border: currentTheme.isDark ? '1px solid rgba(255,255,255,0.06)' : '1px solid rgba(0,0,0,0.05)'
          }}>
            {currentView === 'menu' && (
              <div style={{
                color: currentTheme.isDark ? '#94a3b8' : '#64748b',
                fontWeight: '500',
                fontSize: '11px',
                textTransform: 'none',
                letterSpacing: 'normal',
                margin: '0 auto 12px',
                maxWidth: '920px',
                lineHeight: '1.5',
                padding: '0 6px'
              }}>
                • For your order, the business is responsible for all payments. Trivana Hospitality act only as intermediaries and do not handle any payments. In case of any issue, please contact the business owner directly.
              </div>
            )}

            {/* POWERED BY TRIVANA */}
            <div className="powered-text-container">
              <p className="powered-text" style={{ margin: 0, fontSize: '12px', fontWeight: '700', letterSpacing: '0.08em' }}>
                POWERED BY{' '}
                <a href="https://trivanahospitality.com" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', fontWeight: '800' }}>
                  TRIVANA
                </a>
              </p>
            </div>

            <div className="powered-logos-container" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <div className="powered-logos" aria-label="Powered by logo" style={{ justifyContent: 'center' }}>
                <a href="https://trivanahospitality.com" target="_blank" rel="noopener noreferrer" aria-label="Trivana Hospitality" style={{ minHeight: 'auto', padding: '4px 8px' }}>
                  <img className="trivana-logo" src={trivanaLogo} alt="Trivana Hospitality" />
                </a>
              </div>
            </div>

            {/* DIVIDER LINE */}
            <div style={{
              height: '1px',
              backgroundColor: currentTheme.isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)',
              margin: '12px auto 10px',
              width: '85%'
            }} />

            {/* DELIVERY AGGREGATORS & SHIPPING INTEGRATIONS */}
            <div className="delivery-aggregator-section" style={{ marginTop: '8px', width: '100%', overflow: 'hidden' }}>
              <div style={{ margin: '0 0 10px', textAlign: 'center' }}>
                <p style={{
                  margin: '0 0 3px',
                  fontSize: '11px',
                  fontWeight: '800',
                  letterSpacing: '0.08em',
                  color: currentTheme.isDark ? '#cbd5e1' : '#475569',
                  textTransform: 'uppercase'
                }}>
                  HAVING JUST ONE OPTION ISN'T AN OPTION
                </p>
                <p style={{
                  margin: 0,
                  fontSize: '10px',
                  fontWeight: '600',
                  letterSpacing: '0.02em',
                  color: currentTheme.isDark ? '#94a3b8' : '#64748b'
                }}>
                  Delivering to 20,000+ Pin Codes across India with 20+ Integrated Logistics Partners
                </p>
              </div>
              
              <div className="courier-marquee-wrapper" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {/* Row 1 - Marquee (11 Partners) */}
                <div className="courier-marquee-track">
                  {[...Array(2)].map((_, loopIdx) => (
                    <React.Fragment key={`row1-loop-${loopIdx}`}>
                      {/* 1. YeloFast Instant */}
                      <a
                        href="https://yelofast.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="courier-pill"
                        style={{ background: '#18181b', color: '#facc15', textDecoration: 'none' }}
                      >
                        <span style={{ fontSize: '12px', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <span style={{ fontSize: '13px' }}>📦</span>
                          <span>YeloFast Instant</span>
                        </span>
                      </a>

                      {/* 2. Xpressbees */}
                      <div className="courier-pill" style={{ background: '#f26522', color: '#ffffff' }}>
                        <span style={{ fontSize: '13px', fontWeight: '900', fontStyle: 'italic', letterSpacing: '-0.02em', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ fontSize: '14px', letterSpacing: '-2px', marginRight: '2px' }}>»»</span>
                          <span>XPRESSBEES</span>
                        </span>
                      </div>

                      {/* 3. Delhivery */}
                      <div className="courier-pill" style={{ background: '#09090b', color: '#ffffff' }}>
                        <span style={{ fontSize: '13px', fontWeight: '900', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ color: '#ef4444', fontSize: '14px', lineHeight: '1' }}>■</span>
                          <span>DELHIVERY</span>
                        </span>
                      </div>

                      {/* 4. Ecom Express */}
                      <div className="courier-pill" style={{ background: '#be185d', color: '#ffffff' }}>
                        <span style={{ fontSize: '12px', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ fontSize: '13px' }}>⚡</span>
                          <span>Ecom Express</span>
                        </span>
                      </div>

                      {/* 5. Amazon Shipping */}
                      <div className="courier-pill" style={{ background: '#131921', color: '#ffffff' }}>
                        <span style={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ fontWeight: '800' }}>amazon</span>
                          <span style={{ fontWeight: '400', opacity: 0.85, fontSize: '11px' }}>shipping</span>
                        </span>
                      </div>

                      {/* 6. Blue Dart */}
                      <div className="courier-pill" style={{ background: '#004b93', color: '#ffffff' }}>
                        <span style={{ fontWeight: '900', fontStyle: 'italic', letterSpacing: '0.05em', fontSize: '13px' }}>
                          BLUE DART
                        </span>
                      </div>

                      {/* 7. DTDC India */}
                      <div className="courier-pill" style={{ background: '#0f172a', color: '#ffffff' }}>
                        <span style={{ fontSize: '13px', fontWeight: '900', fontStyle: 'italic', letterSpacing: '0.06em', display: 'flex', alignItems: 'center', gap: '3px' }}>
                          <span>DTDC</span>
                          <span style={{ color: '#ef4444', fontSize: '12px', fontStyle: 'normal' }}>■</span>
                        </span>
                      </div>

                      {/* 8. Shadowfax */}
                      <div className="courier-pill" style={{ background: '#f9570c', color: '#ffffff' }}>
                        <span style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <span style={{ fontSize: '13px' }}>◥</span>
                          <span style={{ fontWeight: '800' }}>shadowfax</span>
                        </span>
                      </div>

                      {/* 9. Blitz */}
                      <div className="courier-pill" style={{ background: '#000000', color: '#ffffff' }}>
                        <span style={{ fontSize: '13px', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ color: '#ffffff' }}>⚡</span>
                          <span>blitz</span>
                        </span>
                      </div>

                      {/* 10. Gati */}
                      <div className="courier-pill" style={{ background: '#0284c7', color: '#ffffff' }}>
                        <span style={{ fontSize: '13px', fontWeight: '900', letterSpacing: '0.06em', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ color: '#facc15' }}>✦</span>
                          <span>GATI</span>
                        </span>
                      </div>

                      {/* 11. Speed Post / India Post */}
                      <div className="courier-pill" style={{ background: '#c4161c', color: '#ffffff' }}>
                        <span style={{ fontSize: '12px', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span>📮</span>
                          <span>Speed Post</span>
                        </span>
                      </div>
                    </React.Fragment>
                  ))}
                </div>

                {/* Row 2 - Marquee Reverse (11 Partners) */}
                <div className="courier-marquee-track-reverse">
                  {[...Array(2)].map((_, loopIdx) => (
                    <React.Fragment key={`row2-loop-${loopIdx}`}>
                      {/* 12. Ekart Logistics */}
                      <div className="courier-pill" style={{ background: '#0066cc', color: '#ffffff' }}>
                        <span style={{ fontSize: '13px', fontWeight: '800', letterSpacing: '-0.02em', display: 'flex', alignItems: 'center', gap: '3px' }}>
                          <span style={{ fontStyle: 'italic', fontWeight: '900' }}>e</span>
                          <span>kart</span>
                        </span>
                      </div>

                      {/* 13. Aramex */}
                      <div className="courier-pill" style={{ background: '#dc2626', color: '#ffffff' }}>
                        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.1' }}>
                          <span style={{ fontWeight: '800', fontSize: '13px', letterSpacing: '-0.02em' }}>aramex</span>
                          <span style={{ fontSize: '7px', fontWeight: '600', opacity: 0.9, letterSpacing: '0.04em' }}>delivery unlimited</span>
                        </span>
                      </div>

                      {/* 14. Dunzo Courier */}
                      <div className="courier-pill" style={{ background: '#059669', color: '#ffffff' }}>
                        <span style={{ fontSize: '13px', fontWeight: '900', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ color: '#a7f3d0' }}>⚡</span>
                          <span>dunzo</span>
                        </span>
                      </div>

                      {/* 15. Borzo Delivery */}
                      <div className="courier-pill" style={{ background: '#0066ff', color: '#ffffff' }}>
                        <span style={{ fontWeight: '800', fontSize: '14px', letterSpacing: '-0.03em' }}>
                          borzo
                        </span>
                      </div>

                      {/* 16. Loadshare Networks */}
                      <div className="courier-pill" style={{ background: '#3b82f6', color: '#ffffff' }}>
                        <span style={{ fontSize: '11px', fontWeight: '800', letterSpacing: '0.04em', display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <span style={{ fontSize: '12px', background: 'rgba(255,255,255,0.25)', borderRadius: '3px', padding: '1px 3px' }}>☊</span>
                          <span>LOADSHARE</span>
                        </span>
                      </div>

                      {/* 17. Smartr Logistics */}
                      <div className="courier-pill" style={{ background: '#7c3aed', color: '#ffffff' }}>
                        <span style={{ fontSize: '12px', fontWeight: '800', letterSpacing: '0.04em', display: 'flex', alignItems: 'center', gap: '3px' }}>
                          <span style={{ color: '#c4b5fd' }}>★</span>
                          <span>smartr</span>
                        </span>
                      </div>

                      {/* 18. DotZot */}
                      <div className="courier-pill" style={{ background: '#334a6e', color: '#ffffff' }}>
                        <span style={{ fontWeight: '900', letterSpacing: '0.06em', fontSize: '12px' }}>
                          D<span style={{ color: '#93c5fd' }}>⊙</span>TZOT
                        </span>
                      </div>

                      {/* 19. Kerry Indev Express */}
                      <div className="courier-pill" style={{ background: '#0b4d75', color: '#ffffff' }}>
                        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.1' }}>
                          <span style={{ fontWeight: '800', fontSize: '10px', letterSpacing: '0.08em' }}>KERRY INDEV</span>
                          <span style={{ fontSize: '7px', fontWeight: '600', opacity: 0.85, letterSpacing: '0.1em' }}>EXPRESS</span>
                        </span>
                      </div>

                      {/* 20. Pik N Del */}
                      <div className="courier-pill" style={{ background: '#0d9488', color: '#ffffff' }}>
                        <span style={{ fontWeight: '900', fontSize: '11px', letterSpacing: '0.06em' }}>
                          PIK N DEL
                        </span>
                      </div>

                      {/* 21. Pidge */}
                      <div className="courier-pill" style={{ background: '#4f46e5', color: '#ffffff' }}>
                        <span style={{ fontSize: '12px', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ color: '#c7d2fe' }}>◬</span>
                          <span>pidge</span>
                        </span>
                      </div>

                      {/* 22. Ecom Reverse */}
                      <div className="courier-pill" style={{ background: '#9f1239', color: '#ffffff' }}>
                        <span style={{ fontSize: '11px', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '3px' }}>
                          <span>⮌</span>
                          <span>Ecom Reverse</span>
                        </span>
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        )}

        {restaurant?.isWebsiteOrderingEnabled === false && (
          <div className="external-order-bar" style={{
            position: 'fixed',
            left: '50%',
            transform: 'translateX(-50%)',
            width: isMobile ? 'calc(100% - 20px)' : 'calc(100% - 32px)',
            maxWidth: '560px',
            bottom: isMobile ? 'calc(86px + env(safe-area-inset-bottom, 0px))' : '24px',
            zIndex: 900,
            background: currentTheme.isDark ? 'rgba(15, 23, 42, 0.95)' : 'rgba(255, 255, 255, 0.98)',
            backdropFilter: 'blur(12px)',
            border: `1.5px solid ${currentTheme.primaryColor}`,
            borderRadius: '14px',
            boxShadow: `0 8px 24px ${currentTheme.primaryColor}30`,
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px'
          }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '13px', fontWeight: '700', color: textColor, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                Online Ordering
              </div>
              <div style={{ fontSize: '11px', color: subtitleTextColor, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {restaurant?.orderingDisabledButtonUrl ? 'Order directly via our partner platform' : 'Contact store directly for orders'}
              </div>
            </div>

            <button
              type="button"
              onClick={handleOrderOnWebsiteRedirect}
              style={{
                backgroundColor: currentTheme.primaryColor,
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '9px 16px',
                fontSize: '13px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                whiteSpace: 'nowrap',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
              }}
            >
              <span>{restaurant?.orderingDisabledButtonText || 'Order on Website'}</span>
              <span style={{ fontSize: '14px' }}>↗</span>
            </button>
          </div>
        )}

        {currentView === 'menu' && cart.length > 0 && !isPremiumCarouselTheme && !isNewDevelopmentTheme && restaurant?.isWebsiteOrderingEnabled !== false && (
          <div className="cart-popup" style={{
            position: 'fixed',
            left: '50%',
            transform: 'translateX(-50%)',
            width: isMobile ? 'calc(100% - 20px)' : 'calc(100% - 32px)',
            maxWidth: isMobile ? 'none' : undefined,
            bottom: isMobile ? 'calc(86px + env(safe-area-inset-bottom, 0px))' : '90px',
            zIndex: 900,
            background: currentTheme.isDark ? 'rgba(15, 23, 42, 0.92)' : 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(12px)',
            border: `1px solid ${currentTheme.primaryColor}55`,
            borderRadius: '12px',
            boxShadow: `0 8px 20px ${currentTheme.primaryColor}35`,
            padding: isMobile ? '10px 12px' : '12px 14px',
            minHeight: isMobile ? '50px' : '58px',
            boxSizing: 'border-box',
            overflow: 'visible'
          }}>
            {stickyFooterDeliveryInsight && (
              <div style={{
                padding: '6px 8px',
                marginBottom: '8px',
                borderRadius: '10px',
                background: currentTheme.isDark
                  ? 'rgba(148, 163, 184, 0.12)'
                  : '#f8fafc',
                border: `1px solid ${currentTheme.isDark ? 'rgba(148,163,184,0.25)' : '#e2e8f0'}`
              }}>
                <span style={{
                  fontSize: '12px',
                  fontWeight: '700',
                  color: currentTheme.isDark ? '#e2e8f0' : '#0f172a',
                  lineHeight: 1.3
                }}>
                  {stickyFooterDeliveryInsight.message}
                </span>
              </div>
            )}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: isMobile ? '8px' : '12px',
              minHeight: isMobile ? '32px' : '38px',
              width: '100%'
            }}>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{
                  fontSize: isMobile ? '10px' : '11px',
                  fontWeight: '600',
                  color: currentTheme.isDark ? '#cbd5e1' : '#64748b',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Next step
                </div>
                <div style={{
                  fontSize: isMobile ? '13px' : '14px',
                  fontWeight: '800',
                  color: currentTheme.primaryColor,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  marginTop: '2px'
                }}>
                  {getCartCount()} item(s) • ₹{getCartTotal().toFixed(2)}
                </div>
              </div>
              <button
                onClick={() => setCurrentView('cart')}
                style={{
                  border: 'none',
                  borderRadius: '8px',
                  padding: isMobile ? '10px 16px' : '12px 20px',
                  cursor: 'pointer',
                  fontWeight: '700',
                  fontSize: isMobile ? '12px' : '13px',
                  color: '#ffffff',
                  background: `linear-gradient(135deg, ${currentTheme.primaryColor}, ${currentTheme.secondaryColor})`,
                  boxShadow: `0 4px 12px ${currentTheme.primaryColor}45`,
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                  minWidth: isMobile ? '102px' : '120px',
                  marginLeft: '8px'
                }}
              >
                View Cart →
              </button>
            </div>
          </div>
        )}

        {/* Bottom Navigation — Fixed to bottom */}
        {!showSplash && !isPremiumCarouselTheme && !isNewDevelopmentTheme && (
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: currentTheme.glassPanel,
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          borderTop: currentTheme.glassPanelBorder || `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.06)'}`,
          display: 'flex',
          justifyContent: 'space-around',
          padding: '8px 0 calc(8px + env(safe-area-inset-bottom, 0px))', 
          boxShadow: currentTheme.glassPanelShadow || '0 -4px 20px rgba(0, 0, 0, 0.1)',
          zIndex: 9999
        }}>
          {['home', 'menu', 'cart'].map(view => {
            const isActive = currentView === view;
            return (
              <button
                key={view}
                onClick={() => setCurrentView(view)}
                style={{
                  position: 'relative',
                  background: 'none',
                  border: 'none',
                  color: isActive ? currentTheme.primaryColor : currentTheme.isDark ? '#cbd5e1' : '#64748b',
                  cursor: 'pointer',
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px',
                  padding: '4px 0',
                  outline: 'none',
                  WebkitTapHighlightColor: 'transparent',
                  transform: isActive ? 'translateY(-2px)' : 'translateY(0)',
                  transition: 'all 0.3s ease'
                }}
                className="btn-hover bottom-nav-btn"
              >
                <div style={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '32px',
                  height: '32px',
                  zIndex: 2
                }}>
                  {/* Fluid Wave Background */}
                  {isActive && (
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      width: '45px',
                      height: '45px',
                      background: currentTheme.primaryColor,
                      opacity: 0.15,
                      transform: 'translate(-50%, -50%)',
                      animation: 'waterWaveFloat 4s linear infinite',
                      zIndex: -1
                    }} />
                  )}
                  
                  {/* Icons */}
                  {view === 'home' && (
                    <svg width="22" height="22" viewBox="0 0 24 24" fill={isActive ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                  )}
                  {view === 'menu' && (
                    isShopMode ? (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="7" height="7" rx="1" />
                        <rect x="14" y="3" width="7" height="7" rx="1" />
                        <rect x="3" y="14" width="7" height="7" rx="1" />
                        <rect x="14" y="14" width="7" height="7" rx="1" />
                      </svg>
                    ) : (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                        <path d="M7 2v20" />
                        <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
                      </svg>
                    )
                  )}
                  {view === 'cart' && (
                    <>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill={isActive ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="9" cy="21" r="1"></circle>
                        <circle cx="20" cy="21" r="1"></circle>
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                      </svg>
                      {cart.length > 0 && (
                        <span style={{
                          position: 'absolute',
                          top: '-6px',
                          right: '-10px',
                          background: '#ef4444',
                          color: 'white',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          padding: '2px 6px',
                          borderRadius: '10px',
                          border: `2px solid ${currentTheme.glassPanel}`
                        }}>
                          {getCartCount()}
                        </span>
                      )}
                    </>
                  )}
                </div>
                
                <span style={{
                  fontSize: '11px',
                  letterSpacing: '0.03em',
                  fontWeight: isActive ? '700' : '500',
                  marginTop: '2px',
                  transition: 'all 0.3s ease'
                }}>
                  {view === 'menu' ? (isShopMode ? 'Products' : 'Menu') : view.charAt(0).toUpperCase() + view.slice(1)}
                </span>
              </button>
            );
          })}
        </div>
        )}
      </div>

      {/* ── Checkout Modal (Fully Template-Specific & Themed) ────────────────────────────────────────── */}
      {showCheckoutModal && (() => {
        const theme = currentTheme || TEMPLATE_THEMES['Normal'];
        const themeIcon = theme.icon || (isRajasthanTheme ? '👑' : '🍽️');
        const primary = theme.primaryColor || '#c9a96e';
        const secondary = theme.secondaryColor || primary;
        const accent = theme.accentColor || primary;
        const isDark = Boolean(theme.isDark);
        
        // Dynamic theme styling
        const btnGrad = theme.categoryActiveGrad || `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)`;
        const modalBg = isDark
          ? (theme.splashBg ? `linear-gradient(160deg, ${theme.splashBg} 0%, #0b0f19 100%)` : 'linear-gradient(160deg, #1e293b 0%, #0f172a 100%)')
          : (theme.gradient?.includes('gradient') ? theme.gradient : 'linear-gradient(160deg, #ffffff 0%, #f8fafc 100%)');
        
        const cardBg = isDark
          ? (theme.glassCard || 'rgba(255, 255, 255, 0.05)')
          : (theme.glassCard || 'rgba(255, 255, 255, 0.88)');
        
        const borderStyle = isDark
          ? `1px solid ${primary}35`
          : `1.5px solid ${primary}30`;
        
        const textColor = isDark ? '#f8fafc' : '#0f172a';
        const mutedColor = isDark ? '#94a3b8' : '#64748b';
        const inputBg = isDark ? 'rgba(15, 23, 42, 0.75)' : '#ffffff';
        const inputBorder = isDark ? 'rgba(255, 255, 255, 0.18)' : `${primary}45`;
        const glowShadow = theme.categoryActiveShadow || `0 8px 24px ${primary}40`;
        const fulfillmentLabel = fulfillmentType === 'DELIVERY' ? '🛵 Delivery' : (fulfillmentType === 'TAKEAWAY' ? '🛍️ Takeaway' : '🚗 Drive-through');

        return (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(15, 23, 42, 0.70)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10001,
          padding: isMobile ? '10px' : '20px'
        }}
          onClick={() => !processingPayment && setShowCheckoutModal(false)}>
          <div style={{
            background: modalBg,
            border: borderStyle,
            boxShadow: `0 25px 60px rgba(0,0,0,0.35), 0 0 25px ${primary}20`,
            borderRadius: isMobile ? '20px' : '26px',
            padding: isMobile ? '20px 16px' : '28px 26px',
            width: isMobile ? '100%' : 'min(94vw, 590px)',
            maxWidth: isMobile ? '440px' : '590px',
            position: 'relative',
            maxHeight: '92vh',
            overflowY: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
            onClick={e => e.stopPropagation()}>
            
            {/* Close Button */}
            <button
              type="button"
              onClick={() => !processingPayment && setShowCheckoutModal(false)}
              style={{
                position: 'absolute',
                top: '18px',
                right: '18px',
                width: '34px',
                height: '34px',
                borderRadius: '50%',
                background: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
                border: borderStyle,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                fontWeight: 700,
                cursor: 'pointer',
                color: mutedColor,
                transition: 'all 0.2s ease'
              }}
            >✕</button>

            {/* Themed Header */}
            <div style={{ marginBottom: '18px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
                {!isNewDevelopmentTheme && themeIcon && <span style={{ fontSize: '20px' }}>{themeIcon}</span>}
                <h2 style={{
                  fontSize: '22px',
                  fontWeight: '900',
                  color: textColor,
                  margin: 0,
                  letterSpacing: '-0.02em',
                  fontFamily: theme.font || "'Inter', 'Poppins', sans-serif"
                }}>
                  Checkout
                </h2>
                <span style={{
                  fontSize: '11px',
                  fontWeight: '700',
                  padding: '3px 10px',
                  borderRadius: '20px',
                  background: isDark ? `${primary}25` : `${primary}18`,
                  color: primary,
                  border: `1px solid ${primary}45`
                }}>
                  {fulfillmentLabel}
                </span>
              </div>
              <p style={{ fontSize: '13px', color: mutedColor, margin: 0 }}>
                Delivering from <strong style={{ color: primary }}>{restaurant?.restaurantName || 'Restaurant'}</strong>
              </p>
            </div>

            {/* Themed Bill Summary Card */}
            <div style={{
              border: borderStyle,
              background: cardBg,
              backdropFilter: 'blur(8px)',
              borderRadius: '18px',
              padding: '14px 16px',
              marginBottom: '18px',
              boxShadow: '0 6px 16px rgba(0,0,0,0.04)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: mutedColor, marginBottom: '6px' }}>
                <span>Item total</span><strong style={{ color: textColor }}>₹{getCartPricing().subtotal.toFixed(2)}</strong>
              </div>
              {fulfillmentType === 'DELIVERY' && (
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: mutedColor, marginBottom: '6px' }}>
                  <span>Delivery fee</span><strong style={{ color: textColor }}>₹{getCartPricing().deliveryCharge.toFixed(2)}</strong>
                </div>
              )}
              {getCartPricing().discountAmount > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#16a34a', marginBottom: '6px', fontWeight: 700 }}>
                  <span>Discount ({getCartPricing().appliedCouponCode || 'Coupon'})</span>
                  <strong>-₹{getCartPricing().discountAmount.toFixed(2)}</strong>
                </div>
              )}
              {getCartPricing().taxAmount > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: mutedColor, marginBottom: '6px' }}>
                  <span>{gstSettings.taxName || 'GST'}{getCartPricing().taxEnabled ? ` (${getCartPricing().taxPercentage.toFixed(2)}%)` : ''}</span>
                  <strong style={{ color: textColor }}>₹{getCartPricing().taxAmount.toFixed(2)}</strong>
                </div>
              )}
              <div style={{ height: '1px', background: isDark ? 'rgba(255,255,255,0.1)' : `${primary}20`, margin: '10px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '16px', color: textColor, fontWeight: '800' }}>
                <span>To Pay</span>
                <span style={{ fontSize: '19px', color: primary, fontWeight: 900 }}>₹{getCartTotal().toFixed(2)}</span>
              </div>
            </div>

            {fulfillmentType === 'DELIVERY' && getCartPricing().belowMinimum && (
              <div style={{ background: isDark ? 'rgba(234,88,12,0.15)' : '#ffedd5', color: '#ea580c', border: '1px solid rgba(234,88,12,0.3)', padding: '10px 14px', borderRadius: '12px', fontSize: '13px', fontWeight: 600, marginBottom: '14px' }}>
                ⚠️ Minimum order for delivery is ₹{getCartPricing().minimumOrderAmount.toFixed(2)}.
              </div>
            )}

            {paymentError && (
              <div style={{ background: isDark ? 'rgba(220,38,38,0.15)' : '#fee2e2', color: '#dc2626', border: '1px solid rgba(220,38,38,0.3)', padding: '10px 14px', borderRadius: '12px', fontSize: '13px', fontWeight: 600, marginBottom: '16px' }}>
                {paymentError}
              </div>
            )}

            {/* Themed Coupon Section - Hidden for NewDevelopmentTheme as coupons are managed on cart review screen */}
            {!isNewDevelopmentTheme && (
              <div style={{ marginBottom: '18px' }}>
                <div style={{ marginBottom: '8px', fontSize: '11px', fontWeight: '800', color: primary, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                  🏷️ Apply Coupon
                </div>

              <div style={{ marginBottom: '8px', display: 'flex', gap: '8px' }}>
                <input
                  type="text"
                  placeholder="Enter coupon code"
                  value={couponCode}
                  onChange={(e) => setCouponCode(String(e.target.value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase())}
                  disabled={processingPayment || applyingCoupon}
                  style={{
                    flex: 1,
                    padding: '11px 14px',
                    borderRadius: '12px',
                    fontSize: '14px',
                    fontWeight: '700',
                    letterSpacing: '0.05em',
                    border: `1.5px solid ${inputBorder}`,
                    background: inputBg,
                    color: textColor,
                    outline: 'none',
                    transition: 'border-color 0.2s'
                  }}
                />
                <button
                  type="button"
                  onClick={() => handleApplyCoupon()}
                  disabled={processingPayment || applyingCoupon}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '12px',
                    border: 'none',
                    fontWeight: '700',
                    fontSize: '13px',
                    cursor: (processingPayment || applyingCoupon) ? 'not-allowed' : 'pointer',
                    background: (processingPayment || applyingCoupon)
                      ? (isDark ? '#475569' : '#94a3b8')
                      : btnGrad,
                    color: '#ffffff',
                    boxShadow: (processingPayment || applyingCoupon) ? 'none' : glowShadow,
                    transition: 'all 0.2s ease'
                  }}
                >
                  {applyingCoupon ? 'Applying...' : 'Apply'}
                </button>
              </div>

              <button
                type="button"
                onClick={handleToggleCoupons}
                disabled={processingPayment}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: primary,
                  background: 'transparent',
                  border: 'none',
                  padding: 0,
                  cursor: processingPayment ? 'not-allowed' : 'pointer',
                  textDecoration: 'none'
                }}
              >
                <span>{showCouponList ? '▲ Hide Available Coupons' : '🏷️ View Available Coupons'}</span>
              </button>

              {showCouponList && (
                <div style={{ marginTop: '10px', marginBottom: '14px' }}>
                  {couponsLoading && (
                    <div style={{ fontSize: '12px', color: mutedColor, padding: '8px 4px' }}>
                      Loading coupons...
                    </div>
                  )}
                  {!couponsLoading && couponsError && (
                    <div style={{ fontSize: '12px', color: '#dc2626', padding: '8px 4px' }}>
                      {couponsError}
                    </div>
                  )}
                  {!couponsLoading && !couponsError && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      {availableCoupons.map((coupon) => (
                        <div
                          key={coupon?.id || coupon?.couponCode}
                          style={{
                            border: `1.5px dashed ${primary}70`,
                            borderRadius: '14px',
                            padding: '12px 14px',
                            background: cardBg,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.04)'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '8px' }}>
                            <div>
                              <div style={{ fontSize: '14px', fontWeight: '800', color: primary, letterSpacing: '0.04em' }}>
                                {String(coupon?.couponCode || '').toUpperCase()}
                              </div>
                              <div style={{ fontSize: '12px', color: mutedColor, marginTop: '3px' }}>
                                {formatCouponDescription(coupon)}
                              </div>
                              {formatCouponExpiry(coupon) && (
                                <div style={{ fontSize: '11px', color: mutedColor, marginTop: '3px', opacity: 0.8 }}>
                                  {formatCouponExpiry(coupon)}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              onClick={() => {
                                const code = String(coupon?.couponCode || '').toUpperCase();
                                setCouponCode(code);
                                setShowCouponList(false);
                                handleApplyCoupon(code);
                              }}
                              disabled={processingPayment || applyingCoupon}
                              style={{
                                border: 'none',
                                borderRadius: '8px',
                                padding: '6px 14px',
                                background: btnGrad,
                                color: '#ffffff',
                                fontSize: '12px',
                                fontWeight: '700',
                                cursor: (processingPayment || applyingCoupon) ? 'not-allowed' : 'pointer',
                                boxShadow: glowShadow,
                                whiteSpace: 'nowrap'
                              }}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {appliedCoupon && (
                <div style={{
                  marginTop: '10px',
                  padding: '10px 14px',
                  borderRadius: '12px',
                  border: '1px solid #bbf7d0',
                  background: isDark ? 'rgba(22,163,74,0.15)' : '#f0fdf4',
                  color: '#16a34a',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '8px'
                }}>
                  <div style={{ fontSize: '13px', fontWeight: '700' }}>
                    {(() => {
                      const appliedUpToValue = Number(appliedCoupon?.upToValue ?? appliedCoupon?.up_to_value ?? 0);
                      const isPercent = String(appliedCoupon?.discountType || '').toUpperCase() === 'PERCENT';
                      const upToLabel = isPercent && appliedUpToValue > 0
                        ? ` (Up to ₹${appliedUpToValue.toFixed(0)})`
                        : '';
                      return `✓ Applied ${appliedCoupon.couponCode}${upToLabel} • Saved ₹${Number(appliedCoupon.discountAmount || 0).toFixed(2)}`;
                    })()}
                  </div>
                  <button
                    type="button"
                    onClick={handleRemoveCoupon}
                    disabled={processingPayment}
                    style={{
                      border: 'none',
                      borderRadius: '8px',
                      padding: '4px 10px',
                      background: processingPayment ? '#9ca3af' : '#ef4444',
                      color: '#ffffff',
                      fontSize: '11px',
                      fontWeight: '700',
                      cursor: processingPayment ? 'not-allowed' : 'pointer'
                    }}
                  >
                    Remove
                  </button>
                </div>
              )}
            </div>
            )}

            {/* Themed Contact Details */}
            <div style={{ marginBottom: '8px', fontSize: '11px', fontWeight: '800', color: primary, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
              👤 Contact Details
            </div>

            <div style={{ marginBottom: '14px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: isFilled(checkoutForm.name) ? textColor : '#dc2626', marginBottom: '6px' }}>
                Full Name * {!isFilled(checkoutForm.name) && <span style={{ fontSize: '12px', fontWeight: '700' }}>({requiredHint})</span>}
              </label>
              <input
                type="text"
                placeholder="Enter your full name"
                value={checkoutForm.name}
                onChange={e => setCheckoutForm(p => ({ ...p, name: e.target.value }))}
                title={!isFilled(checkoutForm.name) ? requiredHint : ''}
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: '12px', fontSize: '14px', boxSizing: 'border-box',
                  border: `1.5px solid ${isFilled(checkoutForm.name) ? inputBorder : '#dc2626'}`,
                  background: inputBg,
                  color: textColor,
                  outline: 'none'
                }}
              />
              {!isFilled(checkoutForm.name) && <div style={{ marginTop: '4px', fontSize: '12px', color: '#dc2626', fontWeight: '600' }}>{requiredHint}</div>}
            </div>

            <div style={{ marginBottom: '14px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: '700', color: isFilled(checkoutForm.phone) ? textColor : '#dc2626', marginBottom: '6px' }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ flexShrink: 0 }}>
                  <path d="M20.52 3.48A11.89 11.89 0 0 0 12.04 0C5.46 0 .1 5.35.1 11.93c0 2.1.55 4.16 1.6 5.97L0 24l6.3-1.65a11.92 11.92 0 0 0 5.73 1.46h.01c6.58 0 11.93-5.35 11.93-11.93 0-3.19-1.24-6.19-3.45-8.4Z" fill="#25D366"/>
                  <path d="M17.2 14.15c-.28-.14-1.64-.8-1.9-.9-.25-.1-.43-.14-.62.14-.18.28-.71.9-.87 1.08-.16.18-.32.21-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.73-1.37-1.63-1.53-1.9-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.19-.28.28-.46.1-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.54-.44-.46-.62-.47h-.53c-.18 0-.46.07-.7.35-.24.28-.92.9-.92 2.2 0 1.3.94 2.55 1.07 2.72.13.18 1.86 2.84 4.52 3.98.63.27 1.12.43 1.5.55.63.2 1.2.17 1.65.1.5-.07 1.64-.67 1.87-1.32.23-.65.23-1.2.16-1.32-.06-.12-.24-.2-.52-.35Z" fill="white"/>
                </svg>
                WhatsApp Number *
                {!isFilled(checkoutForm.phone) && <span style={{ fontSize: '12px', fontWeight: '700' }}>({requiredHint})</span>}
              </label>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                border: `1.5px solid ${isFilled(checkoutForm.phone) ? inputBorder : '#dc2626'}`,
                borderRadius: '12px',
                background: inputBg,
                overflow: 'hidden'
              }}>
                <div style={{
                  padding: '11px 14px',
                  fontSize: '14px',
                  fontWeight: '700',
                  color: textColor,
                  background: isDark ? 'rgba(255,255,255,0.06)' : `${primary}12`,
                  borderRight: `1px solid ${inputBorder}`,
                  userSelect: 'none'
                }}>
                  +91
                </div>
                <input
                  type="tel"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={10}
                  placeholder="Enter 10-digit WhatsApp number"
                  value={checkoutForm.phone}
                  onChange={e => {
                    const digitsOnly = String(e.target.value || '').replace(/\D/g, '').slice(0, 10);
                    setCheckoutForm(p => ({ ...p, phone: digitsOnly }));
                  }}
                  title={!isFilled(checkoutForm.phone) ? requiredHint : ''}
                  style={{
                    width: '100%', padding: '11px 14px', borderRadius: '0', fontSize: '14px', boxSizing: 'border-box',
                    border: 'none',
                    outline: 'none',
                    background: inputBg,
                    color: textColor
                  }}
                />
              </div>
              {!isFilled(checkoutForm.phone) && <div style={{ marginTop: '4px', fontSize: '12px', color: '#dc2626', fontWeight: '600' }}>{requiredHint}</div>}
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: textColor, marginBottom: '6px' }}>Email for payment confirmation & invoice (optional)</label>
              <input
                type="email"
                placeholder="Enter email for payment confirmation & invoice"
                value={checkoutForm.email}
                onChange={e => setCheckoutForm(p => ({ ...p, email: e.target.value }))}
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: '12px', fontSize: '14px', boxSizing: 'border-box',
                  border: `1.5px solid ${inputBorder}`,
                  background: inputBg,
                  color: textColor,
                  outline: 'none'
                }}
              />
            </div>

            {/* Delivery Details */}
            {fulfillmentType === 'DELIVERY' && (
              <>
            <div style={{ marginBottom: '8px', fontSize: '11px', fontWeight: '800', color: primary, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
              📍 Delivery Address
            </div>

            {/* Complete Delivery Address (First) */}
            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: isFilled(checkoutForm.addressLine) ? textColor : '#dc2626', marginBottom: '6px' }}>
                Complete Delivery Address * {!isFilled(checkoutForm.addressLine) && <span style={{ fontSize: '12px', fontWeight: '700' }}>({requiredHint})</span>}
              </label>
              <textarea
                ref={addressLineRef}
                placeholder="House/Flat number, Building name, Street, Area"
                value={checkoutForm.addressLine}
                onChange={e => setCheckoutForm(p => ({ ...p, addressLine: e.target.value }))}
                rows={2}
                title={!isFilled(checkoutForm.addressLine) ? requiredHint : ''}
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: '12px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical',
                  border: `1.5px solid ${isFilled(checkoutForm.addressLine) ? inputBorder : '#dc2626'}`,
                  background: inputBg,
                  color: textColor,
                  outline: 'none'
                }}
              />
            </div>

            {/* Landmark & City (Middle) */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
              <input
                type="text"
                placeholder="Landmark (optional)"
                value={checkoutForm.landmark}
                onChange={e => setCheckoutForm(p => ({ ...p, landmark: e.target.value }))}
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: '12px', fontSize: '13px', boxSizing: 'border-box',
                  border: `1.5px solid ${inputBorder}`,
                  background: inputBg,
                  color: textColor,
                  outline: 'none'
                }}
              />
              <input
                type="text"
                placeholder="City"
                value={checkoutForm.city}
                disabled={Boolean(restaurant?.isCityFixed ?? restaurant?.is_city_fixed)}
                readOnly={Boolean(restaurant?.isCityFixed ?? restaurant?.is_city_fixed)}
                onChange={e => setCheckoutForm(p => ({ ...p, city: e.target.value }))}
                title={Boolean(restaurant?.isCityFixed ?? restaurant?.is_city_fixed) ? "City is fixed by store" : "Enter city"}
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: '12px', fontSize: '13px', boxSizing: 'border-box',
                  border: Boolean(restaurant?.isCityFixed ?? restaurant?.is_city_fixed)
                    ? (isDark ? '1.5px solid rgba(255,255,255,0.1)' : `1.5px solid ${primary}20`)
                    : `1.5px solid ${inputBorder}`,
                  background: Boolean(restaurant?.isCityFixed ?? restaurant?.is_city_fixed)
                    ? (isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)')
                    : inputBg,
                  color: Boolean(restaurant?.isCityFixed ?? restaurant?.is_city_fixed) ? mutedColor : textColor,
                  cursor: Boolean(restaurant?.isCityFixed ?? restaurant?.is_city_fixed) ? 'not-allowed' : 'text',
                  outline: 'none'
                }}
              />
            </div>

            {/* Locality Dropdown (LAST in delivery address block) */}
            <div ref={localityDropdownRef} style={{ position: 'relative', marginBottom: '14px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', marginBottom: '6px' }}>
                <label style={{ fontSize: '13px', fontWeight: '700', color: textColor }}>
                  Search and select locality (optional)
                </label>
                {!hasValidSelectedLocality && !inputValue.trim() && (
                  <span style={{ fontSize: '12px', fontWeight: '700', color: '#dc2626' }}>{requiredHint}</span>
                )}
              </div>
              <input
                type="text"
                placeholder="Search and select locality (optional)"
                value={inputValue}
                onFocus={() => setShowLocalityDropdown(true)}
                onChange={(e) => {
                  const value = e.target.value;
                  setLocalitySearchText(value);
                  setFilteredLocalities(filterLocalities(localities, value));
                  setShowLocalityDropdown(true);

                  if (!selectedLocality) return;
                  const selectedName = String(selectedLocality.localityName || '').trim().toLowerCase();
                  const typed = String(value || '').trim().toLowerCase();
                  if (typed !== selectedName) {
                    setSelectedLocality(null);
                  }
                }}
                onBlur={() => {
                  window.setTimeout(() => {
                    setShowLocalityDropdown(false);
                  }, 120);
                }}
                title={!hasValidSelectedLocality ? requiredHint : ''}
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: '12px', fontSize: '13px', boxSizing: 'border-box',
                  border: hasSelectedAValidLocality ? '1.5px solid #10b981' : `1.5px solid ${inputBorder}`,
                  background: inputBg,
                  color: textColor,
                  outline: 'none'
                }}
              />

              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                marginTop: '4px',
                maxHeight: '190px',
                overflowY: 'auto',
                background: isDark ? '#1e293b' : '#ffffff',
                border: borderStyle,
                borderRadius: '12px',
                zIndex: 30,
                boxShadow: '0 12px 30px rgba(0,0,0,0.22)',
                display: showLocalityDropdown ? 'block' : 'none'
              }}>
                {loadingLocalities && (
                  <div style={{ padding: '10px 14px', fontSize: '12px', color: mutedColor }}>Loading localities...</div>
                )}

                {!loadingLocalities && hasFetchedLocalities && filteredLocalities.length === 0 && (
                  <div style={{ padding: '10px 14px', fontSize: '12px', color: mutedColor }}>No matching localities found</div>
                )}

                {!loadingLocalities && filteredLocalities.map((locality) => {
                  const key = `${locality.localityCode || 'code'}-${locality.localityName || 'name'}`;
                  return (
                    <button
                      type="button"
                      key={key}
                      onMouseDown={(event) => event.preventDefault()}
                      onClick={() => handleSelectLocality(locality)}
                      style={{
                        width: '100%',
                        textAlign: 'left',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        padding: '10px 14px',
                        borderBottom: isDark ? '1px solid rgba(255,255,255,0.06)' : `1px solid ${primary}15`
                      }}
                    >
                      <div style={{ fontSize: '13px', fontWeight: '700', color: textColor }}>
                        {renderHighlightedLocalityText(locality.localityName, inputValue)}
                      </div>
                    </button>
                  );
                })}
              </div>

              {inputValue.trim() && !selectedLocality && !(hasFetchedLocalities && localities.length === 0) && (
                <div style={{ marginTop: '6px', fontSize: '12px', color: '#dc2626' }}>
                  Please select locality
                </div>
              )}
            </div>
              </>
            )}

            {fulfillmentType === 'DRIVETHROUGH' && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '18px' }}>
                <input
                  type="text"
                  placeholder="Vehicle colour (optional)"
                  value={checkoutForm.vehicleColor}
                  onChange={e => setCheckoutForm(p => ({ ...p, vehicleColor: e.target.value }))}
                  style={{
                    width: '100%', padding: '11px 14px', borderRadius: '12px', fontSize: '13px', boxSizing: 'border-box',
                    border: `1.5px solid ${inputBorder}`,
                    background: inputBg,
                    color: textColor,
                    outline: 'none'
                  }}
                />
                <input
                  type="text"
                  placeholder="Vehicle number *"
                  value={checkoutForm.vehicleNumber}
                  onChange={e => setCheckoutForm(p => ({ ...p, vehicleNumber: e.target.value }))}
                  style={{
                    width: '100%', padding: '11px 14px', borderRadius: '12px', fontSize: '13px', boxSizing: 'border-box',
                    border: `1.5px solid ${isFilled(checkoutForm.vehicleNumber) ? inputBorder : '#dc2626'}`,
                    background: inputBg,
                    color: textColor,
                    outline: 'none'
                  }}
                />
              </div>
            )}

            <div style={{ marginBottom: '18px' }}>
              <textarea
                placeholder="Delivery instructions / notes (optional)"
                value={checkoutForm.deliveryInstructions}
                onChange={e => setCheckoutForm(p => ({ ...p, deliveryInstructions: e.target.value }))}
                rows={2}
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: '12px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical',
                  border: `1.5px solid ${inputBorder}`,
                  background: inputBg,
                  color: textColor,
                  outline: 'none'
                }}
              />
            </div>

            {/* Themed Proceed to Pay Button */}
            {!onlinePaymentConfigured ? (
              <button
                type="button"
                onClick={() => {
                  setShowCheckoutModal(false);
                  setShowNoOnlinePaymentModal(true);
                }}
                style={{
                  width: '100%',
                  padding: '16px 20px',
                  borderRadius: '16px',
                  border: 'none',
                  background: btnGrad,
                  color: '#ffffff',
                  fontSize: '15px',
                  fontWeight: '700',
                  letterSpacing: '0.01em',
                  cursor: 'pointer',
                  boxShadow: glowShadow,
                  transition: 'all 0.25s ease'
                }}
              >
                Online Payment Unavailable • Order via Call / WhatsApp
              </button>
            ) : (
              <button
                onClick={handleRazorpayCheckout}
                disabled={processingPayment || (fulfillmentType === 'DELIVERY' && (getCartPricing().belowMinimum || !hasValidSelectedLocality))}
                style={{
                  width: '100%',
                  padding: '16px 20px',
                  borderRadius: '16px',
                  border: 'none',
                  background: processingPayment
                    ? (isDark ? '#475569' : '#94a3b8')
                    : btnGrad,
                  color: '#ffffff',
                  fontSize: '16px',
                  fontWeight: '800',
                  letterSpacing: '0.02em',
                  cursor: (processingPayment || (fulfillmentType === 'DELIVERY' && (getCartPricing().belowMinimum || !hasValidSelectedLocality))) ? 'not-allowed' : 'pointer',
                  boxShadow: processingPayment ? 'none' : glowShadow,
                  transition: 'all 0.25s ease'
                }}
              >
                {processingPayment ? 'Processing payment...' : `Proceed to Pay ₹${getCartTotal().toFixed(2)}`}
              </button>
            )}

            <p style={{ marginTop: '12px', marginBottom: 0, fontSize: '11px', color: mutedColor, textAlign: 'center', fontWeight: '500' }}>
              {onlinePaymentConfigured ? '100% secure payments powered by Razorpay' : 'Contact directly for payment & order placement'}
            </p>
          </div>
        </div>
        );
      })()}

      {showClearCartConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(15, 23, 42, 0.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10002,
            padding: isMobile ? '16px' : '24px'
          }}
          onClick={closeClearCartConfirm}
        >
          <div
            style={{
              width: isMobile ? '100%' : 'min(92vw, 420px)',
              maxWidth: '420px',
              borderRadius: '16px',
              background: currentTheme.isDark ? '#0f172a' : '#ffffff',
              border: `1px solid ${currentTheme.isDark ? 'rgba(148,163,184,0.25)' : '#e2e8f0'}`,
              boxShadow: '0 24px 60px rgba(2, 6, 23, 0.35)',
              padding: isMobile ? '18px 16px' : '22px 20px'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
              <span style={{ fontSize: '22px' }}>🗑️</span>
              <h3 style={{
                margin: 0,
                fontSize: isMobile ? '18px' : '20px',
                fontWeight: '800',
                color: currentTheme.isDark ? '#f8fafc' : '#0f172a'
              }}>
                Clear cart?
              </h3>
            </div>

            <p style={{
              margin: '0 0 16px 0',
              fontSize: '14px',
              lineHeight: '1.5',
              color: currentTheme.isDark ? '#cbd5e1' : '#475569'
            }}>
              This will remove all items from your cart. You can add them again anytime.
            </p>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={closeClearCartConfirm}
                style={{
                  border: `1px solid ${currentTheme.isDark ? 'rgba(148,163,184,0.45)' : '#cbd5e1'}`,
                  background: currentTheme.isDark ? 'rgba(15,23,42,0.6)' : '#f8fafc',
                  color: currentTheme.isDark ? '#e2e8f0' : '#334155',
                  borderRadius: '10px',
                  padding: isMobile ? '10px 14px' : '10px 16px',
                  fontSize: '14px',
                  fontWeight: '700',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={clearCart}
                style={{
                  border: 'none',
                  background: '#dc2626',
                  color: '#ffffff',
                  borderRadius: '10px',
                  padding: isMobile ? '10px 14px' : '10px 16px',
                  fontSize: '14px',
                  fontWeight: '800',
                  cursor: 'pointer',
                  boxShadow: '0 8px 20px rgba(220, 38, 38, 0.28)'
                }}
              >
                Yes, clear cart
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ─────────────────────────────────────────────────────────── */}

      {/* Addon Selection Modal */}
      {!isNewDevelopmentTheme && showAddonModal && currentProduct && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: isMobile ? '8px' : '14px'
        }}
          onClick={closeAddonModal}
        >
          <div style={{
            backgroundColor: 'white',
            borderRadius: isMobile ? '18px' : '20px',
            maxWidth: isMobile ? '96vw' : '560px',
            width: isMobile ? '96vw' : '100%',
            maxHeight: isMobile ? '94vh' : '88vh',
            overflow: 'auto',
            boxShadow: '0 10px 40px rgba(0,0,0,0.3)'
          }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div style={{
              padding: isMobile ? '14px 14px 12px 14px' : '20px',
              borderBottom: '2px solid #e5e7eb',
              position: 'sticky',
              top: 0,
              backgroundColor: 'white',
              borderTopLeftRadius: '20px',
              borderTopRightRadius: '20px',
              zIndex: 10
            }}>
              <h2 style={{
                fontSize: isMobile ? '18px' : '22px',
                fontWeight: '700',
                color: '#1f2937',
                marginBottom: '4px'
              }}>
                Customize Your {currentProduct.productName}
              </h2>
              <p style={{
                fontSize: isMobile ? '12px' : '14px',
                color: '#6b7280',
                marginTop: '4px'
              }}>
                Select add-ons to customize your order
              </p>
            </div>

            {/* Addons List */}
            <div style={{ padding: isMobile ? '12px' : '20px' }}>
              {loadingAddons ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <p style={{ color: '#6b7280' }}>Loading add-ons...</p>
                </div>
              ) : availableAddons.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <p style={{ color: '#6b7280' }}>No add-ons available</p>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '10px' : '14px' }}>
                  {Object.values(
                    availableAddons.reduce((acc, addon) => {
                      const fallbackId = addon?.groupId || `group-${addon?.groupName || 'addons'}`;
                      const groupId = String(fallbackId);
                      if (!acc[groupId]) {
                        acc[groupId] = {
                          groupId,
                          groupName: addon?.groupName || selectionRulesByGroup?.[groupId]?.groupName || 'Add-ons',
                          groupDisplayOrder: Number(
                            addon?.groupDisplayOrder
                            ?? selectionRulesByGroup?.[groupId]?.displayOrder
                            ?? 9999
                          ),
                          groupOptions: []
                        };
                      }
                      acc[groupId].groupOptions.push(addon);
                      return acc;
                    }, {})
                  )
                    .sort((a, b) => a.groupDisplayOrder - b.groupDisplayOrder)
                    .map(({ groupId, groupName, groupOptions }) => {
                    const matchedRule = selectionRulesByGroup?.[groupId]
                      || Object.values(selectionRulesByGroup || {}).find(
                        (rule) => String(rule?.groupName || '').toLowerCase() === String(groupName || '').toLowerCase()
                      );

                    const dependsOnGroupId = matchedRule?.dependsOnGroupId;
                    const selectedParentOption = dependsOnGroupId
                      ? selectedAddons.find((item) => String(item?.groupId) === String(dependsOnGroupId))
                      : null;

                    if (dependsOnGroupId && !selectedParentOption) {
                      return null;
                    }

                    const contextFilteredOptions = (groupOptions || []).filter((addon) =>
                      matchesDependentContext(addon, selectedParentOption)
                    );

                    if (contextFilteredOptions.length === 0) {
                      return null;
                    }

                    const resolvedGroupName = matchedRule?.dynamicLabel && selectedParentOption
                      ? `${groupName} [${selectedParentOption?.addonName || selectedParentOption?.optionName || ''}]`
                      : groupName;

                    const groupMin = Number(matchedRule?.minSelection || 0);
                    const groupMax = Number(matchedRule?.maxSelection || 0);
                    const selectionText = matchedRule ? getSelectionText(groupMin, groupMax) : '';
                    const isGroupRequired = groupMin > 0 || !!matchedRule?.isRequired;
                    const isAddonGroup = /addon|add-on|add ons|add-ons/i.test(String(resolvedGroupName || ''));
                    const showMandatoryLabel = isGroupRequired && !isAddonGroup;

                    return (
                      <div key={groupId} style={{ border: '1px solid #e2e8f0', borderRadius: '14px', background: '#ffffff', overflow: 'hidden', boxShadow: '0 6px 14px rgba(15, 23, 42, 0.06)' }}>
                        <div style={{ padding: isMobile ? '10px 12px' : '12px 14px', borderBottom: '1px solid #e2e8f0', background: '#ffffff' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <div style={{ fontSize: '13px', fontWeight: '800', color: currentTheme.primaryColor }}>
                              {resolvedGroupName}
                            </div>
                            <span
                              style={{
                                fontSize: '12px',
                                fontWeight: showMandatoryLabel ? 700 : 600,
                                color: showMandatoryLabel ? '#e53935' : '#16a34a'
                              }}
                            >
                              {showMandatoryLabel ? 'Mandatory *' : '(Optional)'}
                            </span>
                          </div>
                          {selectionText && (
                            <div style={{ marginTop: '2px', fontSize: '11px', color: '#64748b' }}>
                              {selectionText}
                            </div>
                          )}
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          {contextFilteredOptions.map((addon, index) => {
                            const isSelected = selectedAddons.find((a) => getAddonIdentityKey(a) === getAddonIdentityKey(addon));
                            const optionKey = addon?.optionId || addon?.legacyAddonId || addon?.addonId || addon?.addonName;
                            return (
                              <div
                                key={`${groupId}-${optionKey}`}
                                onClick={() => toggleAddonSelection(addon)}
                                style={{
                                  padding: isMobile ? '12px' : '14px',
                                  borderBottom: index === contextFilteredOptions.length - 1 ? 'none' : '1px solid #e2e8f0',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  gap: '12px',
                                  background: '#ffffff'
                                }}
                              >
                                <div style={{
                                  fontSize: isMobile ? '15px' : '16px',
                                  fontWeight: '600',
                                  color: '#1f2937',
                                  flex: 1,
                                  minWidth: 0
                                }}>
                                  {addon.addonName}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
                                  <div style={{
                                    fontSize: isMobile ? '13px' : '14px',
                                    fontWeight: '600',
                                    color: '#059669'
                                  }}>
                                    ₹{Number(addon.addonPrice || 0).toFixed(2)}
                                  </div>
                                  <div style={{
                                    width: '22px',
                                    height: '22px',
                                    borderRadius: '50%',
                                    border: `2px solid ${isSelected ? '#10b981' : '#d1d5db'}`,
                                    backgroundColor: isSelected ? '#10b981' : 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '12px',
                                    color: 'white'
                                  }}>
                                    {isSelected && '✓'}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              <div style={{ marginTop: isMobile ? '10px' : '14px' }}>
                <div style={{ fontSize: '12px', color: '#64748b', lineHeight: 1.5 }}>
                  Special requests can be added after the item is placed in cart.
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div style={{
              padding: isMobile ? '12px' : '20px',
              borderTop: '2px solid #e5e7eb',
              position: 'sticky',
              bottom: 0,
              backgroundColor: 'white',
              borderBottomLeftRadius: '20px',
              borderBottomRightRadius: '20px'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: isMobile ? '10px' : '16px'
              }}>
                <span style={{ fontSize: '16px', color: '#6b7280' }}>
                  Total Price:
                </span>
                <span style={{
                  fontSize: isMobile ? '32px' : '22px',
                  fontWeight: '700',
                  color: currentTheme.primaryColor
                }}>
                  ₹{((currentProduct.discountPrice || currentProduct.price) +
                    selectedAddons.reduce((sum, addon) => sum + Number(addon.addonPrice || 0), 0)).toFixed(2)}
                </span>
              </div>

              {deliverySlabInsight && (
                <div style={{
                  marginBottom: isMobile ? '10px' : '14px',
                  padding: isMobile ? '10px 12px' : '12px 14px',
                  borderRadius: '14px',
                  background: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 6px 16px rgba(15, 23, 42, 0.08)'
                }}>
                  <div style={{
                    fontSize: isMobile ? '13px' : '14px',
                    fontWeight: '700',
                    color: '#0f172a',
                    lineHeight: 1.4
                  }}>
                    {deliverySlabInsight.message}
                  </div>
                  <div style={{
                    marginTop: '4px',
                    fontSize: '11px',
                    color: '#64748b',
                    fontWeight: '600'
                  }}>
                    Based on current delivery slabs
                  </div>
                </div>
              )}

              <div style={{ display: 'flex', gap: isMobile ? '10px' : '12px' }}>
                <button
                  onClick={closeAddonModal}
                  style={{
                    flex: 1,
                    padding: isMobile ? '12px' : '14px',
                    borderRadius: '12px',
                    border: '2px solid #e5e7eb',
                    backgroundColor: 'white',
                    color: '#6b7280',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    if (!validateGroupSelections()) return;
                    addToCartWithAddons(currentProduct, normalizedSelectedAddons);
                  }}
                  style={{
                    flex: 2,
                    padding: isMobile ? '12px' : '14px',
                    borderRadius: '12px',
                    border: 'none',
                    background: `linear-gradient(135deg, ${currentTheme.primaryColor}, ${currentTheme.secondaryColor})`,
                    color: 'white',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                  }}
                >
                  {editingCartItemId ? 'Update Cart' : 'Add to Cart'} {normalizedSelectedAddons.length > 0 && `(${normalizedSelectedAddons.length} selected)`}
                </button>
              </div>
            </div>
          </div>
        </div>
          )}

      {editingSpecialRequest.open && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 10003,
            backgroundColor: 'rgba(15, 23, 42, 0.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: isMobile ? '12px' : '20px'
          }}
          onClick={closeSpecialRequestEditor}
        >
          <div
            style={{
              width: '100%',
              maxWidth: '420px',
              borderRadius: '16px',
              background: currentTheme.isDark ? '#0f172a' : '#ffffff',
              border: `1px solid ${currentTheme.isDark ? 'rgba(148,163,184,0.25)' : '#e2e8f0'}`,
              boxShadow: '0 24px 60px rgba(2, 6, 23, 0.32)',
              padding: isMobile ? '18px 16px' : '22px'
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <h3 style={{
              margin: '0 0 8px 0',
              fontSize: '18px',
              fontWeight: '800',
              color: currentTheme.isDark ? '#f8fafc' : '#0f172a'
            }}>
              Special request
            </h3>
            <p style={{
              margin: '0 0 12px 0',
              fontSize: '13px',
              color: currentTheme.isDark ? '#cbd5e1' : '#475569'
            }}>
              Add a note for this item only.
            </p>

            <textarea
              value={editingSpecialRequest.text}
              onChange={(event) => setEditingSpecialRequest((prev) => ({
                ...prev,
                text: event.target.value.slice(0, 100)
              }))}
              rows={4}
              maxLength={100}
              placeholder="e.g. Less spicy, no onion"
              style={{
                width: '100%',
                boxSizing: 'border-box',
                borderRadius: '12px',
                border: '1px solid #d1d5db',
                padding: '12px 14px',
                fontSize: '14px',
                resize: 'vertical',
                background: currentTheme.isDark ? 'rgba(15,23,42,0.75)' : '#f8fafc',
                color: currentTheme.isDark ? '#f8fafc' : '#0f172a'
              }}
            />

            <div style={{ marginTop: '6px', textAlign: 'right', fontSize: '11px', color: '#94a3b8' }}>
              {editingSpecialRequest.text.length}/100
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '10px' }}>
              {quickInstructionChips.map((chip) => {
                const selectedInstructionSet = new Set(
                  String(editingSpecialRequest.text || '')
                    .split('|')
                    .map((token) => token.trim().toLowerCase())
                    .filter(Boolean)
                );
                const isSelected = selectedInstructionSet.has(chip.toLowerCase());
                return (
                  <button
                    key={chip}
                    type="button"
                    onClick={() => {
                      const currentTokens = String(editingSpecialRequest.text || '')
                        .split('|')
                        .map((token) => token.trim())
                        .filter(Boolean);
                      const alreadySelected = currentTokens.some((token) => token.toLowerCase() === chip.toLowerCase());
                      const nextTokens = alreadySelected
                        ? currentTokens.filter((token) => token.toLowerCase() !== chip.toLowerCase())
                        : [...currentTokens, chip];
                      setEditingSpecialRequest((prev) => ({
                        ...prev,
                        text: nextTokens.join(' | ').slice(0, 100)
                      }));
                    }}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '999px',
                      border: isSelected ? '2px solid #3b82f6' : '1px solid #d1d5db',
                      background: isSelected ? '#dbeafe' : '#fff',
                      color: isSelected ? '#1e40af' : '#374151',
                      fontSize: '12px',
                      fontWeight: isSelected ? '700' : '600',
                      cursor: 'pointer'
                    }}
                  >
                    {chip}
                  </button>
                );
              })}
            </div>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '16px' }}>
              <button
                type="button"
                onClick={closeSpecialRequestEditor}
                style={{
                  border: '1px solid #cbd5e1',
                  background: currentTheme.isDark ? 'rgba(15,23,42,0.6)' : '#f8fafc',
                  color: currentTheme.isDark ? '#e2e8f0' : '#334155',
                  borderRadius: '10px',
                  padding: '10px 16px',
                  fontSize: '14px',
                  fontWeight: '700',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={saveSpecialRequest}
                style={{
                  border: 'none',
                  background: `linear-gradient(135deg, ${currentTheme.primaryColor}, ${currentTheme.secondaryColor})`,
                  color: '#ffffff',
                  borderRadius: '10px',
                  padding: '10px 16px',
                  fontSize: '14px',
                  fontWeight: '800',
                  cursor: 'pointer'
                }}
              >
                Save request
              </button>
            </div>
          </div>
        </div>
      )}
      {/* 22+ Logistics Integrations Modal */}
      {showCouriersModal && (
        <div
          className="order-type-popup-overlay"
          onClick={() => setShowCouriersModal(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(15, 23, 42, 0.78)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10005,
            padding: isMobile ? '8px' : '20px'
          }}
        >
          <div
            className="order-type-popup-card"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              width: '100%',
              maxWidth: '860px',
              maxHeight: '90vh',
              borderRadius: isMobile ? '18px' : '24px',
              background: currentTheme.isDark ? '#0f172a' : '#ffffff',
              color: currentTheme.isDark ? '#f8fafc' : '#0f172a',
              border: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'}`,
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              padding: 0
            }}
          >
            {/* Modal Header */}
            <div style={{
              padding: isMobile ? '16px 16px 12px' : '20px 24px 14px',
              borderBottom: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.08)' : '#f1f5f9'}`,
              position: 'relative',
              background: currentTheme.isDark ? 'rgba(30, 41, 59, 0.5)' : '#f8fafc'
            }}>
              <button
                type="button"
                onClick={() => setShowCouriersModal(false)}
                style={{
                  position: 'absolute',
                  top: isMobile ? '14px' : '18px',
                  right: isMobile ? '14px' : '20px',
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: 'none',
                  background: currentTheme.isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.06)',
                  color: currentTheme.isDark ? '#cbd5e1' : '#64748b',
                  fontSize: '15px',
                  fontWeight: 800,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s'
                }}
              >
                ✕
              </button>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                <span style={{ fontSize: '22px' }}>🚀</span>
                <h2 style={{
                  margin: 0,
                  fontSize: isMobile ? '17px' : '21px',
                  fontWeight: 900,
                  letterSpacing: '-0.02em',
                  color: currentTheme.isDark ? '#f8fafc' : '#0f172a'
                }}>
                  Integrated Courier & Logistics Partners
                </h2>
              </div>
              <p style={{
                margin: 0,
                fontSize: isMobile ? '12px' : '13px',
                color: currentTheme.isDark ? '#94a3b8' : '#64748b',
                lineHeight: '1.4',
                maxWidth: '90%'
              }}>
                Having just one option isn't an option — Delivering to <strong>20,000+ pin codes</strong> in India across 22+ leading logistics & express delivery networks.
              </p>

              {/* Search and Filter Row */}
              <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <div style={{ position: 'relative', width: '100%' }}>
                  <input
                    type="text"
                    value={courierSearchTerm}
                    onChange={(e) => setCourierSearchTerm(e.target.value)}
                    placeholder="Search courier by name, pin codes, speed (e.g. Delhivery, 27000, Same day)..."
                    style={{
                      width: '100%',
                      padding: '8px 36px 8px 12px',
                      borderRadius: '10px',
                      border: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.15)' : '#cbd5e1'}`,
                      background: currentTheme.isDark ? 'rgba(15, 23, 42, 0.8)' : '#ffffff',
                      color: currentTheme.isDark ? '#f8fafc' : '#0f172a',
                      fontSize: '13px',
                      outline: 'none',
                      boxSizing: 'border-box'
                    }}
                  />
                  {courierSearchTerm && (
                    <button
                      type="button"
                      onClick={() => setCourierSearchTerm('')}
                      style={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        color: currentTheme.isDark ? '#94a3b8' : '#64748b',
                        cursor: 'pointer',
                        fontSize: '12px',
                        padding: '4px'
                      }}
                    >
                      ✕
                    </button>
                  )}
                </div>

                {/* Category Pills */}
                <div style={{
                  display: 'flex',
                  gap: '6px',
                  overflowX: 'auto',
                  paddingBottom: '2px',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none'
                }}>
                  {['All', 'Air & Surface', 'Pan-India Express', 'Hyperlocal', 'International', 'Reverse Logistics'].map((cat) => {
                    const isSelected = courierFilterCategory === cat;
                    return (
                      <button
                        key={cat}
                        type="button"
                        onClick={() => setCourierFilterCategory(cat)}
                        style={{
                          padding: '4px 10px',
                          borderRadius: '999px',
                          border: isSelected ? `1.5px solid ${currentTheme.primaryColor}` : `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.12)' : '#e2e8f0'}`,
                          background: isSelected
                            ? (currentTheme.isDark ? `${currentTheme.primaryColor}30` : `${currentTheme.primaryColor}15`)
                            : (currentTheme.isDark ? 'rgba(255,255,255,0.05)' : '#ffffff'),
                          color: isSelected ? currentTheme.primaryColor : (currentTheme.isDark ? '#cbd5e1' : '#64748b'),
                          fontSize: '11px',
                          fontWeight: isSelected ? 800 : 600,
                          cursor: 'pointer',
                          whiteSpace: 'nowrap',
                          transition: 'all 0.15s ease'
                        }}
                      >
                        {cat}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Modal Body - Scrollable Partner Cards */}
            <div style={{
              flex: 1,
              overflowY: 'auto',
              padding: isMobile ? '12px' : '16px 20px',
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(360px, 1fr))',
              gap: '12px',
              alignContent: 'start',
              scrollbarWidth: 'thin'
            }}>
              {(() => {
                const filtered = COURIER_PARTNERS_DATA.filter((item) => {
                  const matchesCategory =
                    courierFilterCategory === 'All' ||
                    item.category === courierFilterCategory ||
                    (courierFilterCategory === 'Hyperlocal' && item.category.includes('Hyperlocal'));
                  const q = courierSearchTerm.trim().toLowerCase();
                  if (!q) return matchesCategory;
                  const matchesSearch =
                    item.name.toLowerCase().includes(q) ||
                    item.tagline.toLowerCase().includes(q) ||
                    item.description.toLowerCase().includes(q) ||
                    item.serviceability.toLowerCase().includes(q) ||
                    item.speed.toLowerCase().includes(q) ||
                    item.category.toLowerCase().includes(q);
                  return matchesCategory && matchesSearch;
                });

                if (filtered.length === 0) {
                  return (
                    <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '36px 16px' }}>
                      <p style={{ fontSize: '28px', margin: '0 0 8px' }}>🔍</p>
                      <h4 style={{ margin: '0 0 4px', fontSize: '15px', color: currentTheme.isDark ? '#e2e8f0' : '#334155' }}>
                        No courier partner found
                      </h4>
                      <p style={{ margin: 0, fontSize: '12px', color: currentTheme.isDark ? '#94a3b8' : '#64748b' }}>
                        Try searching with another keyword or select "All".
                      </p>
                    </div>
                  );
                }

                return filtered.map((courier) => (
                  <div
                    key={courier.id}
                    style={{
                      borderRadius: '14px',
                      border: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.1)' : '#e2e8f0'}`,
                      background: currentTheme.isDark ? 'rgba(30, 41, 59, 0.65)' : '#ffffff',
                      padding: '12px 14px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                      borderLeft: `4px solid ${courier.color}`,
                      transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                    }}
                  >
                    {/* Card Top Row */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <span
                          style={{
                            background: courier.color,
                            color: '#ffffff',
                            padding: '3px 9px',
                            borderRadius: '6px',
                            fontSize: '11px',
                            fontWeight: 900,
                            letterSpacing: '0.02em',
                            display: 'inline-block'
                          }}
                        >
                          {courier.logoIcon}
                        </span>
                        <h3 style={{
                          margin: 0,
                          fontSize: '14px',
                          fontWeight: 800,
                          color: currentTheme.isDark ? '#f8fafc' : '#0f172a'
                        }}>
                          {courier.name}
                        </h3>
                      </div>
                      <span style={{
                        fontSize: '10px',
                        fontWeight: 700,
                        padding: '2px 7px',
                        borderRadius: '999px',
                        background: currentTheme.isDark ? 'rgba(255,255,255,0.08)' : '#f1f5f9',
                        color: currentTheme.isDark ? '#cbd5e1' : '#64748b',
                        whiteSpace: 'nowrap'
                      }}>
                        {courier.category}
                      </span>
                    </div>

                    {/* Tagline & Description */}
                    <div>
                      <p style={{
                        margin: '0 0 3px',
                        fontSize: '11px',
                        fontWeight: 700,
                        color: currentTheme.primaryColor
                      }}>
                        {courier.tagline}
                      </p>
                      <p style={{
                        margin: 0,
                        fontSize: '11.5px',
                        lineHeight: 1.4,
                        color: currentTheme.isDark ? '#94a3b8' : '#475569'
                      }}>
                        {courier.description}
                      </p>
                    </div>

                    {/* Metrics Grid */}
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: '5px',
                      paddingTop: '6px',
                      borderTop: `1px dashed ${currentTheme.isDark ? 'rgba(255,255,255,0.08)' : '#e2e8f0'}`,
                      fontSize: '11px'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ color: '#3b82f6' }}>📍</span>
                        <span style={{ color: currentTheme.isDark ? '#cbd5e1' : '#64748b' }}>Coverage:</span>
                        <strong style={{ color: currentTheme.isDark ? '#f8fafc' : '#0f172a' }}>{courier.serviceability}</strong>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ color: '#10b981' }}>⚡</span>
                        <span style={{ color: currentTheme.isDark ? '#cbd5e1' : '#64748b' }}>Speed:</span>
                        <strong style={{ color: currentTheme.isDark ? '#f8fafc' : '#0f172a' }}>{courier.speed}</strong>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ color: '#eab308' }}>💵</span>
                        <span style={{ color: currentTheme.isDark ? '#cbd5e1' : '#64748b' }}>COD:</span>
                        <strong style={{ color: courier.cod === 'Yes' ? '#16a34a' : '#dc2626' }}>{courier.cod}</strong>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ color: '#8b5cf6' }}>🔍</span>
                        <span style={{ color: currentTheme.isDark ? '#cbd5e1' : '#64748b' }}>Tracking:</span>
                        <strong style={{ color: '#16a34a' }}>{courier.tracking}</strong>
                      </div>
                    </div>
                  </div>
                ));
              })()}
            </div>

            {/* Modal Footer */}
            <div style={{
              padding: isMobile ? '10px 14px' : '12px 20px',
              borderTop: `1px solid ${currentTheme.isDark ? 'rgba(255,255,255,0.08)' : '#f1f5f9'}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: currentTheme.isDark ? 'rgba(30, 41, 59, 0.5)' : '#f8fafc',
              fontSize: '12px'
            }}>
              <span style={{ color: currentTheme.isDark ? '#94a3b8' : '#64748b', fontWeight: 600 }}>
                ⚡ Auto-routed for fastest delivery & lowest RTO
              </span>
              <button
                type="button"
                onClick={() => setShowCouriersModal(false)}
                style={{
                  border: 'none',
                  background: `linear-gradient(135deg, ${currentTheme.primaryColor}, ${currentTheme.secondaryColor})`,
                  color: '#ffffff',
                  borderRadius: '8px',
                  padding: '7px 18px',
                  fontSize: '12px',
                  fontWeight: 800,
                  cursor: 'pointer'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
        </>
      )}
    </>
  );
};

export default TemplatedMenuPage;
